webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/mLAhLQ/%3F1742011080414&title=The%20Books%20of%20Numbers%2C%20New%20International%20Commentary%20on%20the%20Old%20Testament%20%28NICOT%29&summary=The%20%20book%20of%20Numbers%20tells%20a%20story%20that%20has%20%20two%20main%20characters%20--%20God%20and%20Israel.%20%20The%20way%20the%20story%20is%20told%20sounds%20odd%20and%20%20often%20harsh%20to%20readers%20today.%20In%20spite%20%20of%20the%20difficulties%20imposed%20by%20Numbers%20%20on%20today%27s%20readers%2C%20the%20main%20point%20of%20%20the%20book%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/mLAhLQ/%3F1742011080414",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20%20book%20of%20Numbers%20tells%20a%20story%20that%20has%20%20two%20main%20characters%20--%20God%20and%20Israel.%20%20The%20way%20the%20story%20is%20told%20sounds%20odd%20and%20%20often%20harsh%20to%20re%0Dhttps://textcafe.co/books/mLAhLQ/%3F1742011080414&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/mLAhLQ/%3F1742011080414&posttype=link&caption=The%20%20book%20of%20Numbers%20tells%20a%20story%20that%20has%20%20two%20main%20characters%20--%20God%20and%20Israel.%20%20The%20way%20the%20story%20is%20told%20sounds%20odd%20and%20%20often%20harsh%20to%20readers%20today.%20In%20spite%20%20of%20the%20difficulties%20imposed%20by%20Numbers%20%20on%20today%27s%20readers%2C%20the%20main%20point%20of%20%20the%20book%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/mLAhLQ/%3F1742011080414&description=The%20%20book%20of%20Numbers%20tells%20a%20story%20that%20has%20%20two%20main%20characters%20--%20God%20and%20Israel.%20%20The%20way%20the%20story%20is%20told%20sounds%20odd%20and%20%20often%20harsh%20to%20readers%20today.%20In%20spite%20%20of%20the%20difficulties%20imposed%20by%20Numbers%20%20on%20today%27s%20readers%2C%20the%20main%20point%20of%20%20the%20book%20&media=https://textcafe.co/books/mLAhLQ/tc-custom/9781467422932.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/dp/B08WK6LV7Y?tag=mobilebookcom-20&ref=nosim',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=0GNyCgAAQBAJ&amp;rdid=book-0GNyCgAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }, {
        title: 'Kobo',
        img: 'https://textcafe.co/global-css/img/kobo_appicon.svg',
        url: 'https://www.kobo.com/us/en/search?Query=9781467422932',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467422932').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/mLAhLQ/tc-custom/9781467422932.jpg?1742011080414',
        alt: 'The Books of Numbers, New International Commentary on the Old Testament (NICOT)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "eer-nicot04nu-0001", "eer-nicot04nu-0002", "eer-nicot04nu-0003", "eer-nicot04nu-0004", "eer-nicot04nu-0005", "eer-nicot04nu-0006", "eer-nicot04nu-0007", "eer-nicot04nu-0008", "eer-nicot04nu-0009", "eer-nicot04nu-0010", "eer-nicot04nu-0011", "eer-nicot04nu-0012", "eer-nicot04nu-0013", "eer-nicot04nu-0014", "eer-nicot04nu-0015", "eer-nicot04nu-0016", "eer-nicot04nu-0017", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/mLAhLQ/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_eer_nicot04nu_0001__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_eer_nicot04nu_0001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_eer_nicot04nu_0001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eer_nicot04nu_0002__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_eer_nicot04nu_0002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_eer_nicot04nu_0002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_eer_nicot04nu_0003__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_eer_nicot04nu_0003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_eer_nicot04nu_0003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eer_nicot04nu_0004__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_eer_nicot04nu_0004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_eer_nicot04nu_0004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eer_nicot04nu_0005__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_eer_nicot04nu_0005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_eer_nicot04nu_0005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eer_nicot04nu_0006__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_eer_nicot04nu_0006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_eer_nicot04nu_0006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eer_nicot04nu_0007__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_eer_nicot04nu_0007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_eer_nicot04nu_0007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eer_nicot04nu_0008__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_eer_nicot04nu_0008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_eer_nicot04nu_0008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eer_nicot04nu_0009__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_eer_nicot04nu_0009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_eer_nicot04nu_0009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eer_nicot04nu_0010__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_eer_nicot04nu_0010___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_eer_nicot04nu_0010__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eer_nicot04nu_0011__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_eer_nicot04nu_0011___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_eer_nicot04nu_0011__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eer_nicot04nu_0012__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_eer_nicot04nu_0012___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_eer_nicot04nu_0012__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_eer_nicot04nu_0013__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_eer_nicot04nu_0013___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_eer_nicot04nu_0013__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_eer_nicot04nu_0014__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_eer_nicot04nu_0014___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_eer_nicot04nu_0014__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_eer_nicot04nu_0015__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_eer_nicot04nu_0015___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_eer_nicot04nu_0015__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_eer_nicot04nu_0016__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_eer_nicot04nu_0016___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_eer_nicot04nu_0016__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_eer_nicot04nu_0017__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_eer_nicot04nu_0017___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_eer_nicot04nu_0017__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_eer_nicot04nu_0018__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_eer_nicot04nu_0018___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_eer_nicot04nu_0018__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_eer_nicot04nu_0019__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_eer_nicot04nu_0019___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_eer_nicot04nu_0019__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_eer_nicot04nu_0020__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_eer_nicot04nu_0020___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_eer_nicot04nu_0020__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_eer_nicot04nu_0021__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_eer_nicot04nu_0021___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_eer_nicot04nu_0021__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_eer_nicot04nu_0022__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_eer_nicot04nu_0022___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_eer_nicot04nu_0022__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_eer_nicot04nu_0023__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_eer_nicot04nu_0023___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_eer_nicot04nu_0023__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_eer_nicot04nu_0024__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_eer_nicot04nu_0024___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_eer_nicot04nu_0024__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_eer_nicot04nu_0025__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_eer_nicot04nu_0025___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_eer_nicot04nu_0025__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_eer_nicot04nu_0026__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_eer_nicot04nu_0026___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_eer_nicot04nu_0026__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_eer_nicot04nu_0027__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_eer_nicot04nu_0027___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_eer_nicot04nu_0027__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_eer_nicot04nu_0028__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_eer_nicot04nu_0028___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_eer_nicot04nu_0028__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_eer_nicot04nu_0029__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_eer_nicot04nu_0029___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_eer_nicot04nu_0029__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_eer_nicot04nu_0030__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_eer_nicot04nu_0030___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_eer_nicot04nu_0030__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_eer_nicot04nu_0031__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_eer_nicot04nu_0031___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_eer_nicot04nu_0031__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_eer_nicot04nu_0032__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_eer_nicot04nu_0032___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_eer_nicot04nu_0032__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_eer_nicot04nu_0033__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_eer_nicot04nu_0033___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_eer_nicot04nu_0033__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_last__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_last__);
/*jshint esversion: 6 */








































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/eer-nicot04nu-0001",
    "name": "eer-nicot04nu-0001",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_eer_nicot04nu_0001___default.a
  }, {
    "path": "/eer-nicot04nu-0002",
    "name": "eer-nicot04nu-0002",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_eer_nicot04nu_0002___default.a
  }, {
    "path": "/eer-nicot04nu-0003",
    "name": "eer-nicot04nu-0003",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_eer_nicot04nu_0003___default.a
  }, {
    "path": "/eer-nicot04nu-0004",
    "name": "eer-nicot04nu-0004",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_eer_nicot04nu_0004___default.a
  }, {
    "path": "/eer-nicot04nu-0005",
    "name": "eer-nicot04nu-0005",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_eer_nicot04nu_0005___default.a
  }, {
    "path": "/eer-nicot04nu-0006",
    "name": "eer-nicot04nu-0006",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_eer_nicot04nu_0006___default.a
  }, {
    "path": "/eer-nicot04nu-0007",
    "name": "eer-nicot04nu-0007",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_eer_nicot04nu_0007___default.a
  }, {
    "path": "/eer-nicot04nu-0008",
    "name": "eer-nicot04nu-0008",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_eer_nicot04nu_0008___default.a
  }, {
    "path": "/eer-nicot04nu-0009",
    "name": "eer-nicot04nu-0009",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_eer_nicot04nu_0009___default.a
  }, {
    "path": "/eer-nicot04nu-0010",
    "name": "eer-nicot04nu-0010",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_eer_nicot04nu_0010___default.a
  }, {
    "path": "/eer-nicot04nu-0011",
    "name": "eer-nicot04nu-0011",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_eer_nicot04nu_0011___default.a
  }, {
    "path": "/eer-nicot04nu-0012",
    "name": "eer-nicot04nu-0012",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_eer_nicot04nu_0012___default.a
  }, {
    "path": "/eer-nicot04nu-0013",
    "name": "eer-nicot04nu-0013",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_eer_nicot04nu_0013___default.a
  }, {
    "path": "/eer-nicot04nu-0014",
    "name": "eer-nicot04nu-0014",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_eer_nicot04nu_0014___default.a
  }, {
    "path": "/eer-nicot04nu-0015",
    "name": "eer-nicot04nu-0015",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_eer_nicot04nu_0015___default.a
  }, {
    "path": "/eer-nicot04nu-0016",
    "name": "eer-nicot04nu-0016",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_eer_nicot04nu_0016___default.a
  }, {
    "path": "/eer-nicot04nu-0017",
    "name": "eer-nicot04nu-0017",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_eer_nicot04nu_0017___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_37__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mLAhLQ/tc-custom/9781467422932.jpg?1742011080414",
      "alt": "This image is the cover for the book The Books of Numbers, New International Commentary on the Old Testament (NICOT)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Books of Numbers, New International Commentary on the Old Testament (NICOT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The  book of Numbers tells a story that has  two main characters -- God and Israel.  The way the story is told sounds odd and  often harsh to readers today. In spite  of the difficulties imposed by Numbers  on today's readers, the main point of  the book is of immense importance for  God's people in any age: exact obedience  to God is crucial."), _c('br'), _c('br'), _vm._v("This  comprehensive and erudite commentary --  resulting from nearly a decade of study  of Numbers by Timothy Ashley -- presents  a thorough explication of this  significant Hebrew text. Ashley's  introduction to Numbers discusses such  questions as structure, authorship, and  theological themes, and it features an  extended bibliography of major works on  the book of Numbers, concentrating  mainly on works in English, French, and  German."), _c('br'), _c('br'), _vm._v("Dividing the text of  Numbers into five major sections,  Ashley's commentary elucidates the  theological themes of obedience and  disobedience that run throughout the  book's narrative. His detailed  verse-by-verse comments are intended  primarily to explain the Hebrew text of  Numbers as we have it rather than to  speculate on how the book came to be in  its present form.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Timothy R. Ashley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Timothy R. Ashley is minister of First Baptist Church in La Crosse, Wisconsin. He previously served for more than twenty years as professor of biblical studies at Acadia Divinity College in Wolfville, Nova Scotia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cvi"
    }
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "750",
      "src": "images/eer-nicot04nu-cover.jpg",
      "width": "506"
    }
  })])])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "bk"
    }
  }, [_c('p', {
    staticClass: "bk"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.i"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.ii"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iii"
    }
  }), _vm._v("The Book of")]), _vm._v(" "), _c('p', {
    staticClass: "bk1"
  }, [_vm._v("NUMBERS")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_vm._v("Timothy R. Ashley")]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_vm._v("W"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ILLIAM")]), _vm._v(" B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" E"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ERDMANS")]), _vm._v(" P"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UBLISHING")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OMPANY")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_vm._v("G"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RAND")]), _vm._v(" R"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("APIDS,")]), _vm._v(" M"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ICHIGAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v(" C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AMBRIDGE,")]), _vm._v(" U"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("K"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")])])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iv"
    }
  }), _vm._v("Copyright © 1993 by Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data:")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf1"
  }, [_vm._v("Ashley, Timothy R. 1947–")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("The book of Numbers / by Timothy R. Ashley")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("p. cm. — (The New international commentary on the Old Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0015#FRONT.VII"
    }
  }, [_vm._v("bibliographical references")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0031#INDEX1"
    }
  }, [_vm._v("indexes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("eISBN 978-1-4674-2293-2")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 0-8028-2523-0")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Bible. O.T. Numbers—Commentaries.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("I. Title. II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("BS1265.3.A845 1992")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("222′.14077 — dc20 93-7095")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("CIP")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.v"
    }
  }), _vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("David H. Wallace")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("the Memory of")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Robert B. Laurin (1927–77)")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Christian Gentlemen")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and Scholars, Both")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.vi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rPREFACE"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0006#PREFACE"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rABBREVS"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBREVS"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rINTRO"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0008#INTRO"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.I"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0009#FRONT.I"
    }
  }, [_vm._v("I. Title and Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.II"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0010#FRONT.II"
    }
  }, [_vm._v("II. Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.III"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0011#FRONT.III"
    }
  }, [_vm._v("III. Authorship and Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.IV"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0012#FRONT.IV"
    }
  }, [_vm._v("IV. Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.V"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0013#FRONT.V"
    }
  }, [_vm._v("V. Text and Versions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.VI"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0014#FRONT.VI"
    }
  }, [_vm._v("VI. Analysis of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rFRONT.VII"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0015#FRONT.VII"
    }
  }, [_vm._v("VII. Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rTEXT"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0016#TEXT"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rNUM.I"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I"
    }
  }, [_vm._v("I. Preparation for Departure (1:1–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.I.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A"
    }
  }, [_vm._v("A. Matters Concerning the People and the Camp (1:1–6:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.A.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1"
    }
  }, [_vm._v("1. The Censuses and the Arrangements of the March (1:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.A.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2"
    }
  }, [_vm._v("2. Various Legal Enactments (5:1–6:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.I.B"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B"
    }
  }, [_vm._v("B. Various Matters Concerning the Tabernacle (7:1–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.1"
    }
  }, [_vm._v("1. Offerings by Tribal Leaders (7:1–89)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.2"
    }
  }, [_vm._v("2. Lamps in the Tabernacle (8:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.3"
    }
  }, [_vm._v("3. Consecration of Levites (8:5–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.4"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.4"
    }
  }, [_vm._v("4. The Levites’ Work (8:23–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.5"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.5"
    }
  }, [_vm._v("5. Supplement to the Passover Law (9:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.I.B.6"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6"
    }
  }, [_vm._v("6. Preparations to Depart (9:15–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rNUM.II"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II"
    }
  }, [_vm._v("II. The Journey from Mt. Sinai to Kadesh-Barnea (10:11–12:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.II.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.A"
    }
  }, [_vm._v("A. Departure from Mt. Sinai (10:11–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.II.B"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B"
    }
  }, [_vm._v("B. Crises of Authority Along the Way (11:1–12:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.II.B.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.1"
    }
  }, [_vm._v("1. At Taberah (11:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.II.B.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.2"
    }
  }, [_vm._v("2. At Kibroth-Hattaavah (11:4–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.II.B.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.3"
    }
  }, [_vm._v("3. At Hazeroth (12:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rNUM.III"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III"
    }
  }, [_vm._v("III. In and around Kadesh-Barnea (13:1–19:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.III.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A"
    }
  }, [_vm._v("A. The Spies (13:1–14:45)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.A.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.1"
    }
  }, [_vm._v("1. Spies are Selected (13:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.A.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.2"
    }
  }, [_vm._v("2. Spies Go and Return (13:17–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.A.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3"
    }
  }, [_vm._v("3. Responses to the Spies’ Reports (14:1–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.III.B"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B"
    }
  }, [_vm._v("B. Cultic Legislation (15:1–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.B.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.1"
    }
  }, [_vm._v("1. Supplementary Laws of the Offerings (15:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.B.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.2"
    }
  }, [_vm._v("2. First of the Dough (15:17–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.B.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.3"
    }
  }, [_vm._v("3. Purification Offering (15:22–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.B.4"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.4"
    }
  }, [_vm._v("4. Case Law on Capital Punishment for Sabbath Violation (15:32–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.B.5"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.5"
    }
  }, [_vm._v("5. Tassels on Garments for Remembrance (15:37–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.III.C"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C"
    }
  }, [_vm._v("C. Legitimation of Aaron’s Priesthood (16:1–17:28 [Eng. 13])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.C.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.1"
    }
  }, [_vm._v("1. Rebellions of Korah, Dathan, and Abiram (16:1–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.C.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.2"
    }
  }, [_vm._v("2. Aftermath of Rebellions (17:1–15 [Eng. 16:36–50])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.C.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.3"
    }
  }, [_vm._v("3. Aaron’s Budding Rod (17:16–28 [Eng. 1–13])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.III.D"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D"
    }
  }, [_vm._v("D. Further Cultic Legislation (18:1–19:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.D.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1"
    }
  }, [_vm._v("1. Redefined Role for Priests and Levites (18:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.III.D.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2"
    }
  }, [_vm._v("2. The Red Cow (19:1–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rNUM.IV"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV"
    }
  }, [_vm._v("IV. The Journey from Kadesh-Barnea to the Plains of Moab (20:1–22:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.A"
    }
  }, [_vm._v("A. Death of Miriam and Disaster at Meribah (20:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.B"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.B"
    }
  }, [_vm._v("B. Request to Pass through Edom (20:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.C"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.C"
    }
  }, [_vm._v("C. Death of Aaron (20:22–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.D"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.D"
    }
  }, [_vm._v("D. Second Battle of Hormah (21:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.E"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.E"
    }
  }, [_vm._v("E. Fiery Serpents (21:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.F"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.F"
    }
  }, [_vm._v("F. Travel Itinerary (21:10–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.IV.G"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.G"
    }
  }, [_vm._v("G. Wars against Sihon and Og (21:21–22:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rNUM.V"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V"
    }
  }, [_vm._v("V. On the Plains of Moab (22:2–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A"
    }
  }, [_vm._v("A. Story of Balaam (22:2–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.A.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1"
    }
  }, [_vm._v("1. Encounter between Balak and Balaam (22:2–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.A.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2"
    }
  }, [_vm._v("2. First and Second Oracles (22:41–23:30)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.A.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3"
    }
  }, [_vm._v("3. Third, Fourth, and Final Oracles (23:27–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.B"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.B"
    }
  }, [_vm._v("B. Incident of Baal-Peor (25:1–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.C"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.C"
    }
  }, [_vm._v("C. The Second Census (25:19–26:65)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.D"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.D"
    }
  }, [_vm._v("D. Daughters of Zelophehad (27:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.E"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.E"
    }
  }, [_vm._v("E. Joshua Named as Moses’ Successor (27:12–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.F"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F"
    }
  }, [_vm._v("F. Further Legislation (28:1–30:17 [Eng. 16])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.F.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.1"
    }
  }, [_vm._v("1. Cultic Calendar (28:1–30:1 [Eng. 29:40])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.F.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.2"
    }
  }, [_vm._v("2. Women’s Vows (30:2–17 [Eng. 1–16])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.G"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.G"
    }
  }, [_vm._v("G. War with Midian (31:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.H"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.H"
    }
  }, [_vm._v("H. Transjordanian Inheritance (32:1–42)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.I"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.I"
    }
  }, [_vm._v("I. Travel Itinerary (33:1–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rNUM.V.J"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J"
    }
  }, [_vm._v("J. Regulations for Living in Canaan (33:50–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.1"
    }
  }, [_vm._v("1. Introduction: Canaanites Must Be Expelled (33:50–56)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.2"
    }
  }, [_vm._v("2. Borders of the Land (34:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.3"
    }
  }, [_vm._v("3. Leaders to Draw Israel’s Borders (34:16–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.4"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.4"
    }
  }, [_vm._v("4. Cities of the Levites (35:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.5"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.5"
    }
  }, [_vm._v("5. Cities of Refuge (35:9–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    attrs: {
      "id": "rNUM.V.J.6"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.6"
    }
  }, [_vm._v("6. Additional Legislation for Daughters of Zelophehad (36:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rnotes"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0026#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.viii"
    }
  }), _vm._v("INDEXES")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rINDEX1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0031#INDEX1"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rINDEX2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0032#INDEX2"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rINDEX3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0033#INDEX3"
    }
  }, [_vm._v("Index of Scripture References")])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "PREFACE"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.ix"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rPREFACE"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The book of Numbers will never replace the Psalms at the heart of Christian devotion nor the Gospel of John and the Epistle to the Romans at the heart of Christian theology, nor should it. The book of Numbers tells a story. The story has two main characters, God and Israel. The way the story is told sounds odd and often times harsh to modern ears. For example, I suspect that the opening four chapters with all their names and numbers have defeated many folk who have decided to read through the whole Bible and have just emerged from the rigours of Leviticus. I suspect, as well, that the brutal nature of such passages as the end of the Korah story (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v("), the story of Phinehas (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v("), and the war with Midian (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")]), _vm._v(") are repellent to many.")]), _vm._v(" "), _c('p', [_vm._v("In spite of all these difficulties, and others, that confront modern readers, the point of the book of Numbers is important for God’s people in any age: Exact obedience to God is crucial. Numbers makes the point most especially through examples of "), _c('i', [_vm._v("dis")]), _vm._v("obedience such as those found in chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–21")]), _vm._v(". Although it is clear that God punishes disobedience, at the heart of the book of Numbers is the God who, while demanding exact obedience, is constantly revealing ways in which Israel can render that obedience through new torah (i.e., teaching; see chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–9")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("15")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–19")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27–30")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("32–36")]), _vm._v("). It is notable that the invitations to new obedience often come right in the midst of Israel’s failure and rebellion. Israel thought that the story of its disobedience and failure was important enough to tell. By claiming the Bible (including Numbers) as our standard of faith and conduct, Christians have implicitly said that the story of Numbers is worth "), _c('i', [_vm._v("re-")]), _vm._v("telling. It is important that God’s people re-learn the fact that their rebellion will still lead to “death in the wilderness.” Numbers is the story of a people who did what they ought to have known better than doing and suffered for it (see also Paul’s lament in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Rom. 7:15")]), _vm._v("). The failure of others may be salutary for us all.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.x"
    }
  }), _vm._v("The book of Numbers has been my companion now for the better part of a decade. It has been a comfort, a judgment, a joy, and a frustration all at the same time. Through the years many resources have come across my desk. Never far away has been George Buchanan Gray’s great commentary. Although it is now nearly 70 years old and, in many respects, out-of-date, Gray’s grasp of Hebrew philology is indispensable. He is still “the” commentator on Numbers with whom one agrees or disagrees. If I have done a considerable amount of the latter, it is no sign of disrespect. Quite the contrary, it is a mark of Gray’s erudition that long after his death his work should still be used. The commentary by Philip Budd in the Word Biblical Commentary has also been indispensable because of its discussions of the (supposed) redactional history of the various sections of the book. These discussions really form a summary of most critical work on the book from the middle of the last century to the early 1980s. The reader of the present work will note how little these redactional histories are discussed here. The reason is not that such matters are unimportant, but that I am quite sure that no one knows these things nor really can know them. I am, therefore, committed to explaining the final form of the text as the primary job of a commentary for the Church. No one knows better than I do now how difficult it is to explain the text. The reader is directed to Budd if she/he wishes to read on these critical matters as a primary concern. The many articles and, in the last stages of this work, the commentary by Jacob Milgrom have also been of assistance to me in matters of research on the sacrificial system and much more.")]), _vm._v(" "), _c('p', [_vm._v("The manuscript of this commentary was submitted to the publishers in August 1990. During a delay in publication due to editorial changes at least three major commentaries on Numbers have appeared. Milgrom’s (in the Jewish Publication Society Torah [1990]), R. K. Harrison’s (in the Wycliffe Exegetical Commentary [1990]), and R. B. Allen’s (in the Expositor’s Bible Commentary, vol. 2 [also 1990]). I have only been able to use these works in the proof-reading stage, and, so, in a less thorough way than they deserve. In the case of Milgrom, this problem is partially offset by the many articles of his that have been available.")]), _vm._v(" "), _c('p', [_vm._v("Only those who have tried to write commentaries know the difficulties involved. Commentaries are never wholly satisfactory documents (this one is certainly no different). I would thank my colleagues and students at Acadia Divinity College and Acadia University for their understanding. Craig and Jacqueline Hiebert deserve thanks for compiling the indexes. Special thanks goes to the Principal of the Divinity College, the Rev. Dr. Andrew D. MacRae, for his willingness to release me from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xi"
    }
  }), _vm._v("some teaching and administrative duties in the interests of research and writing. Last of all, I thank my wife and colleague in ministry, the Rev. Maxine F. Ashley, for encouragement in untold ways while enduring the long hours of my preoccupation with the book of Numbers. These contributions and many others make her help the most precious of all.")]), _vm._v(" "), _c('p', [_vm._v("It is hoped, however, that, with its weaknesses, the commentary will be of some use to those who wish better to hear and re-tell the story of exact obedience in the book of Numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("TIMOTHY R. ASHLEY")]), _vm._v(" "), _c('p', {
    staticClass: "patr1"
  }, [_vm._v("Wolfville, Nova Scotia")]), _vm._v(" "), _c('p', {
    staticClass: "patr1"
  }, [_vm._v("August 1992")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ABBREVS"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rABBREVS"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.66"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AASOR")]), _vm._v(" "), _c('i', [_vm._v("Annual of the American Schools of Oriental Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.111"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AB")]), _vm._v(" Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.55"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ADAJ")]), _vm._v(" "), _c('i', [_vm._v("Annual of the Department of Antiquities of Jordan")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.49"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AfO")]), _vm._v(" "), _c('i', [_vm._v("Archiv für Orientforschung")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.65"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AJSL")]), _vm._v(" "), _c('i', [_vm._v("American Journal of Semitic Languages and Literatures")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.29"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AJT")]), _vm._v(" "), _c('i', [_vm._v("American Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.97"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Akk.")]), _vm._v(" Akkadian")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.38"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AnBib")]), _vm._v(" Analecta Biblica")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.118"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ANET")]), _vm._v(" J. B. Pritchard, ed., "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". 3rd ed. Princeton: Princeton Univ. Press, 1969")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.13"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AOAT")]), _vm._v(" Alter Orient und Altes Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.98"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Arab.")]), _vm._v(" Arabic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.6"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Aram.")]), _vm._v(" Aramaic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.94"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Assyr.")]), _vm._v(" Assyrian")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.69"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ASTI")]), _vm._v(" "), _c('i', [_vm._v("Annual of the Swedish Theological Institute")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.54"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ATDA")]), _vm._v(" J. Hoftijzer and G. van der Kooij, eds., "), _c('i', [_vm._v("Aramaic Texts from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(". Leiden: Brill, 1976")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.57"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("AusBR")]), _vm._v(" "), _c('i', [_vm._v("Australian Biblical Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.89"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("AV")]), _vm._v(" Authorized (King James) Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.14"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BA")]), _vm._v(" "), _c('i', [_vm._v("Biblical Archaeologist")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.42"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BASOR")]), _vm._v(" "), _c('i', [_vm._v("Bulletin of the American Schools of Oriental Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.100"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BDB")]), _vm._v(" F. Brown, S. R. Driver, and C. A. Briggs, "), _c('i', [_vm._v("Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Repr. Oxford: Clarendon, 1959")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.131"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BHK")]), _vm._v(" R. Kittel, et al., eds. "), _c('i', [_vm._v("Biblia Hebraica")]), _vm._v(". Stuttgart: Württembergische Bibelanstalt, 1937")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.4"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BHS")]), _vm._v(" K. Elliger and W. Rudolph, eds., "), _c('i', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Stuttgart: Deutsche Bibelstiftung, 1967–77")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.74"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Bib")]), _vm._v(" "), _c('i', [_vm._v("Biblica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.71"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BJS")]), _vm._v(" Brown Judaic Studies")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.44"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiii"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BK")]), _vm._v(" "), _c('i', [_vm._v("Bibel und Kirche")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.37"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BR")]), _vm._v(" "), _c('i', [_vm._v("Biblical Research")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.124"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BT")]), _vm._v(" "), _c('i', [_vm._v("The Bible Translator")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.10"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BTB")]), _vm._v(" "), _c('i', [_vm._v("Biblical Theology Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.27"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BWANT")]), _vm._v(" Beiträge zur Wissenschaft vom Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.76"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("BZ")]), _vm._v(" "), _c('i', [_vm._v("Biblische Zeitschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.53"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("BZAW")]), _vm._v(" Beihefte zur "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.17"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("CBQ")]), _vm._v(" "), _c('i', [_vm._v("Catholic Biblical Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.103"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("DJD")]), _vm._v(" Discoveries in the Judaean Desert")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.121"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("DOTT")]), _vm._v(" D. Winton Thomas, ed., "), _c('i', [_vm._v("Documents from Old Testament Times")]), _vm._v(". Repr. New York: Harper & Row, 1961")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.18"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("EBC")]), _vm._v(" Expositor’s Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.5"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Eng.")]), _vm._v(" English")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.56"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("EvT")]), _vm._v(" "), _c('i', [_vm._v("Evangelische Theologie")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.36"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ExpTim")]), _vm._v(" "), _c('i', [_vm._v("Expository Times")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.122"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("FOTL")]), _vm._v(" Forms of the Old Testament Literature")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.105"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GKC")]), _vm._v(" "), _c('i', [_vm._v("Genesius’ Hebrew Grammar")]), _vm._v(". Ed. E. Kautzsch. Tr. A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.125"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("GNB")]), _vm._v(" Good News Bible (Today’s English Version)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.108"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HALAT")]), _vm._v(" W. Baumgartner, et al., "), _c('i', [_vm._v("Hebräisches und aramäisches Lexikon zum Alten Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.113"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HDB")]), _vm._v(" "), _c('i', [_vm._v("Hastings’ Dictionary of the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.3"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Heb.")]), _vm._v(" Hebrew")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.22"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HKAT")]), _vm._v(" Handkommentar zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.51"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("HSM")]), _vm._v(" Harvard Semitic Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.47"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HTR")]), _vm._v(" "), _c('i', [_vm._v("Harvard Theological Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.23"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("HUCA")]), _vm._v(" "), _c('i', [_vm._v("Hebrew Union College Annual")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.64"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IB")]), _vm._v(" G. A. Buttrick, et al., eds., "), _c('i', [_vm._v("Interpreter’s Bible")]), _vm._v(". 12 vols. Nashville: Abingdon, 1953–56")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.50"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ICC")]), _vm._v(" International Critical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.102"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IDB (Sup)")]), _vm._v(" G. A. Buttrick, et al., eds., "), _c('i', [_vm._v("Interpreter’s Dictionary of the Bible")]), _vm._v(". 4 vols. Nashville: Abingdon, 1962. "), _c('i', [_vm._v("Supplementary Volume")]), _vm._v(". Ed. K. Crim, et al. 1976")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.67"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("IEJ")]), _vm._v(" "), _c('i', [_vm._v("Israel Exploration Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.32"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Int")]), _vm._v(" "), _c('i', [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.101"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ISBE")]), _vm._v(" J. Orr, et al., eds., "), _c('i', [_vm._v("International Standard Bible Encyclopedia")]), _vm._v(". 2nd ed. 5 vols. Grand Rapids: Eerdmans, 1939. Rev. ed. Ed. G. W. Bromiley, et al. 4 vols. 1979–88")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.16"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JAOS")]), _vm._v(" "), _c('i', [_vm._v("Journal of the American Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.112"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JB")]), _vm._v(" Jerusalem Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.12"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xiv"
    }
  }), _c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JBL")]), _vm._v(" "), _c('i', [_vm._v("Journal of Biblical Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.72"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JCS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Cuneiform Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.33"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JNES")]), _vm._v(" "), _c('i', [_vm._v("Journal of Near Eastern Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.15"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JPOS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Palestine Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.126"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JPST")]), _vm._v(" The JPS Torah Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.68"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JQR")]), _vm._v(" "), _c('i', [_vm._v("Jewish Quarterly Review")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.21"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSOT")]), _vm._v(" "), _c('i', [_vm._v("Journal for the Study of the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.31"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("JSOTSup")]), _vm._v(" "), _c('i', [_vm._v("JSOT")]), _vm._v(" Supplement Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.28"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JSS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Semitic Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.26"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("JTS")]), _vm._v(" "), _c('i', [_vm._v("Journal of Theological Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.109"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("KB")]), _vm._v(" L. Koehler and W. Baumgartner, "), _c('i', [_vm._v("Lexicon in Veteris Testamenti Libros")]), _vm._v(". Leiden: Brill, 1958")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.132"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("LS")]), _vm._v(" "), _c('i', [_vm._v("Louvain Studies")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.116"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LSJ")]), _vm._v(" Liddell, Scott, Jones, "), _c('i', [_vm._v("Greek-English Lexicon")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.1"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("LXX")]), _vm._v(" Septuagint")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.133"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Mish.")]), _vm._v(" Mishnah")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.128"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Moffatt")]), _vm._v(" James Moffatt, "), _c('i', [_vm._v("The Moffatt Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.8"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ms(s).")]), _vm._v(" manuscript(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.7"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("MT")]), _vm._v(" Masoretic Text")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.95"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NASB")]), _vm._v(" New American Standard Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.107"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NBD")]), _vm._v(" J. D. Douglas, et al., eds., "), _c('i', [_vm._v("New Bible Dictionary")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.80"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NCBC")]), _vm._v(" New Century Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.81"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NEB")]), _vm._v(" New English Bible")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.114"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NICOT")]), _vm._v(" New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.120"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("NIDNTT")]), _vm._v(" C. Brown, et al., eds. "), _c('i', [_vm._v("New International Dictionary of New Testament Theology")]), _vm._v(". 3 vols. Grand Rapids: Zondervan, 1975–78")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.87"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NIV")]), _vm._v(" New International Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.92"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NJPS")]), _vm._v(" New Jewish Publication Society Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.96"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("NKJV")]), _vm._v(" New King James Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.123"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OBT")]), _vm._v(" Overtures to Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.43"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("OTL")]), _vm._v(" Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.40"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("OTS")]), _vm._v(" "), _c('i', [_vm._v("Oudtestamentische Studiën")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.79"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PEFQS")]), _vm._v(" "), _c('i', [_vm._v("Palestine Exploration Fund Quarterly Statement")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.25"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PEQ")]), _vm._v(" "), _c('i', [_vm._v("Palestine Exploration Quarterly")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.90"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Pesh.")]), _vm._v(" Peshitta")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.70"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("PJ")]), _vm._v(" "), _c('i', [_vm._v("Palästina-Jahrbuch")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.134"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Proceedings, 1989")]), _vm._v(" J. Hoftijzer and G. van der Kooij, eds. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(" . . . Leiden: Brill, 1990")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.24"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RB")]), _vm._v(" "), _c('i', [_vm._v("Revue biblique")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.30"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("RevQ")]), _vm._v(" "), _c('i', [_vm._v("Revue de Qumran")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.86"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xv"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("RSV")]), _vm._v(" Revised Standard Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.88"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("RV")]), _vm._v(" Revised Version")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.135"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Sam. Pent.")]), _vm._v(" Samaritan Pentateuch")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.83"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SB")]), _vm._v(" Sources bibliques")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.35"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLDS")]), _vm._v(" Society of Biblical Literature Dissertation Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.130"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLMS")]), _vm._v(" Society of Biblical Literature Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.58"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBLSP")]), _vm._v(" Society of Biblical Literature Seminar Papers")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.73"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBOT")]), _vm._v(" Sacred Books of the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.84"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SBT")]), _vm._v(" Studies in Biblical Theology")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.62"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("ScrHier")]), _vm._v(" Scripta hierosolymitana")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.136"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SEÅ")]), _vm._v(" "), _c('i', [_vm._v("Svensk Exegetisk Årsbok")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.60"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("Sem")]), _vm._v(" "), _c('i', [_vm._v("Semitica")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.61"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SJLA")]), _vm._v(" Studies in Judaism in Late Antiquity")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.19"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("SJT")]), _vm._v(" "), _c('i', [_vm._v("Scottish Journal of Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.110"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SNTSMS")]), _vm._v(" Society for New Testament Study Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.41"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("SOTSMS")]), _vm._v(" Society for Old Testament Study Monograph Series")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.129"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Syr.")]), _vm._v(" Syriac")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.91"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Targ(s).")]), _vm._v(" Targum(s)")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.137"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("T.B.")]), _vm._v(" Babylonian Talmud")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.59"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TBT")]), _vm._v(" "), _c('i', [_vm._v("The Bible Today")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.115"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDNT")]), _vm._v(" G. Kittel and G. Friedrich, eds., "), _c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(". Tr. and ed. G. W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.119"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TDOT")]), _vm._v(" G. Botterweck and H. Ringgren, eds., "), _c('i', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Tr. D. Green, et al. Vols. 1–6 (to date). Grand Rapids: Eerdmans, 1974–90")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.82"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TGUOS")]), _vm._v(" "), _c('i', [_vm._v("Transactions of the Glasgow University Oriental Society")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.138"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("THAT")]), _vm._v(" E. Jenni and C. Westermann, eds., "), _c('i', [_vm._v("Theologisches Handwörterbuch zum Alten Testament")]), _vm._v(". 2 vols. Munich: Kaiser; Zurich: Theologischer Verlag, 1971–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.75"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TLZ")]), _vm._v(" "), _c('i', [_vm._v("Theologische Literaturzeitung")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.85"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("TOTC")]), _vm._v(" Tyndale Old Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.77"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TPQ")]), _vm._v(" "), _c('i', [_vm._v("Theologisch-praktische Quartalschrift")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.106"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TWOT")]), _vm._v(" R. Harris, et al., eds., "), _c('i', [_vm._v("Theological Wordbook of the Old Testament")]), _vm._v(". 2 vols. Chicago: Moody, 1980")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.39"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("TynBul")]), _vm._v(" "), _c('i', [_vm._v("Tyndale Bulletin")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.63"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("UF")]), _vm._v(" "), _c('i', [_vm._v("Ugarit Forschungen")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.93"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("Ugar.")]), _vm._v(" Ugaritic")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.11"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("VT")]), _vm._v(" "), _c('i', [_vm._v("Vetus Testamentum")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.46"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("VTSup")]), _vm._v(" Supplements to "), _c('i', [_vm._v("VT")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.2"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xvi"
    }
  }), _c('span', {
    staticClass: "gt"
  }, [_vm._v("Vulg.")]), _vm._v(" Vulgate")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.34"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WBC")]), _vm._v(" Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.52"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WEC")]), _vm._v(" The Wycliffe Exegetical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.78"
    }
  }, [_c('span', {
    staticClass: "gt"
  }, [_vm._v("WMANT")]), _vm._v(" Wissenschaftliche Monographien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.127"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("WO")]), _vm._v(" "), _c('i', [_vm._v("Die Welt des Orients")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.20"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZAW")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.48"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZDPV")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift des deutschen Palästina-Vereins")])]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.117"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZPEB")]), _vm._v(" M. Tenney, et al., eds., "), _c('i', [_vm._v("Zondervan Pictorial Encyclopedia of the Bible")]), _vm._v(". 5 vols. Grand Rapids: Zondervan, 1975–76")]), _vm._v(" "), _c('p', {
    staticClass: "glo",
    attrs: {
      "id": "ABBR.45"
    }
  }, [_c('span', {
    staticClass: "gt-i"
  }, [_vm._v("ZTK")]), _vm._v(" "), _c('i', [_vm._v("Zeitschrift für Theologie und Kirche")])])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "INTRO"
    }
  }, [_c('p', {
    staticClass: "pt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rINTRO"
    }
  }, [_vm._v("Introduction")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.I"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.I"
    }
  }, [_vm._v("I. Title and Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The title of the book in English comes through the Vulgate from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(", which used the title “Numbers” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v(". "), _c('i', [_vm._v("Numeri")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Arithmoi")]), _vm._v("). The variant Hebrew titles come from the first word of the text ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("way")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏabbēr")]), _vm._v(", “and he spoke”) or, more commonly, the fourth ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miḏbar")]), _vm._v(", “in the wilderness [of]”).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.1.0001",
      "id": "FN.1.0001r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ “In the wilderness” describes the contents of the book much better than “numbers,” which is derived from the census takings of chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–4")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("The story is rather simple. Israel is counted by Moses, Aaron, and the leaders in order to prepare for the march to Canaan and life in the land following the conquest (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–4")]), _vm._v("). After further exhortations to holy living and preparations to depart from Mt. Sinai ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:1–10:10")]), _vm._v("), Israel leaves the holy mountain for Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–12:13")]), _vm._v("). Spies are sent out from the oasis of Kadesh-barnea to reconnoiter. When they return to Moses and the people, their report is split. The majority say that the land and its inhabitants are too mighty to be taken. The minority (Caleb and Joshua) say that, since God had promised victory, he would bring victory for Israel, despite the strength of the land and its people. The people of Israel choose to believe the majority and are ready to go back to Egypt (thus rebelling against the leadership of Yahweh as well as that of Moses and Aaron) when God intervenes and punishes their disbelief and disobedience. Because of their sin, every person over the age of twenty would wander and die in the wilderness without coming into possession of Canaan. They would wander forty years, until the whole generation was dead (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–14")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The Israelites decide to try to make things better on their own. Unassisted by God (or Moses), they try to conquer the land but are "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.2"
    }
  }), _vm._v("humiliated in defeat ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14:40–45")]), _vm._v("). So for nearly forty years the people wander around Kadesh-barnea in the wilderness until all that generation dies (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16–19")]), _vm._v("). They then return to Kadesh-barnea, and are told to set out once again for Canaan. They depart from Kadesh-barnea and travel to the plains of Moab, just outside the land of promise (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20–21")]), _vm._v("). Along the way, they win some battles, showing that the tide is turning ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:1–4")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21–35")]), _vm._v("). Just outside Canaan, the people are blessed by Balaam, a foreign seer (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22–24")]), _vm._v("). After his blessing, they sin further at Peor and are punished again (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v("). On the plains of Moab a new census is taken to mark the new beginning (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v("). The people wait for further instructions for life in the land of Canaan, where Joshua will lead them after the death of Moses (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27–36")]), _vm._v(").")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.II"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.II"
    }
  }, [_vm._v("II. Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("One may analyze the structure of any book in several ways. The kind of structure one sees depends on the questions one asks. Most commentators have structured Numbers in three sections related to geographic locale: section I at Mt. Sinai ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v("); section II at and around Kadesh-barnea ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–19:22")]), _vm._v("), and section III on the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–36:13")]), _vm._v("). This kind of structure involves two travel sections: the first from Sinai to Kadesh-barnea ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–12:13")]), _vm._v("), and the second from Kadesh-barnea to the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–21:35")]), _vm._v("). The venue of section I is the same as that for "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 20")]), _vm._v("–"), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27")]), _vm._v(" and hence links Numbers with the central books in the Pentateuch.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.2.0002",
      "id": "FN.2.0002r"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("D. T. Olson has proposed an alternate structure that divides the book into two sections of unequal length: section I: The Death of the Old Generation; the first Exodus generation fails in the wilderness ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–25:19")]), _vm._v("); and section II: The Birth of the New; the second Exodus generation prepares to take the land of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–36:13")]), _vm._v("). This view sees the two census documents (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(") as forming the pillars of the book’s structure, and the theme of the book as two-generational: the failure of one generation and the promise of another.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.2.0003",
      "id": "FN.2.0003r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ Section I is broken down into a cycle of preparation for departure and inauguration of it ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:36")]), _vm._v("), "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.3"
    }
  }), _vm._v("and a cycle of rebellion, death, and deliverance, ending in ultimate failure ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:1–25:19")]), _vm._v("). Section II is broken down into a large and disparate group of passages dealing with preparation and organization of the second Exodus generation as it prepares to enter the land of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–36:13")]), _vm._v("). The fate of that second generation is left open at the end of the book, and is a matter of conjecture—perhaps a promise of great success, perhaps a warning of great danger.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.3.0004",
      "id": "FN.3.0004r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("Although Olson’s analysis has much to recommend it, the more traditional analysis of Numbers connects the book more closely with the Pentateuch, in which it is, after all, set. With most commentators on the book, I follow such an analysis here.")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.III"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.III"
    }
  }, [_vm._v("III. Authorship and Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The book of Numbers does not name its author. In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:2")]), _vm._v(" Moses is said to have written down the “starting points” of the Hebrews’ journey, “stage by stage,” which probably indicates at least the framework for the itinerary of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")]), _vm._v(", but, as is well known, this is the only reference to Moses’ writing in the book. One cannot discuss the question of authorship and composition of Numbers in isolation from that of the other books of the Pentateuch. The history of pentateuchal criticism is too lengthy to rehearse here, but some brief words of representative positions on the matter are in order.")]), _vm._v(" "), _c('p', [_vm._v("Scholars who believe that Moses had a significant role to play in the composition of the Pentateuch appeal to the following evidence. First, the text itself claims that Moses wrote some of the material of the Pentateuch.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.3.0005",
      "id": "FN.3.0005r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ Second, the Pentateuch refers hundreds of times to Moses’ receiving communications from Yahweh.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.3.0006",
      "id": "FN.3.0006r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ Third, much of the material in the book of Numbers makes good sense in the Mosaic age, indeed, better sense than in the postexilic age (see further below).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.3.0007",
      "id": "FN.3.0007r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ Those who espouse this view usually maintain the theological presupposition that the Bible is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.4"
    }
  }), _vm._v("authoritative. Hence, when the text claims that, for example, Moses wrote something or received a communication from God, it is not just a literary convention but a description of historical fact.")]), _vm._v(" "), _c('p', [_vm._v("The position that most commonly stands over against the so-called traditional theory of Mosaic authorship is associated with the name of Julius Wellhausen, who, in his "), _c('i', [_vm._v("Prolegomena to the History of Ancient Israel")]), _vm._v(", defended and refined the view that the Pentateuch was made up of a series of written documents: J (Jahwist or Yahwist), E (Elohist), D (Deuteronomist), P (Priestly), originating from the early monarchy (J) to the postexilic period (P).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.4.0008",
      "id": "FN.4.0008r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ The editing of the whole of the Pentateuch occurred at the hands of a Priestly redactor (not necessarily the same Priestly author as the P source) in the postexilic age (perhaps 5th cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The criteria scholars used to divide the sources were, first, the alternation between the divine names (Yahweh and Elohim especially); second, different names for the same reality (such as Horeb/Sinai); third, double or triple narratives of the same event (e.g., passing off one’s wife as one’s sister; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 12:10–13:1")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–18")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:6–11")]), _vm._v("); and, fourth, vocabulary that occurs only in one document or another (e.g., the word "), _c('i', [_vm._v("kind")]), _vm._v(", Heb. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mîn")]), _vm._v(", said to occur only in P).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.4.0009",
      "id": "FN.4.0009r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ These scholars assumed that all institutions, writings, and other manifestations of human civilization moved along a unilinear evolutionary scale from simple to complex. For example, if an institution was simple, free, and anthropomorphic, it must be early; if it was complex, institutional, liturgical, and less anthropomorphic, it must be late.")]), _vm._v(" "), _c('p', [_vm._v("Although scholars have continued to refine and modify the basic scheme,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.4.0010",
      "id": "FN.4.0010r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ it stands today on these same four criteria. Thus even scholars who developed new approaches, such as Gerhard von Rad, who used the form-critical approach that emphasized the oral transmission of smaller "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.5"
    }
  }), _vm._v("textual units, and Martin Noth, who used the so-called traditio-historical approach that emphasized the shaping and reshaping of traditions rather than written documents, assumed the basic correctness of the documentary hypothesis in its main outlines.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.5.0011",
      "id": "FN.5.0011r"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', [_vm._v("More recently, however, other scholars, like Rolf Rendtorff, have recognized that the traditio-historical approach cannot be reconciled with the documentary hypothesis and have abandoned the latter in favor of a scheme based on the editing together of the larger units of the Pentateuch (i.e., such units of tradition as the patriarchal material in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 12–50")]), _vm._v(" or the Balaam stories in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 22–24")]), _vm._v("). The whole was given its definitive stamp by an editor more or less closely aligned to the viewpoint of Deuteronomy.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.5.0012",
      "id": "FN.5.0012r"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_vm._v("The view connected with the name of Y. Kaufmann, and carried forward by such scholars as M. Weinfeld, A. Hurvitz, J. Milgrom, and others, also deserves mention here.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.5.0013",
      "id": "FN.5.0013r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ While not denying the basic correctness of the written documents as such, this group of scholars has attempted to show that the so-called Priestly materials in the Pentateuch are preexilic rather than postexilic. They thoroughly criticize the unilinear evolutionary theory on which the dating of the documents rests. The laws and institutions "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.6"
    }
  }), _vm._v("discussed in the Priestly legislation and narrative simply do not fit in the postexilic age.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.6.0014",
      "id": "FN.6.0014r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ Specific studies of Priestly vocabulary also show that words long thought to be postexilic may more probably be dated in the preexilic period.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.6.0015",
      "id": "FN.6.0015r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Also, these scholars show that Deuteronomy, which they date in the 7th cent., cites material from P, but P does not cite Deuteronomy.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.6.0016",
      "id": "FN.6.0016r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("Although scholars from a wide variety of critical and theological perspectives have subjected every aspect of the documentary hypothesis to searching criticism,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.6.0017",
      "id": "FN.6.0017r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ it is unlikely that most scholars will return to the traditional position, since many would conclude that there is too much evidence for a long period of transmission standing behind the present text to return to a theory of Mosaic authorship. The present author includes himself in this group of many. On the other hand, the text itself is undeniably connected to Moses and this, too, must be taken into account.")]), _vm._v(" "), _c('p', [_vm._v("In other words, to ignore lessons learned from either basic approach would be to ignore data presented by the text of Numbers itself. On the one hand, the traditional theory affirms the many and basic unifying features of the book, which are anchored in the person of Moses. It seems difficult to deny his role in the origin of the book. On the other "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.7"
    }
  }), _vm._v("hand, a great deal of evidence suggests a long period of transmission for some materials in the book. Most of the book presupposes a time later than the conquest, and particularly materials from ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(" on point to a time significantly later.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.7.0018",
      "id": "FN.7.0018r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ The evidence given especially by Kaufmann, Milgrom, et al., seems convincing, however, that one does not need to posit so late a date as the postexilic era for the book in its more-or-less final form; a preexilic date is most likely, possibly in the time of the united monarchy.")]), _vm._v(" "), _c('p', [_vm._v("It seems best to take the materials of the text itself as offering some clue to the sources and composition of the book. Moses may be seen as having a key role in the origin of some of the material in Numbers, though we have no way of knowing how much of it goes back to him. Much of what is in the book bears marks of antiquity, but there are also undoubted signs of a long period of transmission. The book probably went through a more complex history of transmission than is recoverable. The most reasonable and practical approach to specific texts in Numbers is to explain what they mean as they stand in the final form of the text. The book did not simply fall together, and does make sense as it stands. Demonstration that the text makes sense will, of course, be more difficult in some cases than in others. I do not object to a literary theory of sources as such, but to the assumption that these sources were not compiled into a cogent text. When the text presents a literary difficulty, I will attempt to find a literary solution from within the text itself, having to do with the function of the text, rather than simply positing a combination of sources by an editor who had little appreciation for logic, cogency, and literary style. I believe that, through all the complexities of the transmission of the text of Numbers, God was at work to bring to his people the final form of the text. Inspiration should not be limited to any one stage in the composition of the biblical text (e.g., the earliest) as opposed to other stages. The Church and the Synagogue confess the whole OT text as God’s Word, not just one stage in its composition.")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.IV"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.8"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.IV"
    }
  }, [_vm._v("IV. Theological Themes")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("The themes of obedience, disobedience, holiness, and the presence of God are keys to understanding the book of Numbers. For purposes of thematic discussion it will be helpful to break the book into three constituent parts: Orientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v("), Disorientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–22:1")]), _vm._v("), and New Orientation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:1–36:13")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.8.0019",
      "id": "FN.8.0019r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ The travel sections ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–12:16")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–22:1")]), _vm._v(") are transitional.")]), _vm._v(" "), _c('p', [_vm._v("The opening section ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(") stresses the importance of exact obedience to Yahweh in the census (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:54")]), _vm._v("), the camp ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:34")]), _vm._v("), the presentation of offerings (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v("), and Israel’s encampment/decampment ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:23")]), _vm._v("). Yahweh’s will is that Israel be "), _c('i', [_vm._v("oriented")]), _vm._v(" toward him as a holy people, separated from the uncleanness of the rest of the world, as seen in the separation of the Levites (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–4")]), _vm._v(") and the Nazirites (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v(") from the people and the priests from the Levites (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v("). Yahweh’s camp is also a place where no uncleanness (e.g., leprosy) is allowed ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:1–4")]), _vm._v("). Wrongs that are not atoned for ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:5–10")]), _vm._v(") and suspicions between husbands and wives ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:11–31")]), _vm._v(") also bring uncleanness to Yahweh’s holy people. The first section concludes with the recognition that uncleanness will in fact exist, but it also shows Yahweh’s gracious provision that feasts (e.g., Passover) may be postponed until cleanness is regained ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:1–14")]), _vm._v("). The camp as ideally constituted will have the numinous presence of Yahweh with his people as they move toward their destiny in Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:15–22")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("After the command to depart is given ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–13")]), _vm._v("), the people leave the sacred mountain in exact obedience to the instructions in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(" ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14–36")]), _vm._v("). This obedience to Yahweh is the way for Israel to maintain holiness and orientation. What happens next, however, is almost instantaneous complaining and "), _c('i', [_vm._v("dis")]), _vm._v("obedience. In three scenes the complaints involve the people in general, the rabble (the non-Israelites who had come along with them; cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 12:38")]), _vm._v("), and even the family of Moses itself. Each disobedience brings immediate judgment from Yahweh ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:1")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("12:9–12")]), _vm._v("). "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.9"
    }
  }), _vm._v("In this transitional section the paradigm of the central section of the book is set: painful disorientation for God’s people.")]), _vm._v(" "), _c('p', [_vm._v("The story of the spies (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–14")]), _vm._v(") is extremely important to understand the disorientation of the Israelites. In these chapters the people decide that Moses and Aaron (God’s chosen leaders) are not to be trusted to lead. Then, through fear, the people decide that, in spite of God’s promise to give them Canaan, they are not strong enough for the task, and, further, that they need to select a new leader who will take them back to Egypt. In effect they choose to go back to a time before Yahweh had revealed himself to them at Sinai, when they were choosing “other gods,” and God sees this act as rebellion. God’s response to this rebellion is a curse on the entire generation. The old generation had been afraid to go forward; now they would not go forward. They had been afraid that their children would die in the wilderness; now, "), _c('i', [_vm._v("they")]), _vm._v(" would die there. Not one of the Exodus generation over twenty years of age (except Caleb and Joshua) would go into Canaan. It was not possible to go back to Egypt. Rebellion against Yahweh would, instead, lead to forty years’ wandering in the wilderness, making no progress toward the goal of God’s promise of land in Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14:20–35")]), _vm._v("), but it could not lead back to Egypt. The people were God’s in spite of their rebellion.")]), _vm._v(" "), _c('p', [_vm._v("In ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("15")]), _vm._v(" God shows his continued care for Israel by giving supplementary laws for cereal and drink offerings, first fruits, and purification offerings. God is still working with the people in spite of their rebellion, but that the supposedly holy people are by this time truly disoriented is seen in the further rebellions of Korah, Dathan, and Abiram (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v("). These men are not satisfied with the leadership as God had given it; they want more power. The result is tragic and fatal ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:31–35")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:6–15")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:41–50")]), _vm._v("]). Yahweh’s presence brings awful judgment in the narratives of the spies and of Korah, in contrast to the cloudy pillar, which was to provide leadership on the way to Canaan in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(". In spite of the judgment, however, God affirms that the people are his (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–18")]), _vm._v("). Once again he appoints the tribe of Levi in general and the family of Aaron in particular to stand as leaders of the people and intercessors between God and Israel ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:17–28")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–13")]), _vm._v("]). Also, in response to the people’s terror, God changes the duties of both the priests and the Levites so as to protect the people from future outbreaks of divine wrath. God moves to work with his people in their disorientation in order to reorient their lives.")]), _vm._v(" "), _c('p', [_vm._v("In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1–22:1")]), _vm._v(" the people begin moving back toward Canaan, and so toward a new orientation to God’s will for them. At the beginning of this transitional section is the note of Miriam’s death ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:1")]), _vm._v("), followed "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.10"
    }
  }), _vm._v("immediately by a situation in which both Moses and Aaron commit a fatal sin ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:2–13")]), _vm._v("). Following the announcement of the impending doom of the Exodus leaders Moses and Aaron, the situation begins to move toward a better day. The king of Edom denies a request to pass through his land, but Israel suffers no defeat ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:14–21")]), _vm._v("). When Aaron the high priest dies at Mt. Hor ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:22–29")]), _vm._v("), it is the end of an era.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.10.0020",
      "id": "FN.10.0020r"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("After his death Israel gains a victory at Hormah ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:1–3")]), _vm._v(") in contrast to the old and painful defeat there in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14:39–45")]), _vm._v(" at the beginning of the period of disorientation. The incident of the fiery serpents shows that, although the people continue to complain and rebel, intercession is now quick and effective, and the presence of God is both for judgment ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:6")]), _vm._v(") and for salvation ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:8–9")]), _vm._v("). The travel itinerary ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:10–20")]), _vm._v(") sees even the wilderness wandering as making progress toward a goal, that is, God is involved in the process to bring about his purposes even in the face of human rebellion. Further evidences that the people are moving toward a new orientation are the two victories over Sihon the Amorite ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:21–32")]), _vm._v(") and Og of Bashan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:33–35")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("As the Israelites arrive on the plains of Moab ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:1")]), _vm._v("), they are on the threshold of a new orientation. The dominant theme in the last section of the book becomes the blessing of God in Canaan. The paradigm for this blessing is set by a non-Israelite seer named Balaam, who is hired to curse the Israelites by Balak of Moab (with the complicity of the Midianites), but instead blesses them four times ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:7–12")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–26")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23:27–24:13")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24:14–19")]), _vm._v(") and outlines God’s promise for the future of this people ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24:20–25")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.10.0021",
      "id": "FN.10.0021r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ It has been apparent in chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–19")]), _vm._v(" that Israel can bring a curse upon themselves, but in spite of that curse, if the people obey, the future will lay open to them. None of their enemies could curse them, for Yahweh was intent on blessing a newly oriented Israel.")]), _vm._v(" "), _c('p', [_vm._v("The incident concerning the Baal of Peor (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v(") is the last disorientation narrative in the book. Because of idolatry, once again, God’s presence becomes a consuming fire in the form of a plague ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:1b–5")]), _vm._v("). The plague is stemmed when Phinehas acts in zeal to defend Yahweh’s honor ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:6–9")]), _vm._v("). The response of God is the future establishment of Phinehas’s priestly line ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25:10–15")]), _vm._v("), thus showing, again, the future orientation of the whole last section of Numbers.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.11"
    }
  }), _vm._v("Evidently the plague killed the last of the cursed Exodus generation. It was now time for a new beginning in earnest. A new census ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:1–51")]), _vm._v(") reasserts the people’s exact obedience to Yahweh’s command through Moses. This is not, however, a simple return to the old orientation, but a "), _c('i', [_vm._v("new")]), _vm._v(" orientation because it is a "), _c('i', [_vm._v("new")]), _vm._v(" generation.")]), _vm._v(" "), _c('p', [_vm._v("From this point on the vast majority of material concerns the new land. The matters of daughters’ inheritance rights ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:1–11")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("36:1–13")]), _vm._v("), of the commissioning of Joshua as leader for the new day ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:12–23")]), _vm._v("), of the calendar of feasts for regular celebration of Yahweh’s presence in the new land ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28:1–29:40")]), _vm._v("), of vows ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30:1–16")]), _vm._v("), of the division of certain parts of the Transjordan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("32:1–42")]), _vm._v(") and Canaan proper ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:1–49")]), _vm._v("), of the ideal boundaries of Canaan ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:1–29")]), _vm._v("), of the Levites’ cities ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35:1–8")]), _vm._v("), and of the cities of refuge ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35:9–34")]), _vm._v(") all point toward the good future in the land that Yahweh will give. Punishment of Midian ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:1–54")]), _vm._v(") and destruction of the other Canaanites ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:50–56")]), _vm._v(") are reaffirmations of the importance of orientation toward Yahweh and Yahweh alone. The long list of campsites ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:1–49")]), _vm._v(") puts the whole journey from Egypt to Canaan under the direction of Yahweh, who has guided even through the rebellions of Israel.")]), _vm._v(" "), _c('p', [_vm._v("The obvious fact is that Numbers ends on the plains of Moab with Moses alive. The death of Moses is postponed until "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 34")]), _vm._v(", which serves to link Numbers with Deuteronomy. The story of Numbers is a story without a conclusion. The future is open to God’s people, but it is unsure. It will depend on whether his people maintain their orientation toward him and him alone. Every new generation of God’s people faces the same uncertainty, but also has the same promise of blessing.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.11.0022",
      "id": "FN.11.0022r"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', [_vm._v("Minor themes in the book of Numbers will be discussed as they are met in the commentary proper (e.g., the theme of leadership in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11:4–35")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:1–17:28")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:1–17:13")]), _vm._v("]; etc.).")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.V"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.V"
    }
  }, [_vm._v("V. Text and Versions")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Because of the importance of the Torah to Judaism, the Hebrew text of the Pentateuch, including that of the book of Numbers, is on the whole well preserved and free from problems.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.11.0023",
      "id": "FN.11.0023r"
    }
  }, [_vm._v("1")]), _vm._v(" Most of the textual difficulties "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.12"
    }
  }), _vm._v("arise in the poetic bits of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21")]), _vm._v(" and in the Balaam oracles of chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22–24")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0024",
      "id": "FN.12.0024r"
    }
  }, [_vm._v("2")]), _vm._v(" Since neither the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" nor the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" renders much help in reconstructing the original text of these passages, these textual problems are probably older than either of these versions (see below).")]), _vm._v(" "), _c('p', [_vm._v("The Masoretes produced a text ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(") that, with the exception of the above-named passages, shows little significant variation among the extant "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.8"
    }
  }, [_vm._v("mss")]), _vm._v(". At several points in the text of Numbers the Masoretes inserted readings or notes that are significant. The so-called "), _c('i', [_vm._v("special points")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("puncta extraordinaria")]), _vm._v(") mark particular words in the text to show Masoretic awareness of textual or doctrinal reservations about that word (or passage) in the tradition of their community.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0025",
      "id": "FN.12.0025r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ The "), _c('i', [_vm._v("inverted nuns")]), _vm._v(" that mark off "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:35–36")]), _vm._v(" probably show that these verses were considered to be out of place.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0026",
      "id": "FN.12.0026r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ The "), _c('i', [_vm._v("Sebir notes")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.6"
    }
  }, [_vm._v("Aram")]), _vm._v(". "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("s")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇîr")]), _vm._v(", “supposed”) occur over twenty times in the book (and often elsewhere) and seem to be used as a sign that the marginal reading is the more usual or commonly occurring form.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0027",
      "id": "FN.12.0027r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" is a different Hebrew recension from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", written in a special Hebrew script.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.12.0028",
      "id": "FN.12.0028r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ The date of this recension is unknown; "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.13"
    }
  }), _vm._v("estimates range from the 4th to the 1st cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0029",
      "id": "FN.13.0029r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" differs from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" some 6,000 times, 1,900 of these in agreement with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(". It is a full text in that it tends to expand on the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", not only in the direction of giving special place to the theology of the Samaritan sect, but also in the direction of incorporation of readings from similar texts elsewhere in the OT into the text. In the book of Numbers the longest and perhaps most significant variants are additions from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1–3")]), _vm._v(" (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1:6–8")]), _vm._v(" is inserted after "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 10:10")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1:20–23a")]), _vm._v(" after "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 12:16")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0030",
      "id": "FN.13.0030r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ Especially interesting are the interpolations from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 2")]), _vm._v(" into the travel narrative of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 21")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0031",
      "id": "FN.13.0031r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ These add bits of dialogue to the rather colorless "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", but none of these readings should be considered original.")]), _vm._v(" "), _c('p', [_vm._v("The Pentateuch of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" (or Old Greek version) is usually dated in the 3rd cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0032",
      "id": "FN.13.0032r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ In Numbers, as in the rest of the Pentateuch, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" offers for the most part a translation of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" into idiomatic Greek.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0033",
      "id": "FN.13.0033r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Most of the variant readings in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" are in the spellings of names; in a few cases the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" order of verses differs from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0034",
      "id": "FN.13.0034r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" is quite frequently longer than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", but occasionally it is shorter.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.13.0035",
      "id": "FN.13.0035r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ While it is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.14"
    }
  }), _vm._v("possible that some "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" readings preserve a different (perhaps older) text tradition than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", each "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" reading must be assessed to determine this.")]), _vm._v(" "), _c('p', [_vm._v("The Qumran materials do not yield much in the way of significant textual variants.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0036",
      "id": "FN.14.0036r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ Most of what has been published consists of scattered words and lines of text, some of which show affinity with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" readings.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0037",
      "id": "FN.14.0037r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ A single "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.8"
    }
  }, [_vm._v("ms")]), _vm._v(". found in Cave 4 gives portions of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:30–4:14")]), _vm._v(" in a Greek version that generally follows the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" text, but with some variants.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0038",
      "id": "FN.14.0038r"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', [_vm._v("The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v(". on the book of Numbers was translated by St. Jerome sometime between A"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("D"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" 390 and about 405. Although Jerome undertook to translate the Hebrew OT rather than the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" into Latin, he also admitted to using the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" as well as the other Greek Versions (Aquila, Symmachus, and Theodotion). Scholars have also detected traces of the conclusions of some rabbinic exegesis in the translation. B. J. Roberts concluded his summary of the nature of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v(". OT in the following way:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Our conclusion, then, regarding the nature of Jerome’s translation is that, when due allowance is made for all external influecnes, it must be admitted that his method was neither straightforward nor consistent.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.14.0039",
      "id": "FN.14.0039r"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', [_vm._v("In sum, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" is generally preferable to the variant readings of "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.2"
    }
  }, [_vm._v("Vulg")]), _vm._v("., or the Qumran materials. The translation in the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.15"
    }
  }), _vm._v("commentary below is based on the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" and adheres to it as far as possible, although variants will be mentioned in the notes.")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.VI"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.VI"
    }
  }, [_vm._v("VI. Analysis of Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I"
    }
  }, [_c('b', [_vm._v("I. PREPARATION FOR DEPARTURE (1:1–10:10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A"
    }
  }, [_vm._v("A. Matters Concerning the People and the Camp (1:1–6:27)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1"
    }
  }, [_vm._v("1. The Censuses and the Arrangements of the March (1:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A"
    }
  }, [_vm._v("a. First Lay Census (1:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.1"
    }
  }, [_vm._v("(1) The Leaders (1:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2"
    }
  }, [_vm._v("(2) The Census Itself (1:17–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2.A"
    }
  }, [_vm._v("(a) Introduction (1:17–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.2.B"
    }
  }, [_vm._v("(b) The census lists (1:20–47)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.A.3"
    }
  }, [_vm._v("(3) Levites Are Excepted (1:48–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.B"
    }
  }, [_vm._v("b. Placement of the Camp and Marching Order (2:1–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C"
    }
  }, [_vm._v("c. Levitical Censuses (3:1–4:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1"
    }
  }, [_vm._v("(1) General Census (3:1–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1.A"
    }
  }, [_vm._v("(a) Introduction: Family of Aaron (3:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl5"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.1.B"
    }
  }, [_vm._v("(b) The census itself (3:14–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.2"
    }
  }, [_vm._v("(2) Levites for Firstborn (3:40–51)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0017#NUM.I.A.1.C.3"
    }
  }, [_vm._v("(3) Census of Working Levites (4:1–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2"
    }
  }, [_vm._v("2. Various Legal Enactments (5:1–6:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.A"
    }
  }, [_vm._v("a. Camp Must Be Kept Free from Those with Serious Skin Disease (5:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.B"
    }
  }, [_vm._v("b. Restitution When There Is No Kinsman (5:5–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.C"
    }
  }, [_vm._v("c. The Jealous Husband (5:11–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.D"
    }
  }, [_vm._v("d. Law of the Nazirite (6:1–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.A.2.E"
    }
  }, [_vm._v("e. Conclusion: Aaronic Benediction (6:22–27)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B"
    }
  }, [_vm._v("B. Various Matters concerning the Tabernacle (7:1–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.1"
    }
  }, [_vm._v("1. Offerings by Tribal Leaders (7:1–89)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.2"
    }
  }, [_vm._v("2. Lamps in the Tabernacle (8:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.3"
    }
  }, [_vm._v("3. Consecration of Levites (8:5–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.4"
    }
  }, [_vm._v("4. The Levites’ Work (8:23–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.5"
    }
  }, [_vm._v("5. Supplement to the Passover Law (9:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6"
    }
  }, [_vm._v("6. Preparations to Depart (9:15–10:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6.A"
    }
  }, [_vm._v("a. Fiery Cloud (9:15–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0018#NUM.I.B.6.B"
    }
  }, [_vm._v("b. Silver Trumpets (10:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II"
    }
  }, [_c('b', [_vm._v("II. THE JOURNEY FROM MT. SINAI TO KADESH-BARNEA (10:11–12:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.A"
    }
  }, [_vm._v("A. Departure from Mt. Sinai (10:11–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.16"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B"
    }
  }, [_vm._v("B. Crises of Authority on the Way (11:1–12:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.1"
    }
  }, [_vm._v("1. At Taberah (11:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.2"
    }
  }, [_vm._v("2. At Kibroth-hattaavah (11:4–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0019#NUM.II.B.3"
    }
  }, [_vm._v("3. At Hazeroth (12:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III"
    }
  }, [_c('b', [_vm._v("III. IN AND AROUND KADESH-BARNEA (13:1–19:22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A"
    }
  }, [_vm._v("A. The Spies (13:1–14:45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.1"
    }
  }, [_vm._v("1. Spies Are Selected (13:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.2"
    }
  }, [_vm._v("2. Spies Go and Return (13:17–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3"
    }
  }, [_vm._v("3. Responses to the Spies’ Reports (14:1–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.A"
    }
  }, [_vm._v("a. Responses by People and Leaders (14:1–10a)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.B"
    }
  }, [_vm._v("b. Yahweh Responds (14:10b–38)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.A.3.C"
    }
  }, [_vm._v("c. The People Attempt to Enter Canaan (14:39–45)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B"
    }
  }, [_vm._v("B. Cultic Legislation (15:1–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.1"
    }
  }, [_vm._v("1. Supplementary Laws of the Offerings (15:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.2"
    }
  }, [_vm._v("2. First of the Dough (15:17–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.3"
    }
  }, [_vm._v("3. Purification Offering (15:22–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.4"
    }
  }, [_vm._v("4. Case Law on Capital Punishment for Sabbath Violation (15:32–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0020#NUM.III.B.5"
    }
  }, [_vm._v("5. Tassels on Garments for Remembrance (15:37–41)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C"
    }
  }, [_vm._v("C. Legitimation of Aaron’s Priesthood (16:1–17:28 [Eng. 13])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.1"
    }
  }, [_vm._v("1. Rebellions of Korah, Dathan, and Abiram (16:1–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.2"
    }
  }, [_vm._v("2. Aftermath of Rebellions (17:1–15 [Eng. 16:36–50])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.C.3"
    }
  }, [_vm._v("3. Aaron’s Budding Rod (17:16–28 [Eng. 17:1–13])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D"
    }
  }, [_vm._v("D. Further Cultic Legislation (18:1–19:22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1"
    }
  }, [_vm._v("1. Redefined Role for Priests and Levites (18:1–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.A"
    }
  }, [_vm._v("a. Responsibilities of Priests and Levites (18:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.B"
    }
  }, [_vm._v("b. Support of Priests (18:8–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.C"
    }
  }, [_vm._v("c. Support of Levites (18:21–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.1.D"
    }
  }, [_vm._v("d. Tithe of the Tithe (18:25–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2"
    }
  }, [_vm._v("2. The Red Cow (19:1–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2.A"
    }
  }, [_vm._v("a. Making the Waters of Impurity (19:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0021#NUM.III.D.2.B"
    }
  }, [_vm._v("b. Using the Waters of Impurity (19:11–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV"
    }
  }, [_c('b', [_vm._v("IV. THE JOURNEY FROM KADESH-BARNEA TO THE PLAINS OF MOAB (20:1–22:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.A"
    }
  }, [_vm._v("A. Death of Miriam and Disaster at Meribah (20:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.B"
    }
  }, [_vm._v("B. Request to Pass through Edom (20:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.C"
    }
  }, [_vm._v("C. Death of Aaron (20:22–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.D"
    }
  }, [_vm._v("D. Second Battle of Hormah (21:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.E"
    }
  }, [_vm._v("E. Fiery Serpents (21:4–9)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.F"
    }
  }, [_vm._v("F. Travel Itinerary (21:10–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.17"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0022#NUM.IV.G"
    }
  }, [_vm._v("G. Wars against Sihon and Og (21:21–22:1)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V"
    }
  }, [_c('b', [_vm._v("V. ON THE PLAINS OF MOAB (22:2–36:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A"
    }
  }, [_vm._v("A. Story of Balaam (22:2–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1"
    }
  }, [_vm._v("1. Encounter between Balak and Balaam (22:2–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.A"
    }
  }, [_vm._v("a. Messengers Find Balaam (22:2–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.B"
    }
  }, [_vm._v("b. Balaam and the Donkey (22:22–35)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.1.C"
    }
  }, [_vm._v("c. Balak Meets with Balaam (22:36–40)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2"
    }
  }, [_vm._v("2. First and Second Oracles (22:41–23:30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.A"
    }
  }, [_vm._v("a. Introductory Preparations (22:41–23:6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.B"
    }
  }, [_vm._v("b. First Oracle (23:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.2.C"
    }
  }, [_vm._v("c. Second Oracle (23:13–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3"
    }
  }, [_vm._v("3. Third, Fourth, and Final Oracles (23:27–24:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.A"
    }
  }, [_vm._v("a. Third Oracle (23:27–24:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.B"
    }
  }, [_vm._v("b. Fourth Oracle (24:14–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.A.3.C"
    }
  }, [_vm._v("c. Final Oracles (24:20–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0023#NUM.V.B"
    }
  }, [_vm._v("B. Incident of Baal-Peor (25:1–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.C"
    }
  }, [_vm._v("C. Second Census (25:19–26:65 [Eng. 26:1–65])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.D"
    }
  }, [_vm._v("D. Daughters of Zelophehad (27:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.E"
    }
  }, [_vm._v("E. Joshua Named as Moses’ Successor (27:12–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F"
    }
  }, [_vm._v("F. Further Legislation (28:1–30:17 [Eng. 16])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.1"
    }
  }, [_vm._v("1. Cultic Calendar (28:1–30:1 [Eng. 28:1–29:40])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.F.2"
    }
  }, [_vm._v("2. Women’s Vows (30:2–17 [Eng. 1–16])")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0024#NUM.V.G"
    }
  }, [_vm._v("G. War with Midian (31:1–54)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.H"
    }
  }, [_vm._v("H. Transjordanian Inheritance (32:1–42)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.I"
    }
  }, [_vm._v("I. Travel Itinerary (33:1–49)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J"
    }
  }, [_vm._v("J. Regulations for Living in Canaan (33:50–36:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.1"
    }
  }, [_vm._v("1. Introduction: Canaanites Must Be Expelled (33:50–56)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.2"
    }
  }, [_vm._v("2. Borders of the Land (34:1–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.3"
    }
  }, [_vm._v("3. Leaders to Draw Israel’s Borders (34:16–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.4"
    }
  }, [_vm._v("4. Cities of the Levites (35:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.5"
    }
  }, [_vm._v("5. Cities of Refuge (35:9–34)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0025#NUM.V.J.6"
    }
  }, [_vm._v("6. Additional Legislation for Daughters of Zelophehad (36:1–13)")])])])])])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "FRONT.VII"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rFRONT.VII"
    }
  }, [_vm._v("VII. Select Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_vm._v("Abba, R. “The Origin and Significance of Hebrew Sacrifice,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.10"
    }
  }, [_vm._v("BTB")]), _vm._v(" 7 (1977) 123–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Priests and Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 257–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.18"
    }
  }), _vm._v("“Priests and Levites in Ezekiel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aberbach, M., and L. Smolar. “Aaron, Jeroboam, and the Golden Calves,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 86 (1967) 129–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aharoni, Y. “The Province List of Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 9 (1959) 225–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Solomonic Temple, the Tabernacle and the Arad Sanctuary,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.13"
    }
  }, [_vm._v("AOAT")]), _vm._v(" 22 (1973) 1–8.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Aharoni, Y., and R. Amiran. “Arad: Its Inscriptions and Temple,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 31 (1968) 1–32.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Albright, W. F. “The Administrative Divisions of Israel and Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.15"
    }
  }, [_vm._v("JPOS")])]), _vm._v(" 5 (1925) 17–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “From the Patriarchs to Moses: 2. Moses out of Egypt,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 36 (1973) 57–58, 63–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Home of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 35 (1915) 386–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Jethro, Hobab and Reuel in Early Hebrew Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 25 (1963) 1–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The List of Levitic Cities.” In "), _c('i', [_vm._v("L. Ginzberg Jubilee Volume")]), _vm._v(". New York: American Academy for Jewish Research, 1945. Pp. 49–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Midianite Donkey Caravans.” In "), _c('i', [_vm._v("Translating and Understanding the Old Testament: Essays in Honor of Herbert Gordon May")]), _vm._v(". Ed. H. Frank and W. Reed. Nashville: Abingdon, 1970. Pp. 197–205.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Oracles of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 63 (1944) 207–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Proto-Sinaitic Inscriptions and Their Decipherment")]), _vm._v(". Harvard Theological Studies 22. Cambridge: Harvard Univ., 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allegro, J. M. “The Meaning of the Phrase "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šetm hā‘ayin")]), _vm._v(" in Num. 24:3, 15,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 3 (1953) 78–79.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allen, R. B. “Numbers.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.18"
    }
  }, [_vm._v("EBC")])]), _vm._v(" 2. Grand Rapids: Zondervan, 1990. Pp. 657–1008.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Theology of the Balaam Oracles.” In "), _c('i', [_vm._v("Tradition and Testament: Essays in Honor of Charles Lee Feinberg")]), _vm._v(". Ed. J. S. Feinberg and P. D. Feinberg. Chicago: Moody, 1981. Pp. 79–119.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Allis, O. T. "), _c('i', [_vm._v("The Five Books of Moses")]), _vm._v(". Nutley, N.J.: Presbyterian & Reformed, 1941.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Alter, R. "), _c('i', [_vm._v("The Art of Biblical Narrative")]), _vm._v(". New York: Basic Books, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ap-Thomas, D. R. “Some Notes on the Old Testament Attitude to Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.19"
    }
  }, [_vm._v("SJT")])]), _vm._v(" 9 (1956) 422–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Arden, E. “How Moses Failed God,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 76 (1957) 50–52.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Auerbach, E. “Die Feste im alten Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 1–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Die Herkunft der Sadokiten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 49 (1931) 327–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Auld, A. G. “Cities of Refuge in Israelite Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 10 (1978) 26–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Joshua, Moses, and the Land: Tetrateuch, Pentateuch, Hexateuch in a Generation Since 1938")]), _vm._v(". Edinburgh: T. & T. Clark, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.19"
    }
  }), _vm._v("Avi-Yonah, M. "), _c('i', [_vm._v("The Encyclopedia of Archaeological Excavations in the Holy Land")]), _vm._v(". 4 vols. London: Oxford Univ. Press, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Baentsch, B. "), _c('i', [_vm._v("Exodus–Leviticus–Numeri")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.22"
    }
  }, [_vm._v("HKAT")]), _vm._v(" 2. Göttingen: Vandenhoeck & Ruprecht, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bamberger, B. J. “Revelations of Torah after Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 16 (1941) 97–113.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barnouin, M. “Les Rscensements du Livre des Nombres et l’Astronomie Babylonienne,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 280–303.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Tableaux numériques du Livre des Nombres,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 76 (1969) 351–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bartlett, J. R. “The Brotherhood of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 4 (1977) 2–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Conquest of Sihon’s Kingdom: A Literary Re-examination,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 97 (1978) 347–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Historical Reference of Numbers 21:27–30,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 101 (1969) 94–100.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Land of Seir and the Brotherhood of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 20 (1969) 1–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Moabites and Edomites.” In "), _c('i', [_vm._v("Peoples of Old Testament Times")]), _vm._v(". Ed. D. J. Wiseman. Oxford: Clarendon, 1973. Pp. 229–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Rise and Fall of the Kingdom of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 104 (1972) 26–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sihon and Og, Kings of the Amorites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 257–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Use of the Word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rō’š")]), _vm._v(" as a Title in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 1–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zadok and His Successors at Jerusalem,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 19 (1968) 1–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Begrich, J. “Das priesterliche Heilsorakel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 52 (1934) 81–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Beltz, W. "), _c('i', [_vm._v("Die Kaleb-Traditionen im Alten Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 98. Stuttgart: Kohlhammer, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ben-Barek, Z. “Inheritance by Daughters in the Ancient Near East,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 25 (1980) 22–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bennett, C. “Excavations at Buseirah, Southern Jordan,” "), _c('i', [_vm._v("Levant")]), _vm._v(" 5 (1973) 1–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Tawilân,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 76 (1969) 386–90; 77 (1970) 371–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ummel-Biyara-Pétra,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 71 (1964) 250–53; 73 (1966) 372–403.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bentzen, A. “Zur Geschichte der Sadokiten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" NS 10 (1933) 173–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bergmann, A. “The Israelite Tribe of Half Manasseh,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.15"
    }
  }, [_vm._v("JPOS")])]), _vm._v(" 16 (1936) 224–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bertman, S. “Tasseled Garments in the Ancient East Mediterranean,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 24 (1961) 119–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bewer, J. A. “The Literary Problems of the Balaam Story in Numbers, Chapters 22–24,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.29"
    }
  }, [_vm._v("AJT")])]), _vm._v(" 9 (1905) 238–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Binns, L. E. "), _c('i', [_vm._v("The Book of Numbers: With Introduction and Notes")]), _vm._v(". Westminster Commentaries. London: Methuen, 1927.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.20"
    }
  }), _vm._v("“Midianite Elements in Hebrew Religion,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 31 (1930) 337–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bird, P. “To Play the Harlot: An Inquiry into an Old Testament Metaphor.” In "), _c('i', [_vm._v("Gender and Difference in Ancient Israel")]), _vm._v(". Ed. P. Day. Minneapolis: Fortress, 1989. Pp. 75–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Blank, S. H. “The Curse, the Blasphemy, the Spell, and the Oath,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 23/1 (1950–51) 73–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Men against God—The Promethean Element in Biblical Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 72 (1953) 1–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Observations concerning Biblical Prayer,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 32 (1961) 75–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bodenheimer, F. W. “The Manna of Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Boeker, H. J. "), _c('i', [_vm._v("Law and the Administration of Justice in the Old Testament and the Ancient East")]), _vm._v(". Tr. J. Moiser. Minneapolis: Augsburg, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bowman, J. “Did the Qumran Sect Burn the Red Heifer?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.30"
    }
  }, [_vm._v("RevQ")])]), _vm._v(" 1 (1958) 73–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brenner, A. "), _c('i', [_vm._v("Colour Terms in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 21. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brichto, H. C. “The Case of the "), _c('i', [_vm._v("Sota")]), _vm._v(" and a Reconsideration of Biblical Law,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 46 (1975) 55–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Kin, Cult, Land and Afterlife: A Biblical Complex,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 44 (1973) 1–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of “Curse” in the Hebrew Bible")]), _vm._v(". Philadelphia: Society of Biblical Literature and Exegesis, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brin, G. “The Formula ‘From . . . and Onward/Upward,’ ” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1980) 351–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Numbers XV 22–23 and the Question of the Composition of the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 30 (1980) 351–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('i', [_vm._v("A Hebrew-English Lexicon of the Old Testament")]), _vm._v(". Oxford: Clarendon, 1907.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brueggemann, W. “From Hurt to Joy, from Death to Life,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 28 (1974) 3–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buchanan, G. W. “Eschatology and the ‘End of Days,’ ” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.33"
    }
  }, [_vm._v("JNES")])]), _vm._v(" 20 (1961) 188–93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Budd, P. J. "), _c('i', [_vm._v("Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.34"
    }
  }, [_vm._v("WBC")]), _vm._v(" 5. Waco, Tex.: Word, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buis, P. “Les Conflits entre Moise et Israël dans Exode et Nombres,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 257–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Qadesh, un Lieu Maudit?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 24 (1974) 268–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buit, M. du. “Quelques contacts bibliques dans les archives royales de Mari,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 66 (1959) 576–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Burns, R. J. "), _c('i', [_vm._v("Has the Lord Indeed Spoken Only Through Moses? A Study of the Biblical Portrait of Miriam")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 84. Atlanta: Scholars Press, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.21"
    }
  }), _vm._v("Burrows, E. "), _c('i', [_vm._v("The Oracles of Jacob and Balaam")]), _vm._v(". London: Burns, Oates and Washbourne, 1938.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Buttrick, G. A., et al., eds. "), _c('i', [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(". 4 vols. Nashville: Abingdon, 1962. "), _c('i', [_vm._v("Supplementary Volume")]), _vm._v(". Ed. K. Crim, et al. 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Canney, M. A. “Numbers 22:21–31,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 27 (1917) 568.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cassuto, U. "), _c('i', [_vm._v("The Documentary Hypothesis")]), _vm._v(". Tr. I. Abrahams. Jerusalem: Magnes, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cazelles, H. “David’s Monarchy and the Gibeonite Claim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 87 (1955) 165–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “La Dîme Israélite et les Textes de Ras Shamra,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 1 (1951) 131–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cheyne, T. K. “Some Critical Difficulties in the Chapters on Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 10 (1898–99) 399–402.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Childs, B. S. “The Etiological Tale Re-examined,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 24 (1974) 387–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Christensen, D. L. “Num. 21:14–15 and the Book of the Wars of Yahweh,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 36 (1974) 359–60.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Clark, R. E. D. “The Large Numbers in the Old Testament,” "), _c('i', [_vm._v("Journal of the Transactions of the Victoria Institute")]), _vm._v(" 87 (1955) 82–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Clines, D. J. A. "), _c('i', [_vm._v("The Theme of the Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 10. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Coats, G. W. “Balaam: Sinner or Saint?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.37"
    }
  }, [_vm._v("BR")])]), _vm._v(" 18 (1973) 21–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Conquest Traditions in the Wilderness Theme,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 177–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “An Exposition of the Wilderness Traditions,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 288–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Legendary Motifs in the Moses Death Reports,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 39 (1977) 34–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Moses in Midian,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 3–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Murmuring Motif in the Wilderness Traditions of the Old Testament: Rebellion in the Wilderness")]), _vm._v(". Nashville: Abingdon, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Wilderness Itinerary,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 34 (1972) 135–52.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Way of Obedience: Traditio-Historical and Hermeneutical Reflections on the Balaam Story,” "), _c('i', [_vm._v("Semeia")]), _vm._v(" 24 (1982) 53–79.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cody, A. "), _c('i', [_vm._v("A History of the Old Testament Priesthood")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.38"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 35. Rome: Pontifical Biblical Institute, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cook, F. C., and T. E. Espin. "), _c('i', [_vm._v("The Fourth Book of Moses Called Numbers")]), _vm._v(". The Holy Bible According to the Authorized Version. Vol. I/II. London: Murray, 1871.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Coppens, J. “Les Oracles de Bileam: Leur Origine Littéraire et leur Portée Prophétique.” In "), _c('i', [_vm._v("Mélanges Eugene Tisserant")]), _vm._v(". Ed. P. Hennequin et. al. Vol. 1. Cittá del Vaticano: Bibliotheca Apostolica Vaticana, 1964. Pp. 67–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.22"
    }
  }), _vm._v("Cox, S. "), _c('i', [_vm._v("Balaam: An Exposition and a Study")]), _vm._v(". London: Kegan Paul, Trench, 1884.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Craigie, P. C. “The Conquest and Early Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 20 (1969) 76–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cross, F. M. "), _c('i', [_vm._v("Canaanite Myth and Hebrew Epic")]), _vm._v(". Cambridge: Harvard Univ. Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Tabernacle in the Light of Recent Research.” In "), _c('i', [_vm._v("Temples and High Places in Biblical Times; Proceedings of the Colloquium in Honor of the Centennial of Hebrew Union College-Jewish Institute of Religion")]), _vm._v(". Jerusalem: Nelson Glueck School of Biblical Archaeology, 1981. Pp. 170–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Tabernacle,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 1–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cross, F. M., and G. E. Wright. “The Boundary and Province Lists of the Kingdom of Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 75 (1956) 202–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Daiches, S., “Balaam, a Babylonian "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bārû")]), _vm._v(": The Episode of Num 22:2–24:24 and Some Babylonian Parallels,” "), _c('i', [_vm._v("Assyriologische und Archaeologische Studien Hermann von Hilprecht gewidmet")]), _vm._v(" (Leipzig: Hinrichs, 1909), pp. 60–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("David, M. “Die Bestimmungen über die Asylstädte in Jos. 20,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.40"
    }
  }, [_vm._v("OTS")])]), _vm._v(" 9 (1951) 30–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davidson, A. B. "), _c('i', [_vm._v("Hebrew Syntax")]), _vm._v(". 3rd ed. Edinburgh: T. & T. Clark, 1902.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, E. W. “Inheritance Rights and the Hebrew Levirate Marriage,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 31 (1981) 138–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, G. I. "), _c('i', [_vm._v("The Way of the Wilderness: A Geographical Study of the Wilderness Itineraries in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.41"
    }
  }, [_vm._v("SOTSMS")]), _vm._v(" 5. Cambridge: Cambridge Univ. Press, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Wilderness Itineraries,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 25 (1974) 46–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dever, W. G. “The EB IV–MB I Horizon in Transjordan and Southern Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 210 (1973) 37–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("De Vries, S. J. “The Origin of the Murmuring Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 51–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Digges, M. L. “Balaam: A Man in a Corner,” "), _c('i', [_vm._v("Bible Today")]), _vm._v(" 13 (1964) 869–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dillmann, A. "), _c('i', [_vm._v("Die Bücher Numeri, Deuteronomium und Joshua")]), _vm._v(". Kurzgefasstes exegetisches Handbuch zum Alten Testament. 2nd ed. Leipzig: Hirzel, 1886.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Douglas, C. E. “The Twelve Houses of Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 37 (1936) 49–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Douglas, M. "), _c('i', [_vm._v("Purity and Danger: An Analysis of the Concepts of Pollution and Taboo")]), _vm._v(". London: Routledge and Kegan Paul, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Driver, G. R. “Two Problems in the Old Testament Examined in the Light of Assyriology,” "), _c('i', [_vm._v("Syria")]), _vm._v(" 33 (1956) 70–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, and J. C. Miles. “Ordeal by Oath at Nuzi,” "), _c('i', [_vm._v("Iraq")]), _vm._v(" 7 (1940) 132.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.23"
    }
  }), _vm._v("Driver, S. R. "), _c('i', [_vm._v("Introduction to the Literature of the Old Testament")]), _vm._v(". 12th ed. Oxford: Clarendon, 1906.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("A Treatise on the Use of the Tenses in Hebrew and Some Other Syntactical Questions")]), _vm._v(". 2nd ed. Oxford: Clarendon, 1881.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dumbrell, W. J. “Midian—A Land or a League?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 25 (1975) 323–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dus, J. “Herabfahrung Jahwes auf die Lade und Entziehung der Feuerwolke,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 290–311.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eichrodt, W. "), _c('i', [_vm._v("Theology of the Old Testament")]), _vm._v(". Tr. J. A. Baker. 2 vols. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.43"
    }
  }, [_vm._v("OTL")]), _vm._v(". Philadelphia: Westminster, 1961–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eising, H. “Balaams Eselin,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.44"
    }
  }, [_vm._v("BK")])]), _vm._v(" 13 (1958) 45–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Eissfeldt, O. "), _c('i', [_vm._v("Hexateuch-Synopse: Die Erzälung der fünf Bücher Mose und des Buches Josua mit dem Anfange des Richterbuches")]), _vm._v(". Leipzig: J. C. Hinrichs, 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Die Komposition der Bileam-Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 57 (1939) 212–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Old Testament: An Introduction")]), _vm._v(". Tr. P. Ackroyd. New York: Harper & Row, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Protektorat der Midianiter über ihre Nachbarn im letzten Viertel des 2. Jahrtausends v. Chr.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 383–93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sinai Erzählung und Bileamsprüche,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 32 (1961) 179–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Elhorst, H. J. “Das Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 30 (1910) 154–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Elliger, K. “Sinn und Ursprung der Priesterliche Geschichtserzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 49 (1952) 121–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Emerton, J. A. “Priests and Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 129–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Engnell, I. “Methodological Aspects of Old Testament Study,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 7. Leiden: Brill, 1960. Pp. 13–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Pentateuch.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". Tr. J. T. Willis. London: SPCK, 1970. Pp. 50–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Traditio-Historical Method in Old Testament Research.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". London: SPCK, 1970. Pp. 3–11")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Wilderness Wandering.” In "), _c('i', [_vm._v("Critical Essays on the Old Testament")]), _vm._v(". London: SPCK, 1970. Pp. 207–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Erdman, C. R. "), _c('i', [_vm._v("The Book of Numbers: An Exposition")]), _vm._v(". Westwood, N.J.: Revell, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fensham, F. C. “Malediction and Benediction in Ancient Near Eastern Vassal-Treaties and the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 74 (1962) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fichtner, J. “Die etymologische Ätiologie in den Namengebungen der geschichtlichen Bücher des Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 6 (1956) 372–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Finesinger, S. B. “Musical Instruments in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 3 (1926) 21–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Shofar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 8–9 (1931–32) 193–228.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.24"
    }
  }), _vm._v("Fisch, S. “The Book of Numbers.” In "), _c('i', [_vm._v("The Soncino Chumash: The Five Books of Moses with Haphtaroth")]), _vm._v(". Ed. A. Cohen. London: Soncino, 1947. Pp. 793–987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fishbane, M. “Accusations of Adultery: A Study of Law and Scribal Practice in Numbers 5:11–31,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 45 (1974) 25–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fisher, L. R. “A New Ritual Calendar from Ugarit,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.47"
    }
  }, [_vm._v("HTR")])]), _vm._v(" 63 (1970) 485–501.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Flack, E. E. “Flashes of New Knowledge, Recent Study and the Book of Numbers,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 3–23.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Flanagan, J. W. “History, Religion and Ideology: The Caleb Tradition,” "), _c('i', [_vm._v("Horizons")]), _vm._v(" 3 (1976) 175–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fohrer, G. "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". Tr. D. Green. Nashville: Abingdon, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Foote, T. C. “The Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 21 (1902) 1–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Franken, H. J. “Texts from the Persian Period from Tell Deir ‘Alla,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 17 (1967) 480–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Freedman, D. N. “Archaic Forms in Early Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 72 (1960) 101–7.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Pottery, Poetry, and Prophecy: An Essay on Biblical Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 96 (1977) 5–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fretheim, T. E. “The Priestly Document: Anti-Temple?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 313–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Frick, F. S. "), _c('i', [_vm._v("The City in Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(". Missoula, Mont.: Scholars Press, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Fritz, V. “Arad in der biblischen überlieferung und in der Liste Schoschenk I,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 82 (1966) 331–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Erwägungen zur Siedlungsgeschichte des Negeb in der Eisen 1-Zeit (1200–1000 v.Chr.) im Lichte der Ausgrabungen auf der "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ḥirbet el-Mšaš")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 91 (1975) 30–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Israel in der Wüste: Traditionsgeschichtliche Untersuchungen der Wüstenüberlieferung des Jahwisten")]), _vm._v(". Marburg: Elwert, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Frymer-Kensky, T. “The Strange Case of the Suspected Sotah (Numbers V 13–31),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 34 (1984) 11–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gaster, T. H. “The Name "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lēwî")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 38 (1937) 250–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gemser, B. “Der Stern au Jacob (Num. 24:17),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 45 (1925) 301–2.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gibson, J. C. L. "), _c('i', [_vm._v("Canaanite Myths and Legends")]), _vm._v(". 2nd ed. Edinburgh: T. & T. Clark, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gillischewski, E. “Die Geschichte von der ‘Rotte Korah’ Num. 16,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.49"
    }
  }, [_vm._v("AfO")])]), _vm._v(" 3 (1926) 114–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Glueck, N. “The Boundaries of Edom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 11 (1936) 141–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Civilisation of the Edomites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 10 (1947) 77–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Golka, F. W. “The aetiologies in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 410–28; 27 (1977) 36–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.25"
    }
  }), _vm._v("Gottwald, N. K. "), _c('i', [_vm._v("The Tribes of Yahweh")]), _vm._v(". Maryknoll, N.Y.: Orbis, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gowan, D. E. “The use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ya‘an")]), _vm._v(" in biblical Hebrew,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 21 (1971) 168–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gradwohl, R. “Das ‘fremde Feuer’ von Nadab und Abihu,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 75 (1963) 288–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gray, G. B. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.50"
    }
  }, [_vm._v("ICC")]), _vm._v(". Edinburgh: T. & T. Clark, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Nazirite,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 1 (1899–1900) 201–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Sacrifice in the Old Testament")]), _vm._v(". Oxford: Clarendon, 1925.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gray, J. “The Desert Sojourn of the Hebrews and the Sinai Horeb Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 148–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Legacy of Canaan: The Ras Shamra Texts and Their Relevance to the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 5. 2nd ed. Leiden: Brill, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Green, W. H. "), _c('i', [_vm._v("The Higher Criticism of the Pentateuch")]), _vm._v(". New York: Scribners, 1895.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Greenberg, M. “The Biblical Conception of Asylum,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 78 (1959) 125–32.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Idealism and Practicality in Numbers 35:4–5 and Ezekiel 48,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 88 (1968) 59–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A New Approach to the History of the Israelite Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 70 (1950) 41–46.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Greenstone, J. H. "), _c('i', [_vm._v("Numbers, with Commentary")]), _vm._v(". Philadelphia: Jewish Publication Society, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gressmann, H. "), _c('i', [_vm._v("Mose und Seine Zeit")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gross, W. "), _c('i', [_vm._v("Bileam: Literar- und Formkritische Untersuchung der Prosa im Num. 22–24")]), _vm._v(". Munich: Kösel, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “ ‘Ein Zepter wird sich erheben aus Israel’ (Num. 24:17): Die messianische Hoffnung im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.44"
    }
  }, [_vm._v("BK")])]), _vm._v(" 17 (1962) 34–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Guillaume, A. “A Note on Num. 23:10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 335–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gunn, D. M. “The ‘Battle Report’: Oral or Scribal Convention,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 93 (1974) 513–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gunneweg, A. H. J. "), _c('i', [_vm._v("Leviten und Priester")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Mose in Midian,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 61 (1964) 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Guyot, G. H. “Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 3 (1941) 235–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Prophecy of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 2 (1940) 330–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hackett, J. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.51"
    }
  }, [_vm._v("HSM")]), _vm._v(" 31. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Observations on the Balaam Text at Deir "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v("” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 49 (1986) 216–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Halpern, B. “Levitic Participation in the Reform Cult of Jeroboam I,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 31–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.26"
    }
  }), _vm._v("Hanson, H. E. “Num. XVI 30 and the meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bārā’")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 353–59.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Haran, M. “From Early to Classical Prophecy: Continuity and Change,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 385–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Levitical Cities: Utopia and Historical Reality,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 27 (1957–58) 421–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Nature of the ‘"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ohel mo‘edh")]), _vm._v("’ in Pentateuchal Sources,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 5 (1960) 50–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Passover Sacrifice.” In "), _c('i', [_vm._v("Studies in the Religion of Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 23. Leiden: Brill, 1972. Pp. 86–116.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Image of the Tabernacle,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 36 (1965) 191–226.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Studies in the Account of the Levitical Cities,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 80 (1961) 45–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Temples and Temple Service in Ancient Israel")]), _vm._v(". Oxford: Clarendon, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Uses of Incense in the Ancient Israelite Ritual,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 10 (1960) 113–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrelson, W. “Guidance in the Wilderness: The Theology of Numbers,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 24–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrison, R. K. "), _c('i', [_vm._v("Introduction to the Old Testament")]), _vm._v(". Grand Rapids: Eerdmans, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.52"
    }
  }, [_vm._v("WEC")]), _vm._v(". Chicago: Moody, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Heinisch, P. "), _c('i', [_vm._v("Das Buch Numeri, übersetzt und Erklärt")]), _vm._v(". Die Heilige Schrift des Alten Testament. Bonn: Hanstein, 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hempel, J. “Die israelitischen Anschauungen von Segen und Fluch im Lichte altorientalische Parallelen.” In "), _c('i', [_vm._v("Apoxsymata: Vorarbeiten zu einer Religionsgeschichte und Theologie des Alten Testaments")]), _vm._v(". Festgabe J. Hempel. Ed. W. Baumgartner, et al. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 81. Berlin: Töpelmann, 1961. Pp. 30–113.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Henke, O. “Zur Lage von Beth Peor,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 75 (1959) 155–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hertz, J. H. “Numbers 23:9b, 10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 45 (1933–34) 524.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hoftijzer, J. “The Prophet Balaam in a 6th Century Aramaic Inscription,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 11–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hoftijzer, J., and G. van der Kooij, eds. "), _c('i', [_vm._v("The Balaam Text from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _vm._v(" "), _c('i', [_vm._v("Re-Evaluated: Proceedings of the International Symposium held at Leiden, 21–24 August 1989")]), _vm._v(". Leiden: Brill, 1990. ("), _c('i', [_vm._v("Proceedings")]), _vm._v(", 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, eds. "), _c('i', [_vm._v("Aramaic Texts from Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Alla")]), _c('i', [_vm._v(". With Contributions by H. Franken, V. R. Mehra, J. Voskuil, J. A. Mosk. Preface by P. A. H. de Boer")]), _vm._v(". Documenta et Monumenta Orientis Antiqui 19. Leiden: Brill, 1976 ("), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.54"
    }
  }, [_vm._v("ATDA")])]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.27"
    }
  }), _vm._v("Holzinger, H. "), _c('i', [_vm._v("Numeri, Erklärt")]), _vm._v(". Kurzer Hand-Commentar zum Alten Testament 4. Tübingen: J. C. B. Mohr, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hooke, S. H. “Theory and Practice of Substitution,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 2 (1952) 2–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Horne, S. H. “The Excavations at Tell Hesban, 1973,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.55"
    }
  }, [_vm._v("ADAJ")])]), _vm._v(" 18 (1973) 87–88.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Horst, F. “Recht und Religion im Bereich des A.T.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.56"
    }
  }, [_vm._v("EvT")])]), _vm._v(" 16 (1956) 49–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hort, G. “The Death of Qorah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.57"
    }
  }, [_vm._v("AusBR")])]), _vm._v(" 7 (1959) 2–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hurvitz, A. “Evidence of Language in Dating the Priestly Code: A Linguistic Study in Technical Terms and Terminology,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 81 (1974) 24–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jacob, E. "), _c('i', [_vm._v("Theology of the Old Testament")]), _vm._v(". Tr. A. W. Heathcote and P. Allcock. New York: Harper & Row, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("James, E. O. "), _c('i', [_vm._v("The Ancient Gods: The History of the Diffusion of Religion in the Ancient Near East and the Eastern Mediterranean")]), _vm._v(". London: Weidenfeld and Nicholson, 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jirku, A. “Wo Stand Ursprünglich die Notiz über Hebron in Num. 13:22?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 39 (1921) 312.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Jobling, D. “The Jordan a Boundary: A Reading of Numbers 32 and Joshua 22.” In "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.58"
    }
  }, [_vm._v("SBLSP")]), _vm._v(", 1980. Ed. P. J. Achtemeier. Chico, Calif.: Scholars Press, 1980. Pp. 183–207.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Johnson, A. R. "), _c('i', [_vm._v("The Cultic Prophet in Ancient Israel")]), _vm._v(". Cardiff: Univ. of Wales, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Joines, K. R. “The Bronze Serpent in the Israelite Cult,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 87 (1968) 245–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Winged Serpents in Isaiah’s Inaugural Vision,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 86 (1967) 410–15.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Judge, H. G. “Aaron, Zadok, and Abiathar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" NS 7 (1956) 70–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kallai-Kleinmann, Z. “The Town Lists of Judah, Simeon, Benjamin, and Dan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 134–60.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kapelrud, A. “How Tradition Failed Moses,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 76 (1957) 242.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Ras Shamra Discoveries and the Old Testament")]), _vm._v(". Oxford: Blackwell, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kaufmann, Y. “Der Kalendar und der Priester-Kodex,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 307–13.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Religion of Israel")]), _vm._v(". Tr. and abridged by M. Greenberg. Chicago: Univ. of Chicago Press, 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kautzsch, E., ed. "), _c('i', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". 2nd ed. Tr. A. E. Cowley. Oxford: Clarendon, 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Keil, C. F. "), _c('i', [_vm._v("The Book of Numbers")]), _vm._v(". Biblical Commentary. Tr. J. Martin, et al. Edinburgh: T. & T. Clark, 1869.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kellermann, D. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’Āšam")]), _vm._v(" in Ugarit?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 76 (1964) 319–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Bermerkungen zum Sündopfergesetz in Num. 14:22ff.” In "), _c('i', [_vm._v("Wort und Geschichte: Festschrift für Karl Elliger zum 70. Geburtstag")]), _vm._v(". "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.28"
    }
  }), _vm._v("Ed. H. Gese and H. P. Rüger. Neukirchen: Kevelaer, 1973. Pp. 107–14.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Die Priesterschrift von Numeri 1, 1 bis 10, 10")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 120. Berlin: de Gruyter, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kennedy, A. R. S. "), _c('i', [_vm._v("Leviticus and Numbers")]), _vm._v(". New Century Bible. London: Caxton, n.d. Pp. 185–391.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kennett, R. H. “The Origin of the Aaronic Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 6 (1905) 161–86; 7 (1906) 620–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kosmala, H. “Form and Structure in Ancient Hebrew Poetry,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 423–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kraus, H.-J. “Zur Geschichte des Passah-Massot-Festes im AT,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.56"
    }
  }, [_vm._v("EvT")])]), _vm._v(" 18 (1958) 47–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kselman, J. S. “A note on Numbers 12:6–8,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 500–504.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kuschke, A. “Die Lagervorstellung der priesterschriftlichen Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 22 (1951) 74–105.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kutsch, E. “Erwägungen zur Geschichte der Passafeier und des Massotfestes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.45"
    }
  }, [_vm._v("ZTK")])]), _vm._v(" 55 (1958) 1–35.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lagrange, M. J. “L’Itinéraire des Israélites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 9 (1900) 63–86.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Latley, C. “Vicarious Solidarity in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 1 (1951) 267–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Laughlin, J. C. H. “The Strange Fire of Nadab and Abihu,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 559–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("LaVerdiere, E. A. “Balaam Son of Peor,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.59"
    }
  }, [_vm._v("TBT")])]), _vm._v(" 89 (1977) 1157–65.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lehmann, M. R. “Biblical Oaths,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 81 (1969) 74–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lehming, S. “Versuch zu Num. 16,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 74 (1962) 291–321.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Leiman, S. Z. “The Inverted "), _c('i', [_vm._v("Nuns")]), _vm._v(" at Num 10:35–36 and the Book of Eldad and Medad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 93 (1974) 348–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lemaire, A. “Le ‘Pays de Hépher’ et les ‘Files de Zelophehad’ à la lumière des ostraca de Samarie,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.60"
    }
  }, [_vm._v("Sem")])]), _vm._v(" 22 (1972) 13–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Levine, B. “The Descriptive Tabernacle Texts of the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 85 (1965) 307–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("In the Presence of the Lord: A Study of Cult and Some Cultic Terms in Ancient Israel")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 5. Leiden: Brill, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “More on the Inverted "), _c('i', [_vm._v("Nuns")]), _vm._v(" of Num 10:35–36,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 95 (1976) 122–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. The Plaster Inscriptions from "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(": General Interpretation.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 58–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Liebreich L. J. “The Songs of Ascents and the Priestly Blessing,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 74 (1955) 33–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lindblom, J. “Lot-casting in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 12 (1962) 164–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('span', {
    staticClass: "lang"
  }, [_vm._v("Lipiński")]), _vm._v(", E. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b’ḥryt hymym")]), _vm._v(" dans les textes préexiliques,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 445–50.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’Ūrîm")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Tummîm")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 495–96.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.29"
    }
  }), _vm._v("Liver, J. “Korah, Dathan, and Abiram.” In "), _c('i', [_vm._v("Studies in the Bible")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.62"
    }
  }, [_vm._v("ScrHier")]), _vm._v(" 8. Ed. C. Rabin. Jerusalem: Magnes, 1961. Pp. 189–217.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lock, W. “Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 2 (1901) 161–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loewe, H. “Numbers 22:6,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 26 (1914–15) 378.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loewenstamm, S. E. “The Death of Moses,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 27 (1957–58) 142–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lohfink, N. “Die Ursünden in der priesterlichen Geschichtserzählung.” In "), _c('i', [_vm._v("Die Zeit Jesu")]), _vm._v(". H. Schlier Festschrift. Ed. G. Bornkamm and K. Rahner. Freiburg: Herder, 1970. Pp. 38–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Löhr, M. “Bileam, Num. 22:2–24:25,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.49"
    }
  }, [_vm._v("AfO")])]), _vm._v(" 4 (1927) 85–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Long, B. O. “The Effect of Divination upon Israelite Literature,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 489–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of Etiological Narrative in the Old Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 108. Berlin: Töpelmann, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Loretz, O. “Die Herausführungsformel in Num. 23:22 und 24:8,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.63"
    }
  }, [_vm._v("UF")])]), _vm._v(" 7 (1975) 571–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lucas, A. “The Number of Israelites at the Time of the Exodus,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 76 (1944) 164–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McCarthy, D. J. “An Installation Genre?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 31–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Symbolism of Blood and Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 88 (1969) 166–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Further Notes on the Symbolism of Blood and Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 92 (1973) 205–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McEvenue, S. E. "), _c('i', [_vm._v("The Narrative Style of the Priestly Writer")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.38"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 50. Rome: Pontifical Biblical Institute, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mackay, C. “The North Boundary of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 35 (1934) 22–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McKeating, H. “The development of the law on homicide in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 25 (1975) 46–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mackensen, R. S. “The Present Form of the Balaam Stories.” In "), _c('i', [_vm._v("The MacDonald Presentation Volume")]), _vm._v(". Princeton: Books for Libraries Press, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("McNeile, A. H. "), _c('i', [_vm._v("The Book of Numbers in the Revised Version")]), _vm._v(". Cambridge Bible for Schools and Colleges. Cambridge: Cambridge Univ. Press, 1911.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("MacRae, G. W. “The Meaning and Evolution of the Feast of Tabernacles,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 22 (1960) 251–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Maier, J. “Urim und Tummim. Recht und Bund in der Spannung zwischen Königtum und Priestertum im alten Israel,” "), _c('i', [_vm._v("Kairos")]), _vm._v(" NF 11 (1969) 22–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Malina, B. J. "), _c('i', [_vm._v("The Palestinian Manna Tradition")]), _vm._v(". Leiden: Brill, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mann, T. W. “Theological Reflections on the Denial of Moses,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1979) 481–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Margaliot, M. “The Transgression of (Moses and) Aaron at Mey Merivah,” "), _c('i', [_vm._v("Beth Mikra")]), _vm._v(" 58 (1974) 375–400, 456.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.30"
    }
  }), _vm._v("Marsh, J. “Exegesis of the Book of Numbers.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.64"
    }
  }, [_vm._v("IB")])]), _vm._v(", 2. New York: Abingdon, 1953. Pp. 137–308.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Martin-Achard, R. "), _c('i', [_vm._v("Essai biblique sur les fêtes d’Israël")]), _vm._v(". Geneva: Labor et Fides, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mauchline, J. “The Balaam-Balak Songs and Saga.” In "), _c('i', [_vm._v("Studie Semitica et Orientalia. Vol. 2. Presentation volume to William Barron Stevenson")]), _vm._v(". Ed. J. C. Mullo-Weir. Glasgow: Glasgow Univ. Oriental Society, 1945.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Gilead and Gilgal: Some Reflections on the Israelite Occupation of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 6 (1956) 19–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("May, H. G. “The Relation of the Passover to the Feast of Unleavened Cakes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 55 (1936) 65–82.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mays, J. L. "), _c('i', [_vm._v("The Book of Leviticus, the Book of Numbers")]), _vm._v(". Layman’s Bible Commentary. Richmond: John Knox, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mazar, B. “The Cities of the Priests and Levites.” In "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.46"
    }
  }, [_vm._v("VTSup")]), _vm._v(" 7. Leiden: Brill. Pp. 193–205.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Sanctuary of Arad and the Family of Hobab the Kenite,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.33"
    }
  }, [_vm._v("JNES")])]), _vm._v(" 24 (1965) 297–303.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meek, T. J. “Aaronites and Zadokites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 45 (1929) 149–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Moses and Levites,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 56 (1939) 113–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Emendations in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 48 (1929) 167–68.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mendenhall, G. E. “The Census Lists of Numbers 1 and 26,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 77 (1959) 52–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “ ‘Change and Decay in All Around I See’: Conquest, Covenant, and "), _c('i', [_vm._v("The Tenth Generation")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 152–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Hebrew Conquest of Palestine,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 25 (1962) 66–87.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Tenth Generation")]), _vm._v(". Baltimore: Johns Hopkins Univ. Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meshel, Z., and C. Meyers. “The Name of God in the Wilderness of Zin,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 39 (1976) 6–10, 148–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meyers, C. L. "), _c('i', [_vm._v("The Tabernacle Menorah: A Synthetic Study of a Symbol from the Biblical Cult")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.66"
    }
  }, [_vm._v("AASOR")]), _vm._v(" 2. Missoula, Mont.: Scholars Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Milgrom, J. “Akkadian Confirmation of the Meaning of the Term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tĕrûmâ")]), _vm._v(",” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 44 (1974/75) 189. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 171–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Alleged Wave-offering in Israel and the Ancient Near East,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.67"
    }
  }, [_vm._v("IEJ")])]), _vm._v(" 22 (1972) 33–38. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 133–38.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Biblical Diet Laws as an Ethical System,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 17 (1963) 288–301. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 104–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Concerning Jeremiah’s Repudiation of Sacrifice,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 89 "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.31"
    }
  }), _vm._v("(1977) 274–75. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 119–21.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. Cult and Conscience: "), _c('i', [_vm._v("The")]), _vm._v(" asham "), _c('i', [_vm._v("and the Priestly Doctrine of Repentance")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 18. Leiden: Brill, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Cultic "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Š")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("gāgāh")]), _vm._v(" and Its Influence in Psalms and Job,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 58 (1967) 115–25. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology. Pp. 122–32")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šattĕnûpâ")]), _vm._v(".” In "), _c('i', [_vm._v("Zer Li’ gevurot")]), _vm._v(". Festschrift for Z. Shazar. Ed. B. Z. Luria. Jerusalem: Kiryat Sepher, 1972. Pp. 93–110. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 139–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Israel’s Sanctuary: The Priestly ‘Picture of Dorian Gray’,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 83 (1976) 390–99. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 75f–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The JPS Torah Commentary: Numbers Bemidbar")]), _vm._v(". Philadelphia/New York: The Jewish Publication Society, 5750/1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Literary Structure of Numbers 8:5–22 and the Levitic kippûr.” In "), _c('i', [_vm._v("Perspectives on Language and Text: Essays and Poems in Honor of Francis I. Andersen’s Sixtieth Birthday July 28, 1985")]), _vm._v(". Ed. E. Conrad and E. Newing. Winona Lake, Ind.: Eisenbrauns, 1987. Pp. 205–9.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Paradox of the Red Cow (Num. xix),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 31 (1981) 62–72. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 85–95.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Priestly Doctrine of Repentance,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 82 (1975) 186–205. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 47–66.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Priestly Terminology and the Political and Social Structure of Pre-Monarchic Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 69 (1978) 65–81. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 1–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Prolegomenon to Lev 17:11,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 149–56. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 96–103.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šôq hattĕrûmâ")]), _vm._v(": A Chapter in Cultic History,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 42 (1972–73) 1–14. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 159–70.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sin-offering or Purification-offering?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 21 (1971) 237–39. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 67–69.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.61"
    }
  }, [_vm._v("SJLA")]), _vm._v(" 36. Leiden: Brill, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Levitical Terminology")]), _vm._v(". Vol. I. University of California Publications, Near Eastern Studies 14. Berkeley: Univ. of California Press, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Kinds of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥaṭṭā’t")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 26 (1976) 333–37. Repr. in "), _c('i', [_vm._v("Studies in Cultic Theology and Terminology")]), _vm._v(". Pp. 70–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Miller, P. D. “The Blessing of God: An Interpretation of Numbers 6:22–27,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 29 (1975) 240–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.32"
    }
  }), _vm._v("Mitchell, T. C. “The meaning of the noun "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥtn")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 93–112.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mittmann, S. “Num. 20:14–21—eine radaktionelle Kompilation.” In "), _c('i', [_vm._v("Wort und Geschichte: Festschrift für Karl Elliger zum 70. Geburtstag")]), _vm._v(". Ed. H. Gese and H. P. Rüger. Neukirchen-Vluyn: Neukirchener, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Möhlenbrink, K. “Die levitischen überlieferungen des Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 52 (1934) 184–231.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moore, M. "), _c('i', [_vm._v("The Balaam Traditions: Their Character and Development")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 113. Atlanta: Scholars Press, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morgan, D. F. “The So-Called Cultic Calendars in the Pentateuch (Ex. 23:10–19, 34:18–26, Lev. 23, Nu. 28–29, Deut. 16:1–17). A Morphological and Typological Study.” Ph.D. diss., Claremont School of Theology, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morgenstern, J. "), _c('i', [_vm._v("The Ark, the Ephod, and the “Tent of Meeting.”")]), _vm._v(" Cincinnati: Hebrew Union College, 1945.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Chapter in the History of the High Priesthood,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.65"
    }
  }, [_vm._v("AJSL")])]), _vm._v(" 55 (1938) 1–24, 360–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Three Calendars of Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")])]), _vm._v(" 1 (1924) 13–78; 3 (1926) 77–107; 10 (1935) 1–148.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Trial by Ordeal among the Semites in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.23"
    }
  }, [_vm._v("HUCA")]), _vm._v(" Jubilee Volume")]), _vm._v(" (1925) 113–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Ancient Israelite Agricultural Festivals,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 8 (1917–18) 39–50.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mowinckel, S. "), _c('i', [_vm._v("Tetrateuch—Pentateuch—Hexateuch. Die Berichte über die Landnahme in den drei altisraelitischen Geschichtswerken")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 90. Berlin: Töpelmann, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Der Ursprung der Bileamsage,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 48 (1930) 233–71.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Müller, H.-P. “Die aramäische Inschrift von "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(" und die älteren Bileamsprüche.” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 94 (1982) 214–44.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Einige alttestamentliche Probleme zur aramäische Inschrift von "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(".” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 94 (1978) 56–67.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Mullen, E. T. "), _c('i', [_vm._v("The Assembly of the Gods: The Divine Council in Canaanite and Early Hebrew Literature")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.51"
    }
  }, [_vm._v("HSM")]), _vm._v(" 24. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Murtonen, A. “The Use and Meaning of the Words "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("L")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇarek")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("B")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rakah")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 9 (1959) 158–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nestlé, E. “Num. 23:19,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 28 (1908) 228–29.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Neusner, J. "), _c('i', [_vm._v("The Idea of Purity in Ancient Israel")]), _vm._v(". Leiden: Brill, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Newing, E. G. “The Rhetoric of Altercation in Numbers 14.” In "), _c('i', [_vm._v("Perspectives on Language and Text: Essays and Poems in Honor of Francis I. Andersen’s Sixtieth Birthday July 28, 1985")]), _vm._v(". Ed. E. Conrad and E. Newing. Winona Lake, Ind.: Eisenbrauns, 1987. Pp. 211–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.33"
    }
  }), _vm._v("Nielsen, E. “The Levites in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.69"
    }
  }, [_vm._v("ASTI")])]), _vm._v(" 3 (1964) 16–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Noordtzij, A. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Bible Student’s Commentary. Tr. E. van der Maas. Grand Rapids: Zondervan, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("North, F. “Aaron’s Rise in Prestige,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 66 (1954) 191–99.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Noth, M. "), _c('i', [_vm._v("A History of Pentateuchal Traditions")]), _vm._v(". Tr. B. W. Anderson. Englwood Cliffs, N.J.: Prentice-Hall, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Israelitische Stämme zwischen Ammon und Moab,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 60 (1944) 11–57.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Die Israelititischen Personennamen im Rahmen der Gemeinsemitischen Namengebung")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 3/10. Stuttgart: Kohlhammer, 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Laws in the Pentateuch and Other Essays")]), _vm._v(". Tr. D. R. Ap-Thomas. Philadelphia: Fortress, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Num. 21 als Glied der ‘Hexateuch’ Erzählung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 58 (1940–41) 161–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Numbers: A Commentary")]), _vm._v(". Tr. J. D. Martin. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.43"
    }
  }, [_vm._v("OTL")]), _vm._v(". Philadelphia: Westminster, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Das System der zwölf Stämme Israels")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.27"
    }
  }, [_vm._v("BWANT")]), _vm._v(" 4/1. Stuttgart: Kohlhammer, 1930.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Der Wallfahrtsweg zum Sinai,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.70"
    }
  }, [_vm._v("PJ")])]), _vm._v(" 36 (1940) 5–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nyberg, H. S. “Korahs Upror (Num. 16f.),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.136"
    }
  }, [_vm._v("SEÅ")])]), _vm._v(" 11 (1946) 214–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Olávarri, E. “Sondages à “Arô‘er sur l’Arnon,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 72 (1965) 77–94; 76 (1969) 230–59.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Olson, D. T. "), _c('i', [_vm._v("The Death of the Old and the Birth of the New: The Framework of the Book of Numbers and the Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.71"
    }
  }, [_vm._v("BJS")]), _vm._v(" 71. Chico, Calif.: Scholars Press, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Orlinsky, H. M. “Numbers XXVIII 9, 12, 13,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 500.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Rābas")]), _vm._v(" for "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Šākab")]), _vm._v(" in Num. 24:9,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 35 (1944–45) 173–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pákosdy, L. M. von. “Theologische Redaktionsarbeit in der BileamPerikope.” In "), _c('i', [_vm._v("Von Ugarit nach Qumran")]), _vm._v(". Festschrift for O. Eissfeldt. Ed. J. Hempel and L. Rost. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 77. Berlin: Töpelmann, 1958. Pp. 161–76.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Paradise, J. “A Daughter and Her Father’s Property at Nuzi,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.72"
    }
  }, [_vm._v("JCS")])]), _vm._v(" 32 (1980) 189–207.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Parker, I. “The Way of God and the Way of Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 17 (1905) 45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Parker, S. B. “Possession trance and prophecy in pre-exilic Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 271–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Paterson, J. A. "), _c('i', [_vm._v("Book of Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.73"
    }
  }, [_vm._v("SBOT")]), _vm._v(". Leipzig: Hinrichs, 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Patrick, D. "), _c('i', [_vm._v("Old Testament Law")]), _vm._v(". Atlanta: John Knox, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pedersen, J. "), _c('i', [_vm._v("Israel: Its Life and Culture")]), _vm._v(". 4 vols. repr. in 2. London: Oxford, 1926–40.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Perles, F. “Zu Numeri 24:23,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 29 (1909) 73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.34"
    }
  }), _vm._v("Péter, R. “L’imposition des mains dans l’Ancien Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 27 (1977) 48–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Petrie, W. M. F. "), _c('i', [_vm._v("Egypt and Israel")]), _vm._v(". New York: Macmillan, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Researches in Sinai")]), _vm._v(". London: Murray, 1906.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Phillips, A. “The Case of the Woodgatherer Reconsidered,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 125–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Porter, J. R. “The Role of Kadesh-barnea in the Narrative of the Exodus,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 44 (1943) 139–43.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Press, R. “Das Ordal im alten Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 51 (1933) 121–40, 227–55.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rabe, V. W. “The Origins of Prophecy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 221 (1976) 125–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rackman, E. “Jewish Philosophy of Property,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.68"
    }
  }, [_vm._v("JQR")])]), _vm._v(" 67 (1976–77) 65–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rad, G. von. "), _c('i', [_vm._v("Old Testament Theology")]), _vm._v(". Trans. D. Stalker. 2 vols. New York: Harper & Row, 1962, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Story about Balaam.” In "), _c('i', [_vm._v("God at Work in Israel")]), _vm._v(". Tr. J. Marks. Nashville: Abingdon, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rainey, A. F. “The Order of Sacrifices in Old Testament Ritual Texts,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 51 (1970) 485–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ramsay, G. W. “Speech Forms in Hebrew Law and Prophetic Oracles,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 96 (1977) 45–58.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Reif, S. C. “A note on a neglected connotation of "), _c('i', [_vm._v("ntn")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 20 (1970) 114–16.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “What Enraged Phinehas?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 90 (1971) 100–106.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rendtorff, R. "), _c('i', [_vm._v("Die Gesetze in der Priesterschrift: Eine Gattungsgeschichtlichen Untersuchung")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Traditio-historical Method and the Documentary Hypothesis,” "), _c('i', [_vm._v("Proceedings of the World Congress of Jewish Studies")]), _vm._v(" 5 (1969) 5–11.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Problem of the Process of Transmission in the Pentateuch")]), _vm._v(". Tr. J. Scullion. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 89. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1990. (Orig. "), _c('i', [_vm._v("Das überlieferungsgeschichtliche Problem des Pentateuch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 147. Berlin: de Gruyter, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Yahwist as Theologian: Dilemma of Pentateuchal Criticism,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")])]), _vm._v(" 3 (1977) 2–45.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zur Lage von Jaser,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.48"
    }
  }, [_vm._v("ZDPV")])]), _vm._v(" 76 (1960) 124–35.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Richter, G. “Die Einheitlichkeit der Geschichte von der Rotte Korah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 39 (1921) 123–37.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Riggans, W. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Daily Study Bible. Philadelphia: Westminster, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Roach, C. C. “The Camp in the Wilderness: A Sermon on Numbers 2:2,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 49–54.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robertson, E. “The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ūrīm")]), _vm._v(" and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṯummīm")]), _vm._v("; what were they?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 67–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.35"
    }
  }), _vm._v("Robinson, G. “The Prohibition of Strange Fire in Ancient Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 301–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rofé, A. "), _c('i', [_vm._v("The Book of Balaam")]), _vm._v(" (Hebrew). Jerusalem: Simor, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rost, L. “Fragen um Bileam.” "), _c('i', [_vm._v("Beiträge zur alttestamentlichen Theologie: Festschrift für Walther Zimmerli zum 70. Geburtstag")]), _vm._v(". Ed. H. Donner, et al. Göttingen: Vandenhoeck & Ruprecht, 1977. Pp. 377–87.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zu den Festopfervorschriften von Numeri 28 u. 29,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.75"
    }
  }, [_vm._v("TLZ")])]), _vm._v(" 83 (1958) 329–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rouillard, H. “L’ânesse de Balaam,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 87 (1980) 5–36.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Rowley, H. H. “Zadok and Nehushtan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 58 (1939) 113–41.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ruppert, L. “Das Motiv der Versuchung durch Gott in vordeuteronomistischer Tradition,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 55–63.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sabourin, L. “The Biblical Cloud: Terminology and Traditions,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.10"
    }
  }, [_vm._v("BTB")])]), _vm._v(" 4 (1974) 290–311.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sakenfeld, K. D. “The Problem of Divine Forgiveness in Num. 14,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 37 (1975) 317–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sasson, J. M. “A ‘Genealogical Convention’ in Biblical Chronography?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 90 (1978) 171–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Nu. 5 and the Waters of Judgment,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 16 (1972) 249–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Saydon, P. P. “Sin-Offering and Trespass-Offering,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 8 (1946) 393–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("St. Clair, G. “Israel in Camp: A Study,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.26"
    }
  }, [_vm._v("JTS")])]), _vm._v(" 8 (1907) 185–217.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Scharbert, J. “Fluchen und Segnen im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 39 (1958) 1–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schedl, C. “Biblische Zahlen unglaubwürdig?” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.77"
    }
  }, [_vm._v("TPQ")])]), _vm._v(" 107 (1959) 58–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, L. “Die alttestamentliche Bileamüberlieferung,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 23 (1979) 234–61.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, W. “"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miškan")]), _vm._v(" als Ausdruck Jerusalemer Kultsprache,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 75 (1963) 91–92.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schottroff, S. "), _c('i', [_vm._v("Der altisraelitische Fluchspruch")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.78"
    }
  }, [_vm._v("WMANT")]), _vm._v(" 30. Neukirchen: Kreis Moers, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schulz, H. "), _c('i', [_vm._v("Leviten im vorstaatlichen Israel und im Mittleren Osten")]), _vm._v(". Munich: Chr. Kaiser, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Das Todesricht im Alten Testament")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 114. Berlin: Töpelmann, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schunk, K.-D. "), _c('i', [_vm._v("Benjamin. Untersuchungen zur Entstehung und Geschichte eines israelitischen Stammes")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 86. Berlin: Töpelmann, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ophra, Ephron und Ephraim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 11 (1961) 188–200.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Seebass, H. “Num. xi, xii und die Hypothese des Jahwisten,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 28 (1978) 214–23.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Zu Num. X 33f.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 14 (1964) 111–13.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.36"
    }
  }), _vm._v("Segal, J. B. “The Hebrew Festivals and the Calendar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.28"
    }
  }, [_vm._v("JSS")])]), _vm._v(" 6 (1961) 74–94.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Hebrew Passover")]), _vm._v(". London: SPCK, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Intercalation and the Hebrew Calendar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 7 (1957) 250–307.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Pentateuch: Its Composition and Its Authorship and Other Studies")]), _vm._v(". Jerusalem: Magnes, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Settlement of Manasseh East of the Jordan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.79"
    }
  }, [_vm._v("PEFQS")])]), _vm._v(" 50 (1918) 124–31.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sellin, E. O. “Zu Efod und Terafim,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 55 (1937) 296–98.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Seybold, K. “Das Herrscherbild des Bileamorakels, Num. 24:15–19,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.76"
    }
  }, [_vm._v("BZ")])]), _vm._v(" 29 (1979) 1–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Simons, J. "), _c('i', [_vm._v("Geographical and Topographical Texts of the Old Testament")]), _vm._v(". Leiden: Brill, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Two Connected Problems Relating to the Israelite Settlement in Transjordan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 79 (1947) 27–39, 87–101.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Simpson, C. A. "), _c('i', [_vm._v("The Early Traditions of Israel")]), _vm._v(". Oxford: Blackwell, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smick, E. B. “A Study of the Structure of the Third Balaam Oracle (Num. 24:5–9).” In "), _c('i', [_vm._v("The Law and the Prophets: Old Testament Studies in Honor of Oswald T. Allis")]), _vm._v(". Ed. J. Skilton. Nutley, N.J.: Presbyterian & Reformed, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smith, W. R. "), _c('i', [_vm._v("The Religion of the Semites")]), _vm._v(". 2nd ed. London: Black, 1907.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Snaith, N. H. “The Daughters of Zelophehad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 124–27.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Hebrew New Year Festival")]), _vm._v(". London: SPCK, 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Leviticus and Numbers")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.80"
    }
  }, [_vm._v("NCBC")]), _vm._v(". London: Nelson, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Note on Numbers XVIII 9,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 373–75.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Numbers XXVIII 9, 11, 13,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 19 (1969) 374.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Sacrifices in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 7 (1957) 308–17.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Sin Offering and the Guilt Offering,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 15 (1965) 73–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Snijders, L. A. “The Meaning of "), _c('i', [_vm._v("‘zar’")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.40"
    }
  }, [_vm._v("OTS")])]), _vm._v(" 10 (1954) 1–154.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sonsino, R. "), _c('i', [_vm._v("Motive Clauses in Hebrew Law")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.35"
    }
  }, [_vm._v("SBLDS")]), _vm._v(" 45. Chico, Calif.: Scholars Press, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Speiser, E. A. “Census and Ritual Expiation in Mari and Israel.” In "), _c('i', [_vm._v("Biblical and Oriental Studies")]), _vm._v(". Ed. J. J. Finkelstein and M. Greenberg. Philadelphia: Univ. of Pennsylvania Press, 1967. Pp. 171–86.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Unrecognized Dedication,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.67"
    }
  }, [_vm._v("IEJ")])]), _vm._v(" 13 (1963) 69–73.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stade, B. “Die Eiferopferthora,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 15 (1895) 166–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stephens, F. J. “The Ancient Significance of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ṣiṣith")]), _vm._v(",” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 50 (1931) 59–71.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stevenson, W. R. “Hebrew Olah and Zebach Sacrifices.” In "), _c('i', [_vm._v("Festschrift für A. Bertholet")]), _vm._v(". Ed. W. Baumgartner, et al. Tübingen: Mohr, 1950. Pp. 488–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Strack, H. L. "), _c('i', [_vm._v("Die Bücher Genesis, Exodus, Leviticus und Numeri")]), _vm._v(". Kurzgefasster "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.37"
    }
  }), _vm._v("Kommentar zu den Heiligen Schriften Alten und Neuen Testamentes sowie zu den Apokryphen. Nordlingen: C. H. Beck, 1894.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sturdy, J. "), _c('i', [_vm._v("Numbers")]), _vm._v(". Cambridge Bible ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.81"
    }
  }, [_vm._v("NEB")]), _vm._v("). New York: Cambridge Univ. Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sumner, W. A. “Israel’s encounters with Edom, Moab, Ammon, Sihon, and Og according to the Deuteronomist,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 216–28.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sutcliffe, E. F. “De Unitate Litteraria Num. 22,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 7 (1926) 3–39.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “A Note on Num. 22,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.74"
    }
  }, [_vm._v("Bib")])]), _vm._v(" 18 (1937) 439–42.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Talmon, S. “Divergencies in Calendar Reckoning in Ephraim and Judah,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 8 (1958) 48–74.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thiersch, H. “Ependytes und Ephod,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 53 (1935) 180–85.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thomas, D. W. “The Word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rōḇaʿ")]), _vm._v(" in Numbers 23:10,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.36"
    }
  }, [_vm._v("ExpTim")])]), _vm._v(" 46 (1934–35) 285.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Some Further Remarks on Unusual Ways of Expressing the Superlative in Hebrew,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 18 (1968) 120–24.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson, H. C. “The Significance of the Term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’āsham")]), _vm._v(" in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.82"
    }
  }, [_vm._v("TGUOS")])]), _vm._v(" 14 (1953) 20–26.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson H. O. “The Ammonite Remains at Khirbet al-Hajjar,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.42"
    }
  }, [_vm._v("BASOR")])]), _vm._v(" 227 (1977) 27–34.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thompson, R. J. "), _c('i', [_vm._v("Moses and the Law in a Century of Criticism Since Graf")]), _vm._v(". Leiden: Brill, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Penitence and Sacrifice in Early Israel Outside the Levitical Law: An Examination of the Fellowship Theory of Early Israelite Sacrifice")]), _vm._v(". Leiden: Brill, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tosato, A. “The Literary Structure of the First Two Poems of Balaam (Num. 23:7–10, 18–24),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 29 (1979) 98–106.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tucker, G. M. “Covenant Forms and Contract Forms,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 15 (1965) 487–503.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tunyogi, A. C. “The Rebellions of Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 81 (1962) 385–90.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Rebellions of Israel")]), _vm._v(". Richmond: John Knox, 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tushingham, A. D. “The Excavations at Dibon (Dhiban) in Moab, the Third Campaign 1952–53,” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.66"
    }
  }, [_vm._v("AASOR")]), _vm._v(" 40 (1972) 93.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Urie, D. “Officials of the Cult at Ugarit,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.25"
    }
  }, [_vm._v("PEQ")])]), _vm._v(" 80 (1948) 42–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Valentin, H. "), _c('i', [_vm._v("Aaron. Eine Studie zur vorpriesterschriftlichen Aaron überlieferung")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van der Kooij. “Book and Script at Deir ‘Alla.” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 239–62.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van der Ploeg, J. “Studies in Hebrew Law,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 12 (1950) 248–59, 416–27; 13 (1951) 28–43, 164–71, 296–307.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("van Goudoever, J. "), _c('i', [_vm._v("Biblical Calendars")]), _vm._v(". Leiden: Brill, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Van Seters, J. “The Conquest of Sihon’s Kingdom: A Literary Examination,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 91 (1972) 182–97.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.38"
    }
  }), _vm._v("“Once Again: The Conquest of Sihon’s Kingdom,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 99 (1980) 117–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Recent Studies on the Pentateuch: A Crisis in Method,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 99 (1979) 663–72.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The terms ‘Amorite’ and ‘Hittite’,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 22 (1972) 64–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vaulx, J. de. "), _c('i', [_vm._v("Les Nombres")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.83"
    }
  }, [_vm._v("SB")]), _vm._v(". Paris: J. Gabalda, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vaux, R. de. "), _c('i', [_vm._v("Ancient Israel. Its Life and Institutions")]), _vm._v(". Tr. J. McHugh. 2 vols. London: Darton, Longman and Todd; New York: McGraw-Hill, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Ark of the Covenant and Tent of Reunion.” In "), _c('i', [_vm._v("The Bible and the Ancient Near East")]), _vm._v(". Tr. D. McHugh. Garden City, N.Y.: Doubleday, 1971. Pp. 136–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Early History of Israel")]), _vm._v(". Tr. D. Smith. Philadelphia: Westminster, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “L’Itinéraire des Israéliens de Cadès aux Plaines de Moab.” In "), _c('i', [_vm._v("Hommages à André Dupont–Sommer")]), _vm._v(". Ed. A. Caquot and M. Philonenko. Paris: Librairie d’Amerique et d’Orient, 1971. Pp. 136–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Notes d’histoire et de topographie transjordaniennes,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.24"
    }
  }, [_vm._v("RB")])]), _vm._v(" 50 (1941) 16–47.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Le Pays de Canaan,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 88 (1968) 23–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Reflections on the Present State of Pentateuchal Criticism.” In "), _c('i', [_vm._v("The Bible and the Ancient Near East")]), _vm._v(". Tr. D. McHugh. Garden City, N.Y.: Doubleday, 1971. Pp. 31–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Studies in Old Testament Sacrifice")]), _vm._v(". Tr. J. Bourke and R. Potter. Cardiff: Univ. of Wales Press, 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vermes, G. “The Story of Balaam: The Scriptural Origin of Haggadah.” In "), _c('i', [_vm._v("Scripture and Tradition in Judaism")]), _vm._v(". Leiden: Brill, 1955. Pp. 127–77.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Vetter, D. "), _c('i', [_vm._v("Seherspruch und Segensschilderung. Ausdruckabsichten und sprachliche Verwirklichungen in den Bileam-Sprüchen von Numeri 23 und 24")]), _vm._v(". Stuttgart: Calwer Verlag, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wagner, S. “Die Kundschaftergeschichten im Alten Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 76 (1964) 255–69.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Offenbarungsphänomenologische Elemente in der Bileam-Geschichte von Num. 22–24,” "), _c('i', [_vm._v("Theologische Versuche")]), _vm._v(" 5 (1975) 11–31.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Walsh, J. T. “From Egypt to Moab: A Source Critical Analysis of the Wilderness Itinerary,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.17"
    }
  }, [_vm._v("CBQ")])]), _vm._v(" 39 (1977) 20–33.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Walters, S. D. “Prophecy in Mari and Israel,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 89 (1970) 78–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wanke, G. "), _c('i', [_vm._v("Die Zionstheologie der Korachiten")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.53"
    }
  }, [_vm._v("BZAW")]), _vm._v(" 97. Berlin: Töpelmann, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Waterman, L. “Some Determining Factors in the Northward Progress of Levi,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.16"
    }
  }, [_vm._v("JAOS")])]), _vm._v(" 57 (1937) 375–80.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.39"
    }
  }), _vm._v("Watson, J. "), _c('i', [_vm._v("Leviticus-Numbers")]), _vm._v(". Expositor’s Bible. New York: Armstrong, 1903.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wefing, S. “Beobachtungen zum Ritual mit der roten Kuh (Num 19:1–10a),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 93 (1981) 341–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weinberg, J. P. “Das Beit ’Abot im Jh. v.u.Z.,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 400–414.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weingreen, J. “The Case of the Daughters of Zelophehad,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 518–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Case of the Woodgatherer (Numbers XV 32–36),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 16 (1966) 361–64.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weippert, H. “Das geographische System der Stämme Israels,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 23 (1973) 76–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weippert, M. "), _c('i', [_vm._v("The Settlement of the Israelite Tribes in Palestine")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.84"
    }
  }, [_vm._v("SBT")]), _vm._v(" 2/21. London: SCM, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Balaam Text from "), _c('i', [_vm._v("Deir")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘Allā")]), _vm._v(" and the Study of the Old Testament.” In "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.134"
    }
  }, [_vm._v("Proceedings, 1989")])]), _vm._v(". Pp. 151–84.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Weisman, Z. “The Biblical Nazirite, Its Types and Roots,” "), _c('i', [_vm._v("Tarbiz")]), _vm._v(" 36 (1967) 207–20.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wellhausen, J. "), _c('i', [_vm._v("Prolegomena to the History of Ancient Israel")]), _vm._v(". Tr. J. S. Black and A. Menzies. Gloucester, Mass.: Peter Smith, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wenham, G. J. "), _c('i', [_vm._v("Numbers: An Introduction and Commentary")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.85"
    }
  }, [_vm._v("TOTC")]), _vm._v(". Downers Grove: Inter-Varsity, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wenham, J. W. “Large Numbers in the Old Testament,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 18 (1967) 19–53.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westphal, G. “Aaron und die Aaroniden,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 26 (1906) 201–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wharton, J. A. “The Command to Bless: An Exposition of Numbers 22:41–23:25,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 13 (1959) 37–48.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Whybray, R. N. "), _c('i', [_vm._v("The Making of the Pentateuch: A Methodological Study")]), _vm._v(". "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.31"
    }
  }, [_vm._v("JSOTSup")]), _vm._v(" 53. Sheffield: "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.21"
    }
  }, [_vm._v("JSOT")]), _vm._v(" Press, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Williams, R. J. "), _c('i', [_vm._v("Hebrew Syntax")]), _vm._v(". 2nd ed. Toronto: Univ. of Toronto Press, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wilson, R. R. “Between ‘Azel’ and ‘Azel,’ Interpreting the Biblical Genealogies,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.14"
    }
  }, [_vm._v("BA")])]), _vm._v(" 42 (1979) 11–22.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("Genealogy and History in the Biblical World")]), _vm._v(". New Haven: Yale Univ. Press, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “Early Israelite Prophecy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.32"
    }
  }, [_vm._v("Int")])]), _vm._v(" 32 (1978) 3–16.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Old Testament Genealogies in Recent Research,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 94 (1965) 169–89.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wiseman, D. J. “Flying Serpents,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.39"
    }
  }, [_vm._v("TynBul")])]), _vm._v(" 23 (1972) 108–10.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wright, G. E. “The Levites in Deuteronomy,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.11"
    }
  }, [_vm._v("VT")])]), _vm._v(" 4 (1954) 325–30.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wright, G. R. H. “The Bronze Age Temple at Amman,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 78 (1966) 350–56.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wüst, M. "), _c('i', [_vm._v("Untersuchungen zu den siedlungsgeographischen Texten des Alten Testaments")]), _vm._v(". Vol. I: "), _c('i', [_vm._v("Ostjordanland")]), _vm._v(". Wiesbaden: Reichert, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.40"
    }
  }), _vm._v("Yahuda, A. S. “The Name of Balaam’s Homeland,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 64 (1945) 547–51.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zannoi, A. E. “Balaam: International Seer/Wizard Prophet,” "), _c('i', [_vm._v("St. Luke’s Journal of Theology")]), _vm._v(" 22 (1978) 5–19.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zohar, N. “Repentance and Purification: The Significance and Semantics of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥṭ’t")]), _vm._v(" in the Pentateuch,” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.12"
    }
  }, [_vm._v("JBL")])]), _vm._v(" 107 (1988) 609–18.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zuckschwerdt, E. “Zur literarischen Vorgeschichte des priesterlichen Nazir-Gesetzes (Num 6:1–8),” "), _c('i', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.20"
    }
  }, [_vm._v("ZAW")])]), _vm._v(" 88 (1976) 191–205.")])])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "TEXT"
    }
  }, [_c('p', {
    staticClass: "pt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.41"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rTEXT"
    }
  }, [_vm._v("Text and Commentary")])])])])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "NUM.I"
    }
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.42"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.43"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rNUM.I"
    }
  }, [_vm._v("I. Preparation for Departure ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("These chapters deal with the Hebrews’ preparation to leave Mt. Sinai for the land of promise. Since the events recounted here take place at Sinai, these chapters link with the material that has gone before in the books of Exodus and Leviticus.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.43.0040",
      "id": "FN.43.0040r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ The fact that the setup of the camp is given makes it clear that this material narrates the final preparation for departure, which occurs in what follows.")]), _vm._v(" "), _c('p', [_vm._v("At first glance these chapters may seem to be a miscellany, but closer attention reveals that the central theme around which they turn is holiness.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.43.0041",
      "id": "FN.43.0041r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ Although on one level these chapters simply narrate preparations to leave Sinai, on another level they show the importance of holiness in the camp (e.g., ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v("), in dealing with the tabernacle (e.g., chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–4")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:1–4")]), _vm._v("), and with various incidents in the life of the people (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:5–10")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–31")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("One may divide this unit into subsections in various ways. In this commentary the division comes between chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(", for ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" begins with a chronological indicator (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v("), ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v(" ends with a benediction (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22–27")]), _vm._v("), ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(" also begins with a chronological indicator (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v("), and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:10")]), _vm._v(" concludes with the statement "), _c('i', [_vm._v("I am Yahweh your God")]), _vm._v(", a typical concluding formula. Further, "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11")]), _vm._v(" begins with a new chronological note.")]), _vm._v(" "), _c('p', [_vm._v("That this unit has sources is undeniable. Those who adhere to the so-called documentary hypothesis along lines classically set down by J. Wellhausen would agree that Numbers comes from the P source. Other less hypothetical sources may underlie "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(", such as the lists of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.44"
    }
  }), _vm._v("names and of tribes, census lists, and legal enactments (or narratives about such enactments) found in the present text.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "NUM.I.A"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rNUM.I.A"
    }
  }, [_vm._v("A. Matters Concerning the People and the Camp ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–6:27")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "bhaft",
    attrs: {
      "id": "NUM.I.A.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0005#rNUM.I.A.1"
    }
  }, [_vm._v("1. The Censuses and the Arrangements of the March ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–4:49")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The first subsection deals with God’s people and their camp. In everything they are to be a holy nation. The first four chapters deal with the selection of Moses’ helpers, the first lay census, the marching order, and two Levitical censuses.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "NUM.I.A.1.A"
    }
  }, [_vm._v("a. First Lay Census ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–54")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "dhaft",
    attrs: {
      "id": "NUM.I.A.1.A.1"
    }
  }, [_vm._v("(1) The Leaders ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–16")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Yahweh spoke to Moses in the wilderness of Sinai, in the tent of meeting, on the first day﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.44.0042",
      "id": "FN.44.0042r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ of the second month in the second year after the exodus from the land of Egypt, saying")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("“Calculate the total of all the congregation of the children of Israel, as regards their clans, as regards their fathers’ houses, according to the number of their names, every male, individually")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("from twenty years old upward, all in Israel going out to the army, you will number them by their companies, you and Aaron.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("And with you shall be one man for each tribe,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.44.0043",
      "id": "FN.44.0043r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ each man head of his father’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("And these are the names of the men who will stand with you: From Reuben, Elizur the son of Shedeur;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("from Simeon, Shelumiel the son of Zurishaddai;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("from Judah, Nahshon the son of Amminadab;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("from Issachar, Nathanel the son of Zuar;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("from Zebulun, Eliab the son of Helon;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("from the sons of Joseph: from Ephraim, Elishama the son of Ammihud; from Manasseh, Gamaliel the son of Pedahzur;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.45"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("from Benjamin, Abidan the son of Gideoni;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("from Dan, Ahiezer the son of Ammishaddai;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("from Asher, Pegiel the son of Ochran;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("from Gad, Eliasaph the son of Deuel;﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.45.0044",
      "id": "FN.45.0044r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("from Naphtali, Ahira the son of Enan.”")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("These are the ones called﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.45.0045",
      "id": "FN.45.0045r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ from the congregation, exalted ones﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.45.0046",
      "id": "FN.45.0046r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ from their fathers’ tribes, heads of the clans of Israel.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")])]), _vm._v(" This verse gives the basic setting for what follows: who said it, to whom it was said, where it was said, and when it was said. First and foremost, these words are the words spoken by Yahweh himself to Moses the mediator. The plan was not one that Moses worked out, but one delivered to him by the revelation of God.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("wilderness")]), _vm._v(" (Heb. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miḏbār")]), _vm._v("). This translation (so "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.89"
    }
  }, [_vm._v("AV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.88"
    }
  }, [_vm._v("RV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(", etc.) seems preferable to “desert” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.87"
    }
  }, [_vm._v("NIV")]), _vm._v("). The latter connotes a land devoid of life and water, and this is not always the meaning of the Hebrew word, which refers to three kinds of country: pastureland (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 2:22")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Ps. 65:13")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("12")]), _vm._v("]), uninhabited land (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Job 38:26")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Jer. 2:24")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:1")]), _vm._v("), and large tracts of such land (e.g., “the wilderness of Judah,” "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 15:61–62")]), _vm._v("). Cities and towns could be located in the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miḏbār")]), _vm._v(" (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 15:61–62")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Isa. 42:11")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.45.0047",
      "id": "FN.45.0047r"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Sinai")]), _vm._v(". The people were still at the foot of the holy mountain (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 19:1")]), _vm._v("). The location of Mt. Sinai is debated among scholars. The "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.46"
    }
  }), _vm._v("traditional site is in the southern Sinai Peninsula at "), _c('span', {
    staticClass: "lang"
  }, [_vm._v("Jebel Mûsā")]), _vm._v(", which is part of a short ridge of granite, about 2"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub'), _vm._v(" mi. long, with "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ras eṣ-ṣafṣafeh")]), _vm._v(" at the northwest (about 6,500 ft. high) and "), _c('span', {
    staticClass: "lang"
  }, [_vm._v("Jebel Mûsā")]), _vm._v(" at the southeast (about 7,500 ft. high). Since Mt. Sinai is also called Horeb in the OT, some identify "), _c('span', {
    staticClass: "lang"
  }, [_vm._v("Jebel Mûsā")]), _vm._v(" with Sinai and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Ras-eṣ-ṣafṣafeh")]), _vm._v(" with Horeb. The probability is that Sinai and Horeb are synonyms. It is also possible that the author has the whole granite ridge in mind here.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.46.0048",
      "id": "FN.46.0048r"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', [_vm._v("Yahweh is said to have spoken "), _c('i', [_vm._v("in the tent of meeting")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ōhel mô‘ēḏ")]), _vm._v("). The word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mô‘ēḏ")]), _vm._v(" is derived from a verb meaning “to appoint” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("yā‘aḏ")]), _vm._v("). This tent may therefore be either the place “appointed” by God or the place of “appointment” with God (possibly both).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.46.0049",
      "id": "FN.46.0049r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ The tabernacle ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miškān")]), _vm._v(", from "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāḵan")]), _vm._v(", “to dwell”) is a tent shrine, which the Hebrews thought of as the temporary abode of God.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.46.0050",
      "id": "FN.46.0050r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ The tent of meeting may have preceded the tabernacle (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 33:7")]), _vm._v(", which refers to a time before the tabernacle was built).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.46.0051",
      "id": "FN.46.0051r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ The primary description of the Israelite tent shrine is found in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25–40")]), _vm._v(", where the tent shrine is called the “tent of meeting” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ōhel mô‘ēḏ")]), _vm._v(") 32 times and the “tabernacle” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miškān")]), _vm._v(") 49 times. These references do not seem to distinguish between these terms, and passages such as "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 39:39")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3:38")]), _vm._v(" suggest that the terms were considered synonymous at the time these books received their final form. The probability is, then, that the function and place of an earlier tent shrine (the tent of meeting) was absorbed into that of the tabernacle. It is at least possible that the two shrines coexisted for a time, but that either name may have been used for the tent shrine by the time of the final editing of the Pentateuch.")]), _vm._v(" "), _c('p', [_vm._v("A great deal of ink has been spilled over whether the tent of meeting (tabernacle) ever existed or was an idealization of the temple "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.47"
    }
  }), _vm._v("projected back into the wilderness period. The critical opinion of many scholars has shifted from the day when J. Wellhausen offered the critical orthodoxy: “hitherto it had only been "), _c('i', [_vm._v("asserted")]), _vm._v(" that the tabernacle rests on a historical fiction. In reality it is proved.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.47.0052",
      "id": "FN.47.0052r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Today, on the basis of the archeological discoveries of prefabricated tent shrines in ancient Egypt, and on a general reassessment of the monolinear evolutionary tenets of much of earlier scholarship, one cannot deny the possibility that the tabernacle could have existed in the Mosaic age.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.47.0053",
      "id": "FN.47.0053r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("The time of God’s speaking is placed at "), _c('i', [_vm._v("the first day of the second month in the second year after the exodus from the land of Egypt")]), _vm._v(". The chronological note at "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 10:11")]), _vm._v(" marks the twentieth day of the same month; that is, the time frame of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1–10:10")]), _vm._v(" is nineteen days. The events of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7:1–10:10")]), _vm._v(" take place one month earlier, on the day in which the tabernacle was set up. The Hebrews arrived at Sinai on the third new moon after the Exodus ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 19:1")]), _vm._v("), so they had been at the mountain some eleven months by the first day of the second month in the second year.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the exodus")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣē’ṯām")]), _vm._v(", lit., “their going out”). Two theories on the date of the Exodus are popular: the early (ca. 1445 B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(") and the late (ca. 1290 B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("). On balance the archeological evidence and historical data may be said to favor the later date, but the case is far from proved.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.47.0054",
      "id": "FN.47.0054r"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.48"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")])]), _vm._v(" "), _c('i', [_vm._v("Calculate the total")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ś")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’û ’eṯ–rō’š")]), _vm._v(", lit., “lift up the head”). The term "), _c('i', [_vm._v("head")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rō’š")]), _vm._v(") is used metaphorically for the “top” (e.g., of a mountain, "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 8:5")]), _vm._v("). The “sum” is the top amount of cumulative numbers, and so the meaning of “total” is not far from the spatial meaning of the word. The idiom is found elsewhere ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:12")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 5:24")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:49")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:2")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5:7")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:2")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:26")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("49")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Ps. 119:160")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("139:17")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Congregation")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ēḏâ")]), _vm._v(")—this term is related to the verb "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("yā‘aḏ")]), _vm._v(", “to appoint,” and the noun "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mô‘ēḏ")]), _vm._v(", “meeting.” It is found 149 times in the OT, just over half of these occurrences in the book of Numbers. Depending on the context, the exact make-up of the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ēḏâ")]), _vm._v(" varies. In the present verse the congregation is the whole people of Israel—men, women and children.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.48.0055",
      "id": "FN.48.0055r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ In other contexts, specific groups of Israelites, which nonetheless represent the whole people, are meant.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.48.0056",
      "id": "FN.48.0056r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ In places where "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ēḏâ")]), _vm._v(" means the whole people of Israel, it is synonymous with the term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qāhāl")]), _vm._v(" (“the assembly”; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:7")]), _vm._v("), but not when "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ēḏâ")]), _vm._v(" takes on the narrower meaning of a representative group.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.48.0057",
      "id": "FN.48.0057r"
    }
  }, [_vm._v("16")]), _vm._v("﻿ The legislative function of the congregation may be seen in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 35:12")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24–25")]), _vm._v(" as well as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 9:18–19")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:6")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:16")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Judg. 21:10")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 K. 12:20")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("clans")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišp")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥôṯ")]), _vm._v(") and "), _c('i', [_vm._v("fathers’ houses")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bêṯ ’āḇôṯ")]), _vm._v(") are tribal subdivisions, the larger being given first. The "), _c('i', [_vm._v("father’s house")]), _vm._v(" comes close to what might be described as a nuclear family: mother, father, brothers, sisters. The "), _c('i', [_vm._v("clan")]), _vm._v(" is a wider term, including other blood relatives as well. The widest term is “tribe” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maṭṭeh, šēḇeṭ")]), _vm._v("). Of course, the usage of all these terms varies in different contexts.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.48.0058",
      "id": "FN.48.0058r"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.49"
    }
  }), _c('i', [_vm._v("individually")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("l")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḡulg")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lōṯām")]), _vm._v(", lit., “with regard to their skulls”; viz., “with regard to themselves”). Since each person has only one skull, the idiom comes to refer to each individual.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.49.0059",
      "id": "FN.49.0059r"
    }
  }, [_vm._v("18")]), _vm._v("﻿ The command is to count the males of Israel, by clans, families, and right down to the individual names. The census is to be as complete as practical.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")])]), _vm._v(" The census is further defined by limiting it to males from twenty years of age and older—all, that is, who were eligible to serve in the army. The word "), _c('i', [_vm._v("army")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣāḇā’")]), _vm._v("; cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:48")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(") can mean “host” ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v("), or “war” or “battle” (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:3–4")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v("). Most scholars have seen the groups of Israelites designated as "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣāḇā’")]), _vm._v(" as military groups.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.49.0060",
      "id": "FN.49.0060r"
    }
  }, [_vm._v("19")]), _vm._v("﻿ Ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" consistently uses the term to refer to the community of Levites serving in the tent of meeting (e.g., vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30")]), _vm._v("). It is probable, however, that even in this matter the military image is to the fore, since the chief duty of the Levites is “guard duty” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar mišmereṯ")]), _vm._v("), as will be seen, e.g., in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:53")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:8")]), _vm._v(", etc. Since the military usage seems more common in Hebrew and the cognate languages, and since the age of an able-bodied male (twenty years) is included in the census instruction,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.49.0061",
      "id": "FN.49.0061r"
    }
  }, [_vm._v("20")]), _vm._v("﻿ the least that can be said is that the pattern used for this census was a military pattern. No doubt such a numbering would be invaluable in military planning.")]), _vm._v(" "), _c('p', [_vm._v("The census commanded here is not the first one during the stay at Sinai. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:11–16")]), _vm._v(" gives a command that when a census is taken, each one counted should be liable for a half-shekel assessment (to be used in the building of the tabernacle; see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 38:25–28")]), _vm._v("). One might simply assume that the two censuses were separate were it not that the total of persons counted in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38:26")]), _vm._v(" is 603,550, precisely the total given for the census in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:46")]), _vm._v(". These identical totals cannot merely be coincidental. These data have led some scholars to conclude that the command to take the census is given in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:11–16")]), _vm._v(" and that the census is not carried out until "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.49.0062",
      "id": "FN.49.0062r"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exodus 30:11")]), _vm._v(" has no command to take a census immediately. The command is that, “when you calculate the total of the children of Israel” ("), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.50"
    }
  }), _vm._v("i.e., when that time should come), then there must be a half-shekel redemption price paid for each person twenty and older who is counted. The text does not say that this counting was carried out immediately, but "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38:25–28")]), _vm._v(" does state that 603,550 people paid 100 talents and 1,775 shekels of silver for the fitting of the tabernacle.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.50.0063",
      "id": "FN.50.0063r"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', [_vm._v("Although biblical data on the chronology of this specific period are limited, there are difficulties in the assumption that the censuses of Exodus and Numbers are the same. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:1")]), _vm._v(" is dated one month after the tabernacle was erected (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 40:2")]), _vm._v("). "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 38")]), _vm._v(" indicates that the first census was completed and the redemption price levied in order to make fittings for the tabernacle. That census, of course, had to take place before the tabernacle was erected. Thus, on the chronology of the text itself, the two cannot be seen as the same event. The census of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30")]), _vm._v(" was concluded at least one month before the one in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(" was commanded, and probably some time before that. It is hard to believe that the final editor of the Pentateuch would not have smoothed out such differences if the intent had been to see the census command of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30")]), _vm._v(" carried out in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Another approach to the problem assumes that "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38")]), _vm._v(" are later insertions into the text derived from the book of Numbers or elsewhere. For example, Budd argues this way and states that "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38:21–31")]), _vm._v(" could have been from the hand of the author of Numbers.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.50.0064",
      "id": "FN.50.0064r"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', [_vm._v("It is, of course, true that the Pentateuch was edited together at a period after the events it narrates. It is also true that the Pentateuch is not arranged consistently in chronological order (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:1")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7:1")]), _vm._v("). Although theoretically the kind of editing Budd proposes may have occurred, one cannot demonstrate that it never took place. To say that "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 38:21–31")]), _vm._v(" is an insertion based on material in Numbers does not necessitate any greater distance from the events narrated than a time after the material in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 4")]), _vm._v(" (supposedly some time between the first and nineteenth days of the second year after the Exodus), although it may be later than this time by an indeterminate period.")]), _vm._v(" "), _c('p', [_vm._v("What does the final form of the text wish the reader to make of these two obviously related but separate censuses? They are similar in that they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.51"
    }
  }), _vm._v("give totals of Israelite males twenty years of age and up.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.51.0065",
      "id": "FN.51.0065r"
    }
  }, [_vm._v("24")]), _vm._v("﻿ But the purpose of the two seems different. The first has a religious purpose (a levy for the tabernacle), and the second an administrative or military purpose. The technique was also different. The first census reports only the grand total. The census in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(" numbers the people by tribe, clan, and father’s house, in addition to a count of individual names. That twelve leaders are appointed to help Moses and Aaron in this numbering indicates the much greater scope of this census. The total figure of the census checked with that of the earlier one, so that, although these countings were distinct, they were so close in time that they were related. Data from the first were probably used in the second. They stand as two halves of one act, the religious half (Exodus) and the military or administrative half (Numbers). Perhaps to remind the Israelites of the religious dimension of all life—even the supposedly administrative details—Aaron is included in the census of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")])]), _vm._v(" Twelve men were appointed to assist Moses and Aaron in the work of counting. God appointed one man from each tribe. Each one of these men was (at least) the head of his father’s house, the more immediate family group.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–16")])]), _vm._v(" These verses are nominal sentences that emphasize the names of the men involved. The nominal clause or sentence usually emphasizes the subject and expresses a constant condition.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.51.0066",
      "id": "FN.51.0066r"
    }
  }, [_vm._v("25")]), _vm._v("﻿ The function of these leaders, who are called "), _c('i', [_vm._v("exalted ones")]), _vm._v(" in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v(", is to lead the tribes, especially on the march (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:3–31")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:11–38")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The names of these same leaders are found again in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:3–31")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7:12–83")]), _vm._v("; and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14–27")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.51.0067",
      "id": "FN.51.0067r"
    }
  }, [_vm._v("26")]), _vm._v("﻿ Although the names are the same in these later lists, the order of the tribes is different. Numbers has seven lists of the Israelite tribes ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20–46")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:3–31")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7:12–83")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14–27")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13:4–16")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:5–62")]), _vm._v("), none of which includes the tribe of Levi.")]), _vm._v(" "), _c('p', [_vm._v("The listings of the tribes seem to have three different orders. Those narratives dealing with the choice of leaders ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13:4–16")]), _vm._v(") have similar orders,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.51.0068",
      "id": "FN.51.0068r"
    }
  }, [_vm._v("27")]), _vm._v("﻿ apparently based on a genealogical principle: the sons of Leah (minus Levi), followed by the sons of Rachel, followed by the sons "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.52"
    }
  }), _vm._v("of the two handmaidens Zilpah and Bilhah (the last in a flexible order).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.52.0069",
      "id": "FN.52.0069r"
    }
  }, [_vm._v("28")]), _vm._v("﻿ In the census lists ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–46")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:5–62")]), _vm._v(") Gad, the son of Zilpah (Leah’s handmaiden), takes the place of Leah’s son Levi. The census list of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–46")]), _vm._v(" (followed in most respects by that of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(") is set up to facilitate the division of the Israelites into four camps of three tribes each (as is accomplished in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v("). If the order of the old list in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(" were followed the result would be four camps (L = Leah’s sons; R = Rachel’s sons; HL = sons of Leah’s handmaid; HR = sons of Rachel’s handmaid):")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reuben (L)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Issachar (L)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Manasseh (R)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Asher (HL)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Simeon (L)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Zebulun (L)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Benjamin (R)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gad (HL)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Judah (L)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ephraim (R)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Dan (HR)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Naphtali (HR)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The sons of Rachel are thus split into two camps. If, however, one moves Gad up to the third place, as is done in the census list of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–46")]), _vm._v(", the following is the result:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Reuben")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Judah")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ephraim")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Dan")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Simeon")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Issachar")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Manasseh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Asher")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Gad")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Zebulun")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Benjamin")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Naphtali")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The camps are broken into two Leah groups, one Rachel group, and one handmaidens group. The marching order ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:3–31")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7:12–83")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14–27")]), _vm._v(") maintains the same basic four-group structure, except that pride of place on the east side of the tabernacle is given to the Judah-Issachar-Zebulun group.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.52.0070",
      "id": "FN.52.0070r"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', [_vm._v("Scholars have been divided on the question of which form of the list is original (i.e., presumably, which form is archetypal, the one from which all the others have been derived—not simply the first in order of appearance). Noth posits that ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" is the original form, while Mayes argues for the list in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.52.0071",
      "id": "FN.52.0071r"
    }
  }, [_vm._v("30")]), _vm._v("﻿ In addition to being captive to other critical "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.53"
    }
  }), _vm._v("presuppositions,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0072",
      "id": "FN.53.0072r"
    }
  }, [_vm._v("31")]), _vm._v("﻿ these views presuppose that all the lists derived from one original list in an “official” order. This assumption is not necessary. It seems as likely that, from ancient times, different orders existed for different purposes. The final form of the text reflects these different orders, and we have no objective way of getting behind this text. Therefore, "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(" is original only in the sense that it comes first in the book.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0073",
      "id": "FN.53.0073r"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', [_vm._v("The list of names in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–15")]), _vm._v(" contains quite a few theophoric elements (i.e., elements relating to God): "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ēl")]), _vm._v(" (God, 9 times), "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šaddāy")]), _vm._v(" (Almighty [?],﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0074",
      "id": "FN.53.0074r"
    }
  }, [_vm._v("33")]), _vm._v("﻿ 3 times), "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣûr")]), _vm._v(" (Rock, 3 times), "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’āḇ")]), _vm._v(" (Father, 2 times), "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’āḥ")]), _vm._v(" (Brother, 2 times). For many years Gray’s approach to this list has been the standard: “several of the names are unquestionably ancient, but the "), _c('i', [_vm._v("list")]), _vm._v(" is certainly unhistorical.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0075",
      "id": "FN.53.0075r"
    }
  }, [_vm._v("34")]), _vm._v("﻿ By contrast, Noth sees the list as an old traditional list of names that goes back to the time after the conquest.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0076",
      "id": "FN.53.0076r"
    }
  }, [_vm._v("35")]), _vm._v("﻿ Each one argues diligently for his own point of view on the basis of which kinds of grammatical constructions are found in “early” or “late” names, and which names have extrabiblical parallels in early and late periods of Hebrew history. From a literary perspective, however, it is very difficult to construct valid arguments for the date of a piece of literature in terms of vocabulary of any kind, especially proper names. Early names could be put into a late list by an editor. Furthermore, one can draw parallels only from the extant literature. What fraction of ancient Near Eastern literature has been discovered, and what fraction of what has been discovered has been deciphered? The argument from silence is a weak argument, which may be overturned by the next spade of dirt from the Near East. Nothing prohibits any of the names found in this list from appearing in a document of the late 2nd or early 1st millennium B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(", but there is also no proof that the list is ancient.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.53.0077",
      "id": "FN.53.0077r"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.54"
    }
  }), _vm._v("Both Noth and de Vaux have stated (but not explained in any detail) that "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–15")]), _vm._v(" (or "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v(") sits awkwardly in its context. This awkwardness, they claim, marks the list as an insertion in a later context.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.54.0078",
      "id": "FN.54.0078r"
    }
  }, [_vm._v("37")]), _vm._v("﻿ That a list of names is a free-standing composition that may be eliminated without doing a great deal of damage to the context is true. The same could be said of most lists both inside and outside the Bible. In fact, the text proceeds quite smoothly: God commands Moses and Aaron to take the census (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2–3")]), _vm._v("), God tells Moses (and Aaron) that twelve leaders will assist (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v("), God gives Moses and Aaron the names of the men he has chosen to assist them (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–15")]), _vm._v("), and a concluding formula rounds off the section (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v("). Much of the so-called roughness of the section may be attributed to the nominal sentences in which it is written, and which are, by nature, rather terse.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")])]), _vm._v(" These men, chosen by God to help with the census and lead the tribes, are described in three terms: "), _c('i', [_vm._v("called, exalted")]), _vm._v(", and "), _c('i', [_vm._v("head")]), _vm._v(". These persons are called out by God and chosen by him. They are also "), _c('i', [_vm._v("exalted ones from their fathers’ tribes")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("n")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("śî’ê maṭṭôṯ ’ăḇôṯām")]), _vm._v("). This expression indicates that the divine choice of these men exalted them from the tribes of their fathers (i.e., their ancestors). The phrase is unique. E. A. Speiser held that the term "), _c('i', [_vm._v("exalted one")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nāśî’")]), _vm._v(", from "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nāśā’")]), _vm._v(", “to lift up”) is a technical term for one who has been elevated in the assembly or elected to serve.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.54.0079",
      "id": "FN.54.0079r"
    }
  }, [_vm._v("38")]), _vm._v("﻿ This may well form the background of this technical term, although it is God who does the electing here.")]), _vm._v(" "), _c('p', [_vm._v("The function of these men who were called and exalted was to be "), _c('i', [_vm._v("heads of the clans of Israel")]), _vm._v(". The word "), _c('i', [_vm._v("clans")]), _vm._v(" here is not "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišp")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥôṯ")]), _vm._v(" (as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:2")]), _vm._v("), but "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’al")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ê")]), _vm._v(" (lit., “thousands”). That "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" may mean “company, clan,” is shown by "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Judg. 6:12")]), _vm._v(", which states that Gideon’s "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" (clan) is the weakest in Manasseh.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.54.0080",
      "id": "FN.54.0080r"
    }
  }, [_vm._v("39")]), _vm._v("﻿ Thus the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" may be equivalent to the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišp")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥâ")]), _vm._v(" in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(", but we do not know the exact size. One could imagine that the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" was larger than the father’s house and smaller than the (father’s) tribe. These leaders were to exercise their function by, first, assembling the people for the census ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:18")]), _vm._v("); second, leading in the encampment and departure of Israel (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:3")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10:14")]), _vm._v("); and, third, spying out the land of Canaan (although this was a different specific group, "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13:4")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "NUM.I.A.1.A.2"
    }
  }, [_vm._v("("), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.55"
    }
  }), _vm._v("2) The Census Itself ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:17–47")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("Numbers 1:17–46")]), _vm._v(" contains the story of the first lay census. The story has been prefaced by the appointment of leaders to help in the process (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4–16")]), _vm._v("). The passage is introduced in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–19")]), _vm._v(", followed by the heart of the passage, the census list itself in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20–43")]), _vm._v(". The passage closes with a summary in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44–46")]), _vm._v(". V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("47")]), _vm._v(" is a summary statement about the Levites’ census and forms a transition to vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("48–54")]), _vm._v(". The narrative passages that surround the list serve only to frame it.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "NUM.I.A.1.A.2.A"
    }
  }, [_vm._v("(a) Introduction ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:17–19")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("And Moses and Aaron took﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.55.0081",
      "id": "FN.55.0081r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ these men who had been designated by name,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("and they assembled the whole congregation on the first day of the second month, and they set down their family ancestry﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.55.0082",
      "id": "FN.55.0082r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ according to their fathers’ houses, by the number of names, from twenty years of age and up, one by one.")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("As Yahweh had commanded Moses, so he numbered them in the wilderness of Sinai.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The verb indicates that the leaders fulfilled God’s command to number themselves with regard to their tribal connections. Noth takes the verb to refer to the entering of the names in a register; this, although possible, is speculative.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.55.0083",
      "id": "FN.55.0083r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("Some scholars have posited that v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("19a")]), _vm._v(" "), _c('i', [_vm._v("(As Yahweh had commanded Moses")]), _vm._v(") should be connected to the end of v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18")]), _vm._v(" rather than starting a new thought.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.55.0084",
      "id": "FN.55.0084r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ Generally this formula concludes sections rather than "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.56"
    }
  }), _vm._v("beginning them (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 2:33")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:51")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8:3")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("15:36")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:11")]), _vm._v("). If this be true, then v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("19b")]), _vm._v(" "), _c('i', [_vm._v("(so he numbered them in the wilderness of Sinai")]), _vm._v(") should be taken as a preface to the list that follows.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.56.0085",
      "id": "FN.56.0085r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("In a sense all of vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–19")]), _vm._v(" form an introduction to the census list that follows in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20–46")]), _vm._v(". At the beginning and the end of this introduction (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("19")]), _vm._v(") only Moses is named as the recipient of God’s command, while in the detailed material (see vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17")]), _vm._v(") Aaron is also brought into the picture. This must mean that, while Moses was ultimately responsible to God for the execution of the census, Aaron (and the leaders as well) had a helping role. This is further evidence of the wisdom of the counsel given to Moses by his father-in-law in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 18:13–37")]), _vm._v(" to the effect that leadership tasks need to be shared.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "NUM.I.A.1.A.2.B"
    }
  }, [_vm._v("(b) The census lists ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–47")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("The sons of Reuben, firstborn of Israel, their family histories, by their clans, by their fathers’ houses, by the number of names, one by one﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.56.0086",
      "id": "FN.56.0086r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ every male from twenty years and upward, everyone who is eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("Those numbered from the tribe of Reuben: 46,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("As regards﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.56.0087",
      "id": "FN.56.0087r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ the sons of Simeon, their family histories, by their clans, by their fathers’ houses (those of his counting),﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.56.0088",
      "id": "FN.56.0088r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ by the number of names, one by one, every male from twenty years and upward, everyone who is eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("Those numbered from the tribe of Simeon: 59,300.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("As regards the sons of Gad, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone who is eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("Those numbered from the tribe of Gad: 46,500.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.56.0089",
      "id": "FN.56.0089r"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("As regards the sons of Judah, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.57"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("Those numbered from the tribe of Judah: 74,600.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("As regards the sons of Issachar, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("Those numbered from the tribe of Issachar: 54,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("As regards the sons of Zebulun, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("Those numbered from the tribe of Zebulun: 57,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("32")]), _vm._v("As regards the sons of Joseph: As regards the sons of Ephraim, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("33")]), _vm._v("Those numbered from the tribe of Ephraim: 40,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("34")]), _vm._v("As regards the sons of Manasseh, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("35")]), _vm._v("Those numbered from the tribe of Manasseh: 32,200.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("36")]), _vm._v("As regards the sons of Benjamin, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("37")]), _vm._v("Those numbered from the tribe of Benjamin: 35,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("38")]), _vm._v("As regards the sons of Dan, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("39")]), _vm._v("Those numbered from the tribe of Dan: 62,700.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("40")]), _vm._v("As regards the sons of Asher, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("41")]), _vm._v("Those numbered from the tribe of Asher: 41,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("42")]), _vm._v("As regards the sons of Naphtali, their family histories, by their clans, by their fathers’ houses, by the number of names, from twenty years and upward, everyone eligible to go in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("43")]), _vm._v("Those numbered from the tribe of Naphtali: 53,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("44")]), _vm._v("These are those persons numbered, who were numbered by Moses and Aaron—and also the exalted ones of Israel, twelve men, one man for each father’s house.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.57.0090",
      "id": "FN.57.0090r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.58"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("45")]), _vm._v("And all those who were numbered of the children of Israel—by their fathers’ houses, from twenty years and upward, everyone eligible to go in the army in Israel—")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("46")]), _vm._v("all those numbered totaled 603,550.")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("47")]), _vm._v("But the Levites were not numbered together with them by their fathers’ houses.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The individual census reports recorded here are all structured along the same lines: the name of the tribe and the total number are inserted into two formulae.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.58.0091",
      "id": "FN.58.0091r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ The first formula is based on the wording of vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2–3")]), _vm._v(". The second is: “those numbered of the tribe of x: (total number).” On the one hand, the redundancy of the formulae is just what one would expect in a list. On the other hand, the small variations that do occur introduce a small amount of literary variety.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.58.0092",
      "id": "FN.58.0092r"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("20–44")])]), _vm._v(" The contents of this list are rather straightforward. The major difference from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(" is that Gad is moved from eleventh to third place.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.58.0093",
      "id": "FN.58.0093r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ The "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" is unsure of where to place Gad. In the current census document Gad is in ninth place (after Benjamin), while in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" he is in sixth place (after Zebulun). At the very least this shows that the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" translator was unsure of the criterion by which Gad had been moved from eleventh place in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:14")]), _vm._v(" to third in the current list. In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:5–16")]), _vm._v(" and in chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(", and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10")]), _vm._v(", the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" follows the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(" in the order of the tribes—even in putting Gad in sixth place. It is likely that because Gad is in sixth place in the lists of chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(", and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10")]), _vm._v(", he is placed sixth also in the census list of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.58.0094",
      "id": "FN.58.0094r"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', [_vm._v("With the slight exception of Gad (son of Leah’s handmaiden), the list in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–46")]), _vm._v(" still proceeds in a more-or-less chronological fashion, with "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.59"
    }
  }), _vm._v("the sons of Leah first, the sons of Rachel second, and the sons of the handmaidens third. Thus, Reuben, the firstborn, initiates this list (and the other census list, as well as the lists for the selection of leaders). He is replaced by Judah in those lists that deal with the arrangement of the camp or the march.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("their family histories")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tôl")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏōṯām")]), _vm._v(") is found in each of the sections (e.g., vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")]), _vm._v("). This word may have been suggested by the denominative verb “to set down a family ancestry” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hiṯyallaḏ")]), _vm._v(") in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18")]), _vm._v(". Both words go back to the root "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("yld")]), _vm._v(", “bear a child.” The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("tôl")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏôṯ")]), _vm._v(" include the genealogical descent of a family, and this is no doubt the emphasis here. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṯôl")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏôṯ")]), _vm._v(" is used in Genesis to indicate the histories of the origins of particular patriarchal families.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.59.0095",
      "id": "FN.59.0095r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ Here the term is likely a replacement for “tribe” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maṭṭeh")]), _vm._v("), the widest family connection, tracing the family line back to one of the sons of Jacob the patriarch. This judgment is confirmed by the fact that the rest of the designations are arranged from the larger to the smaller units.")]), _vm._v(" "), _c('p', [_vm._v("In sections dealing with Reuben and Simeon the phrase "), _c('i', [_vm._v("one by one")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("gulg")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lōṯām")]), _vm._v(") clarifies the phrase "), _c('i', [_vm._v("by the number of names")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mispār šēmôṯ")]), _vm._v("). The people are counted by the number of their names, viz., individually. Since the "), _c('i', [_vm._v("one by one")]), _vm._v(" does not occur after v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(", one may assume that the compiler of the list felt confident that readers would take for granted after that point that "), _c('i', [_vm._v("by the number of names")]), _vm._v(" meant one by one.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("45–47")])]), _vm._v(" These verses continue the conclusion of the unit. The words "), _c('i', [_vm._v("fathers’ houses")]), _vm._v(" is picked up from v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44")]), _vm._v(" and used in a way more strictly appropriate to it as “an extended family.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.59.0096",
      "id": "FN.59.0096r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Phrases on the acceptable age limit and eligibility for military service are repeated here. These repetitions round off the unit (see vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("32")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("36")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("42")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("603,500—The compiler of the present text simply added the total of people found in the attached twelve tribal census reports to get this total. The same procedure is used in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(". After the period of the wilderness wandering the total was 601,730, a difference of 1,280 people.")]), _vm._v(" "), _c('p', [_vm._v("V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("47")]), _vm._v(" forms a brief summary and transition to the section on the excepting of the Levites from the general census process (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:48–54")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "sh",
    attrs: {
      "id": "NUM.I.A.1.A.EXCURSUS"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.60"
    }
  }), _vm._v("Excursus on Large Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The numbers in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:20–46")]), _vm._v(" appear rather straightforward. The totals are clear and there are no significant textual problems. The only problem is that these numbers (just over 600,000 fighting men) seem much too large for a variety of reasons. We meet the issue of large numbers in the Bible as early as, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 5:5")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11")]), _vm._v(", etc., in the ages given for Adam, Seth, Enosh, etc. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 12:37")]), _vm._v(" reports that 600,000 “men on foot, besides women and children,” came out of Egypt. After our text the Chronicler reports that the combined figures for Israel and Judah at the time of David was 1,570,000 men ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 21:5")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Some evangelical scholars have held that the easiest solution is simply to take the numbers at their face values, as the compiler of the present text (and others) obviously has done, since simple addition of the totals for the individual tribes yields the same grand total as in the text.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.60.0097",
      "id": "FN.60.0097r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ But this solution is not without problems, and the problems are real and persistent. Here is a selection of them:")]), _vm._v(" "), _c('p', [_vm._v("(1) Such a number of males from twenty years of age and up would give a total populace of about two to two and one-half million. It is hard to believe that such a number could be sustained for forty years in the wilderness without constant, day-to-day, miraculous intervention. The miraculous intervention and provision that do occur seem to be the exception rather than the rule (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 11")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("(2) Such a number would have, indeed, caused Egypt’s Pharaoh consternation, for not only would there have been very little room for them in Egypt, but a group of this size could likely have taken over Egypt with or without weapons.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.60.0098",
      "id": "FN.60.0098r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ They would hardly have had to fear Pharaoh’s army, which was probably at most about 20,000 men.")]), _vm._v(" "), _c('p', [_vm._v("(3) Current estimates of the population of Canaan at the time of the Exodus are well below three million. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 23:29")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 7:7")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(" indicate that the Israelites were far fewer in number than the Canaanite population that they were to conquer.")]), _vm._v(" "), _c('p', [_vm._v("(4) It is well known that two midwives are said to have served the entire number of Hebrews ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 1:15")]), _vm._v("), that the entire number could gather "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.61"
    }
  }), _vm._v("around the tent of meeting to hear Moses ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 16:9")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("19:17")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33:18")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 1:1")]), _vm._v("; etc.), and that the whole number could march around Jericho seven times in one day ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 6:15")]), _vm._v(") with enough time left in the day to fight a battle.")]), _vm._v(" "), _c('p', [_vm._v("(5) According to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3:40–43")]), _vm._v(" the number of firstborn males among the people was 22,273, out of a population of about 600,000 adult males. This is a ratio of about "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:1")]), _vm._v(". This means that a firstborn male must had had, on average, 26 brothers, not to mention sisters. Unless polygamy was the common practice in this period (and no evidence suggests that it was), this kind of ratio is not likely on a wide scale.")]), _vm._v(" "), _c('p', [_vm._v("(6) Such a massive group would have taken up a great deal of space on the march, especially when one considers their animals and possessions.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.61.0099",
      "id": "FN.61.0099r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_vm._v("This group of problems has been admitted by scholars across the theological spectrum.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.61.0100",
      "id": "FN.61.0100r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ In the light of these, and other obvious and serious problems, various scholars have attempted to understand these figures in a way that does not take them at face value. Some of the options have included the following.")]), _vm._v(" "), _c('p', [_vm._v("(1) One group of scholars has held that these figures and others throughout the OT are fabrications of the author or compiler of the material. The numbers have no relation to fact.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.61.0101",
      "id": "FN.61.0101r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ Why these tables of figures should have been invented in just this way is not clear, and the impression is often given that solutions grow more from the minds of modern scholars than from a treatment of ancient texts in their own worlds.")]), _vm._v(" "), _c('p', [_vm._v("(2) A second group of scholars has held that the numbers in the text are fairly accurate for a later date in Israel’s history, and have been transposed to the wilderness period to show that, in a theological sense, all Israel was present.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.61.0102",
      "id": "FN.61.0102r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ G. Wenham holds that the figures in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" would still be high for David’s time.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.61.0103",
      "id": "FN.61.0103r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ But the biblical figures in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2 Sam. 24:9")]), _vm._v(" are 800,000 warriors for Israel and 500,000 for Judah, while, as reported above, the Chronicler’s figures are 1,100,000 for Israel and "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.62"
    }
  }), _vm._v("470,000 for Judah ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 21:5")]), _vm._v("). "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2 K. 15:19–20")]), _vm._v(" reports that King Menahem of Israel (ca. 738 B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(") paid Pul (Tiglath-pileser III) of Assyria 1,000 talents of silver by assessing all the wealthy men of the land 50 shekels apiece. A talent equals 3,000 shekels. Thus there must have been about 60,000 men of means in Israel toward the end of the 8th century.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.62.0104",
      "id": "FN.62.0104r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ The relationship of the figures in such a passage as "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2 K. 15:19–20")]), _vm._v(" to the figures in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" is unclear, but it is known that Israel was quite well-off during the years of Jeroboam II (ca. 782–753 B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("; see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Amos 6:1–7")]), _vm._v("), so that the number of wealthy men in Israel might well have been higher at that time than in some other periods. But these figures do not enhance one’s confidence in the figures in Numbers.")]), _vm._v(" "), _c('p', [_vm._v("(3) Other scholars have seen the numbers as symbolic in some way. Some see the figures as partaking of gematria, that is, making the numbers represent a name or a saying by their combined numerical values.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.62.0105",
      "id": "FN.62.0105r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ For example, using a system (widely used after the Maccabean age) wherein the first nine letters of the Hebrew alphabet represented the units, the next nine the tens, and the last four the hundreds, G. Fohrer derives the number 603 from the letters of the words “the sons of Israel” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("bny yśr’l")]), _vm._v("), which is then multiplied by 1,000.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.62.0106",
      "id": "FN.62.0106r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ The words “every head” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("kl r’š")]), _vm._v(") give a total of 551. The two numbers added together give a total of 603,551, which is then rounded off to the appropriate 603,550.")]), _vm._v(" "), _c('p', [_vm._v("The weaknesses of such an approach are multiple. (a) There is no reason why the first set of numbers should be multiplied by 1,000 other than the fact that one needs to do so to come out with the desired number. (b) There is no clear reason why certain Hebrew words are treated in this way in this case (or in any other), other than the fact that they make the theory work. In fact, the last number does not work, but has to be rounded off. In cases like this one, one might as well round off many numbers as one. (c) Even the words that are chosen work only for the total of 603,550 in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:46")]), _vm._v(". They do not work for the total in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 26")]), _vm._v(". It is also difficult to relate these symbolic totals to the various individual tribal totals. (d) Although some have claimed to derive meaning from a few other biblical texts by using gematria (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 14:14")]), _vm._v("), virtually the only clear example of such is "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Rev. 13:18")]), _vm._v(", with the mysterious meaning of 666.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.62.0107",
      "id": "FN.62.0107r"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.63"
    }
  }), _vm._v("(e) The common Hebrew system of representing numbers by successive letters of the alphabet, as mentioned above, is not the only possible system that could have been used. In later times, the Jewish Kabbala used no fewer than nine systems based on the Hebrew alphabet.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0108",
      "id": "FN.63.0108r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ (f) The first extant examples of the commonly used system of numerical equivalents are not until the 2nd cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" "), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0109",
      "id": "FN.63.0109r"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', [_vm._v("M. Barnouin has proposed a different symbolic key based on Near Eastern mathematics and astronomy. His system is carefully worked out, but seems more clever than convincing. It is doubtful whether persons in ancient Israel would have been able to get this meaning from the text. Most certainly, it is not plainly in the text.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0110",
      "id": "FN.63.0110r"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("(4) The other proposed solutions have in common the feature that they take Heb. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(", translated in most English versions as “thousand,” in some other sense, thus considerably reducing the numbers involved. The first to suggest such a solution appears to be W. M. Flinders Petrie.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0111",
      "id": "FN.63.0111r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ He held that the consonants "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(" could also be translated as “group” or “clan” (as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Sam. 10:19")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Judg. 6:15")]), _vm._v("; etc.).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0112",
      "id": "FN.63.0112r"
    }
  }, [_vm._v("16")]), _vm._v("﻿ Thus, for Reuben, whose tribe has “forty-six "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" and five hundred,” one should read forty-six “groups” with a total of five hundred men. This leads to a grand total of 5,550 men in 598 groups in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(", and 5,730 men in 596 groups in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 26")]), _vm._v(". These numbers are reasonable amounts of fighting men, and would be an adequate size to answer the problems set out at the beginning of this excursus. Although many problems may be solved by using this system, not all are. Flinders Petrie himself admitted that his system did not have all the answers. For example, this system does not work for the Levites, who would have twenty-two groups with a total of no men. Flinders Petrie treated the narratives dealing with the Levites as later additions to the text.")]), _vm._v(" "), _c('p', [_vm._v("In 1958 G. Mendenhall refined and updated the Flinders Petrie hypothesis.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.63.0113",
      "id": "FN.63.0113r"
    }
  }, [_vm._v("17")]), _vm._v("﻿ Mendenhall used materials from Mari especially to hold that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.64"
    }
  }), _vm._v("the census lists of chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" contained the quotas of contingents sent to war from each group rather than the whole number of fighting men.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.64.0114",
      "id": "FN.64.0114r"
    }
  }, [_vm._v("18")]), _vm._v("﻿ He then used the Flinders Petrie hypothesis ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp =")]), _vm._v(" “tribal division”). The same term was used to describe both the tribal subsection itself and the fighting units levied from that tribal subsection. Mendenhall’s numbers are therefore the same as those of Flinders Petrie. He does give a different explanation of the figures, as has been seen. These tribal subsections varied in size from about five men for Simeon to about fourteen for Gad in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1")]), _vm._v(". The figures in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v(" range from about five men for Issachar to about seventeen for Reuben. According to Mendenhall the tendency toward larger subsections in the latter passage shows that the texts are in the right order.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.64.0115",
      "id": "FN.64.0115r"
    }
  }, [_vm._v("19")]), _vm._v("﻿ Mendenhall dated the census lists in the period of the Judges.")]), _vm._v(" "), _c('p', [_vm._v("The Flinders Petrie/Mendenhall solution has much to commend it, although one may differ on points of detail, such as date. The most serious objection to the theory is that it does not deal with the number of the Levites either in chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–4")]), _vm._v(" or in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:57–62")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("N. Gottwald assumed much in the Flinders Petrie/Mendenhall hypothesis. He gave some of the Hebrew terms content related to their social functions. Secondary social divisions begin with the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišpāḥâ")]), _vm._v(", “a protective association of extended families.” The "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" is simply “men at arms.” A number of men are mustered from each group, and this group is called an "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(". Other times an "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" seems equivalent to a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišpāḥâ")]), _vm._v(", but with a different social function. Gottwald assumes, with Mendenhall, that the P traditionist misunderstood the term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" as “thousand” instead of a tribal unit.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.64.0116",
      "id": "FN.64.0116r"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_vm._v("J. W. Wenham argued that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(" may not only be vocalized as "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ele")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(", but also as "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allu")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(", “chieftain,” as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 36:15")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.64.0117",
      "id": "FN.64.0117r"
    }
  }, [_vm._v("21")]), _vm._v("﻿ Wenham criticized Flinders Petrie and Mendenhall: “If the numbers of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ăla")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("îm")]), _vm._v(" and the numbers of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("me’ôṯ")]), _vm._v(" are two different ways of saying the same thing, there should be at least some correspondence between them.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.64.0118",
      "id": "FN.64.0118r"
    }
  }, [_vm._v("22")]), _vm._v("﻿ This is not the case. The “group” numbers vary from as few as five to as many as seventeen, as was seen above. Wenham set up a rather complicated scheme for figuring out the number of “captains” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allû")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("îm")]), _vm._v(") and the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.65"
    }
  }), _vm._v("number of units ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mē’ôṯ")]), _vm._v("). For example, Reuben has forty-five "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allû")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("îm")]), _vm._v(" and 1,500 men, Simeon has fifty-seven "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allû")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("îm")]), _vm._v(" and 2,300 men. Wenham’s work, based on R. E. D. Clark’s theory, gives a steady number of between two and three leaders per unit.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.65.0119",
      "id": "FN.65.0119r"
    }
  }, [_vm._v("23")]), _vm._v("﻿ He considered an "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allû")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" to be a specially trained warrior who would be either a captain of a contingent of one hundred or a captain of a contingent of fifty men. In his scheme some "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’allû")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("îm")]), _vm._v(" would be left over to act as captains of the contingents of one thousand or as “super-numerary captains of fifty.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.65.0120",
      "id": "FN.65.0120r"
    }
  }, [_vm._v("24")]), _vm._v("﻿ The total fighting force would be about 18,000 men on this reckoning, and the total population about 72,000. This compares with the 2–2"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub'), _vm._v(" million of the text on face value, about 20,000 in the Flinders Petrie/Mendenhall scheme, and about 140,000 on R. E. D. Clark’s theory.")]), _vm._v(" "), _c('p', [_vm._v("The problem of the Levites must be worked out another way. The difficulty is that the Levites have 22,000 men according to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3:39")]), _vm._v(". As pointed out above, this would be read as twenty-two groups of no men each. Obviously something is amiss. That the Levites’ census must be worked out in another way from the semimilitary census of the lay tribes is not a surprise, since the Levites were not to go to war but to serve the religious needs of the community. It does not seem reasonable to expect "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(" to mean either “trained warrior” (J. Wenham) or “tribal subsection” (Flinders Petrie, Mendenhall). J. Wenham explained the number of Levites by noting that biblical texts are often corrupted by the simple addition of zeros to the numbers.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.65.0121",
      "id": "FN.65.0121r"
    }
  }, [_vm._v("25")]), _vm._v("﻿ If, in fact, this is the case in the book of Numbers, the total figure should read 2,200 Levite males. This amount compares favorably to the other tribes.")]), _vm._v(" "), _c('p', [_vm._v("What can be said in conclusion? No one system answers all the questions or solves all the problems. Rather than assuming this complex (mis-)use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(", one might be better served to assume that a zero needs to be dropped from all the figures involved. This would give a fighting strength of 60,355 and a total population of between 200,000 and 250,000 (still quite high by ancient standards).﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.65.0122",
      "id": "FN.65.0122r"
    }
  }, [_vm._v("26")]), _vm._v("﻿ The flaw in this suggestion is that "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.66"
    }
  }), _vm._v("the mistake in zeros would easily occur only where numbers were represented by figures rather than by words. We have little or no evidence that figures were used in the biblical texts during the biblical period.")]), _vm._v(" "), _c('p', [_vm._v("A weak point in all the solutions that understand "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(" as “tribal subgroup” is that the text of Numbers understands it as “thousand.” The editor simply totals the figures to get 603,550. Using the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp =")]), _vm._v(" “group” solution, the total is (according to Flinders Petrie and Mendenhall) 598 groups of 5,550 men. To understand "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’lp")]), _vm._v(" in any other way than “thousand” assumes a misunderstanding and mistransmission of the text in all the census lists of Exodus and Numbers (not to mention other texts). Since both the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(" and the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.135"
    }
  }, [_vm._v("Sam. Pent.")]), _vm._v(" basically agree with the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.7"
    }
  }, [_vm._v("MT")]), _vm._v(", the misunderstanding must have taken place as early as the 5th or 4th cent. B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C.")]), _vm._v(" "), _c('p', [_vm._v("In short, we lack the materials in the text to solve this problem. When all is said and done one must admit that the answer is elusive. Perhaps it is best to take these numbers as R. K. Harrison has done—as based on a system familiar to the ancients but unknown to moderns. According to Harrison the figures are to be taken as “symbols of relative power, triumph, importance, and the like and are not meant to be understood either strictly literally or as extant in a corrupt textual form.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.66.0123",
      "id": "FN.66.0123r"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "NUM.I.A.1.A.3"
    }
  }, [_vm._v("(3) Levites Are Excepted ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:48–54")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("48")]), _c('i', [_vm._v("And Yahweh spoke to Moses, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("49")]), _vm._v("“Only﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.66.0124",
      "id": "FN.66.0124r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ the tribe of Levi you will not number, you will not calculate their total among the children of Israel;")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("50")]), _vm._v("rather, you appoint the Levites over the tabernacle of the testimony and over all its vessels and over all that pertains to it. They are to carry the tabernacle and all its vessels, and they are to attend to it and encamp around the tabernacle.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("51")]), _vm._v("When the tabernacle is to move, the Levites will take it down, and when the tabernacle is to be erected, the Levites will put it up. The unauthorized party who encroaches will be put to death.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("52")]), _vm._v("And the children of Israel shall make camp, each one beside his encampment, and each one beside his standard, by their armies.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.67"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("53")]), _vm._v("And the Levites will encamp around the tabernacle of the testimony that there should be no wrath against the congregation of the children of Israel. And the Levites will guard the tabernacle of the testimony.”")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("54")]), _vm._v("The children of Israel did so; according to all that Yahweh commanded Moses, so they did.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This section is an expansion of the previous verse. It explains why the Levites have no place in the previous two lists. They have been set aside for special treatment and will therefore have a special census. Instead of going into the army, the Levites will serve by carrying, attending, and guarding the tabernacle. The tabernacle was the place where God met the people and was thus a holy place. Humans were not ordinarily in the holy sphere. Thus special persons (the Levites) had to be set apart (appointed), by God through Moses, to do the work of the service of the tabernacle. The Levitical camp surrounded the tabernacle so that that which was holy did not contact that which was unclean. The specific plan for setting up the Levitical camp is given in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:21–39")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("50")])]), _vm._v(" "), _c('i', [_vm._v("you appoint")]), _vm._v(". The pronoun emphasizes that Moses is personally to appoint these Levites. The verb "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pāqaḏ")]), _vm._v(" has the sense “to appoint” here; it is the same verb translated “number” earlier in the chapter.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.67.0125",
      "id": "FN.67.0125r"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the tabernacle of the testimony")]), _vm._v(" is, in this text, identical with the tent of meeting ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:1")]), _vm._v("). The structure is also called the tent of the testimony in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9:15")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:22–23")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:2")]), _vm._v("; and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2 Chr. 24:6")]), _vm._v(". Similar phrases are “the ark of the testimony,” “the tables of the testimony,” and “the veil of the testimony.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.67.0126",
      "id": "FN.67.0126r"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("testimony")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ēḏâ")]), _vm._v(") is related to the root "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘wd")]), _vm._v(", which has to do with repetition. A testimony is that which affirms the continuing relevance of something through repetition.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.67.0127",
      "id": "FN.67.0127r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ The particular testimony in mind here may be the written law of God (e.g., the Decalogue), which acted as a repeated testimony or witness to God’s covenant with Israel.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.67.0128",
      "id": "FN.67.0128r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ Also the tent, the ark, and the veil are themselves all testimonies that speak of God and his desire "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.68"
    }
  }), _vm._v("to have a people unto himself, his election of his people in Egypt, and his covenant at Sinai.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.68.0129",
      "id": "FN.68.0129r"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("51")])]), _vm._v(" When the tabernacle is to be moved the Levites are to do the dismantling and reconstruction. They are appointed as guardians over all the paraphernalia of the tabernacle. Any "), _c('i', [_vm._v("unauthorized party")]), _vm._v(" or “stranger” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("zār")]), _vm._v("), in this case a non-Levite, who approaches in order to usurp the role of guardian over these holy things will be put to death by the Levitical guards.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.68.0130",
      "id": "FN.68.0130r"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("52")])]), _vm._v(" The Israelites are to encamp by tribal groups (see ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v("), "), _c('i', [_vm._v("each one beside his standard")]), _vm._v(". The traditional interpretation of "), _c('i', [_vm._v("standard")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("deḡel")]), _vm._v(") has been a colored flag to designate each group. Rashi thought that each flag was a color matched to a stone in the high priest’s breastplate (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 28:17–21")]), _vm._v("). Ibn Ezra saw each flag with a different symbol: Reuben, a man; Judah, a lion; etc.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.68.0131",
      "id": "FN.68.0131r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ We have no idea on what basis these comments were made. Gray preferred to translate "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("deḡel")]), _vm._v(" as “company” on the basis of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.1"
    }
  }, [_vm._v("LXX")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.90"
    }
  }, [_vm._v("Pesh")]), _vm._v("., and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.91"
    }
  }, [_vm._v("Targ")]), _vm._v(". renderings.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.68.0132",
      "id": "FN.68.0132r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ The only occurrence of the related verbal form ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dāḡal")]), _vm._v(") is a passive participle in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Cant. 5:10")]), _vm._v(", usually translated as “conspicuous,” or “easily distinguished.” In the light of this related form and the cognate Akkadian verb "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dagālu")]), _vm._v(", “to see,” the traditional translation seems preferable.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.69"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("53")])]), _vm._v(" The Levites were to form a cordon around the tabernacle in order to keep other Israelites from coming in contact with the holy objects housed in it. If anyone were to encroach upon the holy precinct, the wrath of God would be let loose on the whole camp. In the incident with Korah (ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v("), the wrath of God goes forth in the form of a plague that strikes the whole people.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.69.0133",
      "id": "FN.69.0133r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ This result may also be seen in the incident with the Philistines in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Sam. 5:6–12")]), _vm._v(". The Levites’ duty was to keep the wrath of God from striking all concerned, whether primarily guilty or not.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.69.0134",
      "id": "FN.69.0134r"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', [_vm._v("Therefore the main task of the Levites was to "), _c('i', [_vm._v("guard")]), _vm._v(" the tabernacle. Jacob Milgrom has shown that the expression "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar mišmereṯ")]), _vm._v(" meant “guard duty.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.69.0135",
      "id": "FN.69.0135r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ The Levites were known as a warlike tribe (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 49:5–7")]), _vm._v("); they were charged with the execution of 3,000 men who had sinned by worshiping the golden calf ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 32:25–29")]), _vm._v("). It is not surprising that the same term ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṣāḇā’")]), _vm._v(") is used of their service (which included guarding the tabernacle) and the military service of the rest of the tribes ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:23")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The actual setup of the camp, with the Levites around the tabernacle, is not related until ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v("; the Levites’ other tasks regarding the tabernacle are not set out until chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(". The intention of this section is only to summarize why the Levites are not involved in the lay census (they have been appointed to special service) and the primary task involved in this special service (guarding the tabernacle, thus keeping the camp safe).")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "NUM.I.A.1.B"
    }
  }, [_vm._v("b. Placement of the Camp and Marching Order ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2:1–34")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("And Yahweh spoke to Moses and to Aaron, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("“Let the children of Israel encamp, each man by his standard, with the standards of their fathers’ houses. They shall encamp at a distance from the tent of meeting, on every side.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("Those who are to camp to the east, toward the sunrise, are to be of the standard of the camp of Judah, by their armies. And the leader of the sons of Judah was Nahshon the son of Amminadab.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("His host, that is, those numbered: 74,600.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("And encamping next to him were those of the tribe of Issachar. And the leader of the sons of Issachar was Nethanel the son of Zuar.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.70"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("His host, that is, those numbered: 54,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("[Then]﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.70.0136",
      "id": "FN.70.0136r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ the tribe of Zebulun; and the leader of the sons of Zebulun was Eliab the son of Helon.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("His host, that is, those numbered: 57,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("All those numbered, by their hosts, in the camp of Judah: 186,400. They are the first to depart.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("The standard of the camp of Reuben, by their hosts, is to be to the south. And the leader of the sons of Reuben was Elizur the son of Shedeur.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And his host, that is, those numbered: 46,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("And encamping next to him were those of the tribe of Simeon. And the leader of the sons of Simeon was Shelumiel the son of Zurishaddai.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("And his host, that is, those numbered: 59,300.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("Then the tribe of Gad, and the leader of the sons of Gad was Eliasaph the son of Deuel.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.70.0137",
      "id": "FN.70.0137r"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("And his host, that is, those numbered: 46,650.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("All those numbered, by their hosts, in the camp of Reuben: 151,450. They are the second to depart.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("Then the tent of meeting is to depart, the camp of the Levites being in the midst of the camps. As they encamped, so they are to depart, each one in his place, by their standards.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("The standard of the camp of Ephraim, by their hosts, is to be to the west. And the leader of the sons of Ephraim was Elishama the son of Ammihud.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("And his host, that is, those numbered: 40,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("And encamping next to him were those of the tribe of Manasseh. And the leader of Manasseh was Gamaliel the son of Pedahzur.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("And his host, that is, those numbered: 23,200.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Then the tribe of Benjamin, and the leader of the sons of Benjamin was Abidan the son of Gideoni.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("And his host, that is, those numbered: 35,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("All those numbered, by their hosts, in the camp of Ephraim: 108,100.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.71"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("The standard of the camp of Dan, by their hosts, is to be to the north. And the leader of the sons of Dan was Ahiezer the son of Ammishaddai.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("And his hosts, that is, those numbered: 62,700.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("And encamping next to him were those of the tribe of Asher. And the leader of the sons of Asher was Pagiel the son of Ochran.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("And his host, that is, those numbered: 41,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("Then the tribe of Naphtali, and the leader of the sons of Naphtali was Ahira the son of Enan.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("And his host, that is, those numbered: 53,400.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("All those numbered, by their hosts, in the camp of Dan: 157,600. They shall depart in the last place, by their standards.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("32")]), _vm._v("These were those numbered of the children of Israel, by their fathers’ houses, all those numbered in the camps, by their hosts: 603,550.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("33")]), _vm._v("But the Levites were not counted among the children of Israel. Just as Yahweh had commanded Moses,")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("34")]), _vm._v("so the children of Israel did. According to all that Yahweh commanded Moses, they encamped by their standards, and they departed the same way, each one by his clans, according to his father’s house.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(" uses the figures developed in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(" (hence once again, the reader is faced with the problem of large numbers)﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.71.0138",
      "id": "FN.71.0138r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ and gives the formation of the camp and the order of departure for the march. The arrangement of the tribes differs slightly from ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(". The tribal group belonging to Judah (Judah, Issachar, and Zebulun) are moved from the fourth, fifth, and sixth places to the first, second, and third.")]), _vm._v(" "), _c('p', [_vm._v("The east side is the natural place to begin because that is the side in which the opening into the tabernacle was placed, and thus the way into the presence of God. The east was generally the primary direction in the ancient Near East. Since it is the direction of the rising sun, it is usually called the “front” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qdm")]), _vm._v(") or the direction of “the dawn” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mzrḥ")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.71.0139",
      "id": "FN.71.0139r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ From this basic (and common) eastward orientation, one would proceed to one’s right hand (the south), one’s back (the west), and one’s left hand (the north). This is the pattern of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.71.0140",
      "id": "FN.71.0140r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("But why should Judah’s group be moved from its place as found "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.72"
    }
  }), _vm._v("in the census document of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:20–46")]), _vm._v("? One possibility is that the author of this passage wished, for his own theological reasons, to emphasize the preeminence of Judah. This solution is common among those who analyze and explain the Pentateuch along the lines of the documentary hypothesis. This passage belongs to source stratum P. The provenance of P is usually thought to be the Babylonian diaspora,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0141",
      "id": "FN.72.0141r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ at a time when any thought of preeminence for a group other than Judah was impossible. P was concerned to elevate the status of Judah.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0142",
      "id": "FN.72.0142r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ Looking back on the history of Israel from the standpoint of the Exile, one can see that the kingdom of Judah (and hence the tribe of Judah) was the one that had become preeminent. This passage is an attempt to show that this postexilic preeminence had a theological basis in the Mosaic age.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0143",
      "id": "FN.72.0143r"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_vm._v("Another approach assumes that Judah comes first in this list simply because his group did encamp on the east side of the tabernacle. Judah and his host are given the first place because of the prophecy in the Testament of Jacob ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 49:8–12")]), _vm._v("), which, in spite of its many obscurities, clearly gives Judah preeminence over his brothers. The same passage associates Issachar and Zebulun with Judah as they are in the current passage. Everyone agrees that the Testament of Jacob is earlier than the list here in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 2")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0144",
      "id": "FN.72.0144r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ It could easily have provided the theological rationale for giving Judah and his camp the first place at the east side of the tabernacle.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0145",
      "id": "FN.72.0145r"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("A simpler solution than either of these commends itself here. Judah was allowed pride of place on the east with Aaron and the priests because its census figures are the largest of any of the tribes and its camp was also the largest.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.72.0146",
      "id": "FN.72.0146r"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–2")])]), _vm._v(" In the introduction to the chapter, God gives the command "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.73"
    }
  }), _vm._v("to place the camp in a certain order. Once again, the biblical author sees a detail of administration as the direct command and will of the Almighty. The formula "), _c('i', [_vm._v("And Yahweh spoke to Moses (and to Aaron), saying")]), _vm._v(", commonly begins a unit in the book of Numbers.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.73.0147",
      "id": "FN.73.0147r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("The tribes are to encamp by their "), _c('i', [_vm._v("standard")]), _vm._v(", which is the flag or banner marking off each camp of three tribes.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.73.0148",
      "id": "FN.73.0148r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ They are also to encamp "), _c('i', [_vm._v("with the ensigns of their fathers’ houses")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ōṯōṯ l")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇêṯ ’ăḇōṯām")]), _vm._v("). The "), _c('i', [_vm._v("ensign")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ôṯ")]), _vm._v(") means a “sign” or “token,” and must be some sort of insignia of a father’s house. The simplest way of visualizing the camp is to picture each of the four subcamps gathered under a "), _c('i', [_vm._v("standard")]), _vm._v(" (thus, by synecdoche, the camps are called standards), with each subcamp further divided by the ensigns or insignia of each father’s house.")]), _vm._v(" "), _c('p', [_vm._v("The Israelites are to encamp "), _c('i', [_vm._v("at a distance")]), _vm._v(" ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("minneḡeḏ")]), _vm._v("] from the tent of meeting (or tabernacle), "), _c('i', [_vm._v("on every side")]), _vm._v(" ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sāḇîḇ")]), _vm._v("] of it. The basic meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("minneḡeḏ")]), _vm._v(" is “away from the front of,” which is how many commentators translate it.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.73.0149",
      "id": "FN.73.0149r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ Some Jewish exegesis connects the current passage with "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Josh. 3:4")]), _vm._v(", which stipulates 2,000 cubits (a little over "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub'), _vm._v(" mi.) as the distance between the marching people and the ark, and posits that each camp was 2,000 cubits from the tabernacle.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.73.0150",
      "id": "FN.73.0150r"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–31")])]), _vm._v(" The four camps were set around the tent of meeting in a rectangle. Protecting the tabernacle on the east end were Aaron and the priests, while the Levites formed a protective cordon about the holy precinct on the other three sides. It is interesting that this rectangular form of encampment is similar to one Pharaoh Ramses II (perhaps a contemporary of Moses) used in his campaigns in Syria.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.73.0151",
      "id": "FN.73.0151r"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.74"
    }
  }), _vm._v("The syntax of the various sections describing the tribal arrangement (i.e., vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–9")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10–16")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18–24")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25–31")]), _vm._v(") is as follows (using the first group as an example): "), _c('i', [_vm._v("on the east (are) . . . the tribe of Judah . . . next to him (are) . . . Issachar . . . (and) Zebulun")]), _vm._v(". In other words, the camp leader is in the center flanked by the other two tribes, as is seen in the following diagram.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.74.0152",
      "id": "FN.74.0152r"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    attrs: {
      "id": "eer-nicot04nu-fig01"
    }
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "432",
      "src": "images/eer-nicot04nu-fig01.jpg",
      "width": "600"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("32–34")])]), _vm._v(" These verses conclude the unit, and again summarize information given in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(". The total of men is 603,550. The Levites are not counted in this census, but the reader is not burdened, at this point, with the reason for the omission (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:47–54")]), _vm._v("). "), _c('i', [_vm._v("as Yahweh had commanded Moses")]), _vm._v(" refers to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:49–53")]), _vm._v(". The concluding formula in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34")]), _vm._v(" is similar to the one that rounded off the previous chapter. Thus, this passage begins with the command of God and ends with its execution by the people of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "NUM.I.A.1.C"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.75"
    }
  }), _vm._v("c. Levitical Censuses ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:1–4:49")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("When the lay census had been taken, it had been made clear that the Levites’ service was to be different (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:47–54")]), _vm._v("). The tent of meeting had to be protected from contact with that which was not holy, and thus special persons (the Levites) were appointed to guard it in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1")]), _vm._v(". chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–4")]), _vm._v(" expand on this Levitical guard duty, their other duties, their numbers, and the camp arrangement.")]), _vm._v(" "), _c('p', [_vm._v("Two censuses are reported here ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:14–39")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:1–49")]), _vm._v("), but they are neither repetitions nor parallel accounts. The purpose of the first census was to number all male Levites from one month of age and up. The second census was to number the working Levites—those from thirty to fifty years of age. The two censuses had ancillary purposes as well. The first also provided the camp arrangement, thus completing what was begun in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("2")]), _vm._v(". The second also set forth specific kinds of work for the different Levitical clans. In between these two censuses ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:40–51")]), _vm._v(") is a small unit that picks up a number of commands from the book of Exodus and works out specifics of the principles set forth in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:11–13")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "NUM.I.A.1.C.1"
    }
  }, [_vm._v("(1) General Census ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:1–39")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ehaft",
    attrs: {
      "id": "NUM.I.A.1.C.1.A"
    }
  }, [_vm._v("(a) Introduction: Family of Aaron ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:1–13")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("These are the family histories of Aaron and Moses, on the day Yahweh spoke to Moses on the mountain of Sinai.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("And these are the names of the sons of Aaron: the firstborn Nadab, and Abihu, Eleazar, and Ithamar.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("These are the names of the sons of Aaron, the anointed priests, whom he consecrated to minister as priests.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("But Nadab and Abihu died before Yahweh, when they presented unacceptable fire before Yahweh in the wilderness of Sinai, and they had no sons. So Eleazar and Ithamar ministered as priests in the presence of Aaron their father.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("And Yahweh spoke to Moses, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("“Bring the tribe of Levi near and present them before Aaron the priest that they might serve him.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("And they will stand guard for him and for the whole congregation before the tent of meeting, in doing﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.75.0153",
      "id": "FN.75.0153r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ the work of the tabernacle.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("And they will guard all the furnishings of the tent of meeting, and this﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.75.0154",
      "id": "FN.75.0154r"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.76"
    }
  }), _vm._v("guard duty is on behalf of the children of Israel,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0155",
      "id": "FN.76.0155r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ in doing the work of the tabernacle.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("And you will give the Levites to Aaron and his sons; they are wholly given﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0156",
      "id": "FN.76.0156r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ to him from among the children of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("And you shall appoint Aaron and his sons, and they shall watch over their priesthood. And the unauthorized persons who encroach will be killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And Yahweh spoke to Moses, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("“I, even I, have taken the Levites from the midst of the children of Israel instead of each firstborn who opens the womb from the children of Israel; therefore the Levites will belong to me,")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("because every firstborn is mine. On the day when I smote every firstborn in the land of Egypt I consecrated to myself every firstborn in Israel, from human and animal; they will belong to me. I am Yahweh.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–3")])]), _vm._v(" This short section contains genealogical formulae: "), _c('i', [_vm._v("These are the family histories of (")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ēlleh tôl")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏōṯ")]), _vm._v(") and "), _c('i', [_vm._v("these are the names of (")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ēlleh š")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("môṯ")]), _c('i', [_vm._v(").")]), _vm._v(" The first formula is the same one that divides Genesis into a number of family histories, as many commentators have recognized.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0157",
      "id": "FN.76.0157r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ The second formula is also common in OT genealogical contexts, especially in the Pentateuch.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0158",
      "id": "FN.76.0158r"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_vm._v("This passage is the first one in the book of Numbers to introduce the family of Aaron: firstborn Nadab and his brothers Abihu, Eleazar, and Ithamar.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0159",
      "id": "FN.76.0159r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ Aaron and his four sons had been consecrated as priests before God,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.76.0160",
      "id": "FN.76.0160r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ but the two older sons Nadab and Abihu had been killed when they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.77"
    }
  }), _vm._v("had performed an unauthorized ritual ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 10")]), _vm._v("). This story, one of the few narratives in Leviticus, is placed after the election of Aaron and his sons to the privilege and service of the priesthood ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 8")]), _vm._v(") and immediately before a discussion of clean and unclean animals ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 11")]), _vm._v("). Nadab and Abihu offered incense in an improper manner before Yahweh and were consumed by fire from his presence. The problem was not that they offered incense when they were not qualified to do so. Ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v(" relates their ordination as priests with all the rights and privileges of priests. The problem was that they offered incense “that Yahweh had not commanded them” ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 10:1")]), _vm._v("). They made this offering on their own, of their own free will, not in response to God’s command. Thus the fire was "), _c('i', [_vm._v("unacceptable")]), _vm._v(" or “unauthorized” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("zārâ")]), _vm._v("). This word is related to the one used for the encroacher who is to be killed if he attempts to pass into the tabernacle in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 1:51")]), _vm._v(". In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 10")]), _vm._v(" there were presumably no Levitical guards to keep interlopers out of the sacred precincts, so God had acted directly to protect his holiness. This act left Aaron with only two sons.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")])]), _vm._v(" "), _c('i', [_vm._v("in the presence of Aaron their father")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘al p")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nê ’aḥărōn ’ăḇîhem")]), _vm._v("). Some render this phrase “in the lifetime of Aaron their father.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.77.0161",
      "id": "FN.77.0161r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ The literal rendering of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘al p")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nê")]), _vm._v(" is “upon” or “against the face of.” The idiom may only indicate one who is in the presence of another (which must be during his or her lifetime). Others translate it as “under the oversight of,” i.e., directly in front of Aaron’s face.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.77.0162",
      "id": "FN.77.0162r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ The phrase probably indicates both contemporaneity and oversight, and so the translation "), _c('i', [_vm._v("in the presence")]), _vm._v(", which implies both.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–10")])]), _vm._v(" The Levites are presented to Aaron to serve the priesthood, and, by doing so, to serve the whole community.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")])]), _vm._v(" Moses is charged by God to "), _c('i', [_vm._v("Bring the tribe of Levi near")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("haqrēḇ ’eṯ-maṭṭēh lēwî")]), _vm._v("). The term "), _c('i', [_vm._v("bring near")]), _vm._v(" is a technical one that can mean “to offer (an offering, sacrifice, etc.).”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.77.0163",
      "id": "FN.77.0163r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Moses is to "), _c('i', [_vm._v("present")]), _vm._v(" (lit., “cause to stand”) the Levites to Aaron and to God as offerings (as will be seen in due course). The idiom “to make someone stand before someone” is used of presenting an inferior to a superior, e.g., Jacob before Pharaoh ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 47:7")]), _vm._v("), a poor person before a priest ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27:8")]), _vm._v("). In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Esth. 4:5")]), _vm._v(" it has the thrust of “to make a servant to.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.77.0164",
      "id": "FN.77.0164r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.78"
    }
  }), _vm._v("The purpose of the Levites’ being brought near and put under Aaron’s authority is "), _c('i', [_vm._v("that they might serve him")]), _vm._v(". The word "), _c('i', [_vm._v("serve")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šērēṯ")]), _vm._v(", Piel) is a general word for the work and ministry that the Levites are to undertake. According to Gray, the verb is used absolutely only of the priests. When the verb is used of the Levites, it always has an object, e.g., the priest (as here), the assembly ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:9")]), _vm._v("), or the tabernacle ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:50")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.78.0165",
      "id": "FN.78.0165r"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', [_vm._v("Both specific kinds of service to be rendered have already been set out in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:50–53")]), _vm._v(", viz., guard duty and the work of dismantling, carrying, and reassembling the tabernacle. Vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7–8")]), _vm._v(" further describe these duties.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")])]), _vm._v(" As in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:53")]), _vm._v(", the idiom here is "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar mišmereṯ")]), _vm._v(", which Milgrom has shown to mean “guard duty.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.78.0166",
      "id": "FN.78.0166r"
    }
  }, [_vm._v("14")]), _vm._v("﻿ Here the standard English translations muddy the waters considerably by translating the terms for the duties of the Levites in these verses as equivalents when they are in fact quite distinct. V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(" tells of the duties of the Levites when the tribes are in camp, since this is the only time when one can keep watch in front of or "), _c('i', [_vm._v("before")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("li")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nê")]), _vm._v(") the tent of meeting. V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v(" has said that the Levites were to serve Aaron and the priests, and one of the ways in which the Levites serve is by "), _c('i', [_vm._v("standing guard for him before")]), _vm._v(" [i.e., in front of] "), _c('i', [_vm._v("the tent of meeting")]), _vm._v(". The Levites are to stand guard in front of, i.e., outside, the tent of meeting, and the priests are to guard the inner precincts, as will be seen.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.78.0167",
      "id": "FN.78.0167r"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the whole congregation")]), _vm._v(". As the allusion to Nadab and Abihu illustrated, even priests can incur Yahweh’s killing wrath by offering “unauthorized fire.” As will be seen in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v(", it is also, of course, possible for others to trespass and for the "), _c('i', [_vm._v("whole congregation")]), _vm._v(" to suffer God’s wrath, whether or not they had physically taken part in the trespass (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:6–15")]), _vm._v(" [Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16:41–50")]), _vm._v("]). Therefore, by keeping the congregation out of the holy precincts, the Levites are rendering a protection and a service to the community.")]), _vm._v(" "), _c('p', [_vm._v("A second way in which the Levites are to serve Aaron is by "), _c('i', [_vm._v("doing the work of the tabernacle")]), _vm._v(". Milgrom has shown conclusively that the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(" means physical "), _c('i', [_vm._v("work")]), _vm._v(". Since this verse applies to the work of the Levites "), _c('i', [_vm._v("before")]), _vm._v(" (i.e., “out in front of”) the tent of meeting, i.e., in camp, the physical work required here is general.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.78.0168",
      "id": "FN.78.0168r"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.79"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")])]), _vm._v(" Although some consider the last half of this verse an addition to the text, since it repeats the last part of v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(", ﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0169",
      "id": "FN.79.0169r"
    }
  }, [_vm._v("17")]), _vm._v("﻿ this is doubtful. This verse is not simply a doublet. V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(" deals with the Levites’ work in the camp and v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v(" deals with their work on the march. This is shown by the reference to the "), _c('i', [_vm._v("furnishings")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("k")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lî")]), _vm._v(") that the Levites guard. When the camp is set up these "), _c('i', [_vm._v("furnishings")]), _vm._v(" are inside the tabernacle enclosure, guarded by the priests ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:38")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:5")]), _vm._v("). The Levites guard the area out in front of ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("li")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nê")]), _vm._v(") the tabernacle ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:7")]), _vm._v("; cf. vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35")]), _vm._v("). The only time the holy object would be exposed is on the march. Here the general word "), _c('i', [_vm._v("work")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") refers to the erecting, disassembling, and carrying that will be assigned to the various Levite groups later in this chapter and in the next.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0170",
      "id": "FN.79.0170r"
    }
  }, [_vm._v("18")]), _vm._v("﻿ The two verses are distinct in their references and both are necessary to provide information on the duties of the Levites. The phrase "), _c('i', [_vm._v("and this guard duty is on behalf of the children of Israel")]), _vm._v(" interrupts the flow of the sentence in order to reinforce the idea, already present elsewhere in the text, that the Levites’ guard duty is really on behalf of and for the benefit of the whole community.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0171",
      "id": "FN.79.0171r"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("9")])]), _vm._v(" The Levites are "), _c('i', [_vm._v("wholly given")]), _vm._v(" to Aaron and his sons, i.e., the priests. This verse is similar to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8:16")]), _vm._v(", which states that the Levites are wholly given to God. Some versions attempted to harmonize the two verses,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0172",
      "id": "FN.79.0172r"
    }
  }, [_vm._v("20")]), _vm._v("﻿ but the difference between them is more important than their similarity. Here Moses gives the Levites to the priests while in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8:16")]), _vm._v(" God gives them to himself. Furthermore, in this verse the Levites are given to the priests "), _c('i', [_vm._v("from among")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mē’eṯ")]), _vm._v("), i.e., “on the part of,” or “representing,” the children of Israel, while in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8:16")]), _vm._v(" they are given by God "), _c('i', [_vm._v("from the midst of")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mittôḵ")]), _vm._v(") the children of Israel, representing the firstborn.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("10")])]), _vm._v(" This verse states that the priests have a part to play in guarding the tabernacle. Aaron and his sons are to "), _c('i', [_vm._v("watch over")]), _vm._v(" ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar")]), _vm._v("] their priesthood ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("k")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hunnāṯām")]), _vm._v("], i.e., over their priestly functions.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0173",
      "id": "FN.79.0173r"
    }
  }, [_vm._v("21")]), _vm._v("﻿ This verse contains the second occurrence of the formula "), _c('i', [_vm._v("the unauthorized person who encroaches will be killed")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.79.0174",
      "id": "FN.79.0174r"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–13")])]), _vm._v(" These verses refer to the laws of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 13:2")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:29–30")]), _vm._v("; and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:19–20")]), _vm._v(". The principle is that every firstborn belongs to God "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.80"
    }
  }), _vm._v("("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13:2")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.80.0175",
      "id": "FN.80.0175r"
    }
  }, [_vm._v("23")]), _vm._v("﻿ Every firstborn animal must be either sacrificed or redeemed and the substitute sacrificed ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22:30")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:19–20a")]), _vm._v("). The firstborn son was to be redeemed by a substitution ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34:20b")]), _vm._v("). After the sin of the golden calf, the Levites were substituted without a formal statute ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("32:25–29")]), _vm._v("). Their substitution is made formal here and spelled out in greater detail in 3:44–51.")]), _vm._v(" "), _c('p', [_vm._v("To summarize what has been introduced here concerning the priests and Levites: The priesthood was reduced with the deaths of Nadab and Abihu (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–4")]), _vm._v("), so that augmentation of those standing guard over the tabernacle was desirable. This resulted in the Levites’ being dedicated to the service of the priests (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6")]), _vm._v("). The Levites would be responsible for guard duty outside the tent when it was set up and (some of them) for the other physical work connected with setting up, taking down, and carrying the structure (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7–8")]), _vm._v("). The Levites are given over to Aaron and the priesthood as representatives of Israel (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("9")]), _vm._v("). The priests also have a guard duty over their own priestly duties (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10")]), _vm._v("). The Levites stand as God’s replacement for the firstborn in Israel (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–13")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "NUM.I.A.1.C.1.B"
    }
  }, [_vm._v("(b) The census itself ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:14–39")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("And Yahweh spoke to Moses in the wilderness of Sinai, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("“Number the sons of Levi by their fathers’ houses, by their clans; you shall number every male from one month of age and up.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("And Moses numbered them according to the command of Yahweh, as he had been commanded.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.80.0176",
      "id": "FN.80.0176r"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("And these are the sons of Levi, by their names: Gershon and Kohath and Merari.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("And these are the names of the sons of Gershon, by their clans: Libni and Shimei.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("And the sons of Kohath, by their clans: Amram and Izhar, Hebron and Uzziel.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("And the sons of Merari, by their clans: Mahli and Mushi. These are the clans of the Levites by their fathers’ houses.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.81"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("To Gershon belonged the clan of the Libnites and the clan of the Shimeites; these are the clans of the Gershonites.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Those numbered, according to the number of all males, from one month of age and older, those numbered: 7,500.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("The clans of the Gershonites: They will encamp behind the tabernacle, to the west,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("and the leader of the father’s house of the Gershonites: Eliasaph the son of Lael.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("And the guard duty of the sons of Gershon in the tent of meeting: the tabernacle, the tent, its covering, the screen of the door of the tent of meeting,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("the hangings of the court, and the screen﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.81.0177",
      "id": "FN.81.0177r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ of the door of the court that is around the tabernacle and around the altar; also its cords, and any work concerning these things.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("And to Kohath belonged the clan of the Amramites and the clan of the Izharites and the clan of the Hebronites and the clan of the Uzzielites. These are the clans of the Kohathites.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("According to the number of all males, from one month of age and up: 8,600,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.81.0178",
      "id": "FN.81.0178r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ standing guard over the holy things.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("The clans of the sons of Kohath will encamp at the side of the tabernacle to the south.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("And the leader of the father’s house of the households of the Kohathites: Elizaphan the son of Uzziel.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("And their guard duty: the ark, the table, the lampstand, the altars, the holy objects with which they assist, and the screen, as well as their removal.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.81.0179",
      "id": "FN.81.0179r"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("32")]), _vm._v("And the leader of the leaders of the Levites was Eliezar the son of Aaron the priest. He was overseer of those who stood guard over the holy things.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.82"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("33")]), _vm._v("To Merari belonged the clans of the Mahlites and the Mushites. These are the clans of the Merarites.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("34")]), _vm._v("And those numbered, by the number of every male from one month of age and up: 6,200.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("35")]), _vm._v("And the leader of the fathers’ houses of the clans of Merari: Zuriel son of Abihail. They are to encamp on the north side of the tabernacle.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("36")]), _vm._v("The appointed guard duty of the sons of Merari: the boards of the tabernacle, its crosspieces, its pillars, its sockets, and all their accessories, as well as all their removal,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.82.0180",
      "id": "FN.82.0180r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("37")]), _vm._v("the pillars surrounding the court, their sockets, their tent pegs, and their cords.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("38")]), _vm._v("And those who encamp before the tabernacle, toward the east, before the tent of meeting, toward the rising sun, will be Moses and Aaron and his sons, standing guard over the holy things﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.82.0181",
      "id": "FN.82.0181r"
    }
  }, [_vm._v("6")]), _vm._v("﻿—a guard duty on behalf of the children of Israel—and the unauthorized person who encroaches will be killed.")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("39")]), _vm._v("All those Levites numbered, whom Moses and Aaron﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.82.0182",
      "id": "FN.82.0182r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ numbered, according to the command of Yahweh; by their clans, every male from one month of age and up: 22,000.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This section gives some specific duties of the three Levite groups. It is important to keep the census of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" separate from the one in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(". The present census, on all Levites from one month of age and up, emphasizes "), _c('i', [_vm._v("guard duty (")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _c('i', [_vm._v("); work (")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _c('i', [_vm._v(")")]), _vm._v(" is barely mentioned. By contrast, the stress in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" is on the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(". This census in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" is the more important of the the two since 22,000 Levites, at least potentially, keep guard, while only 8,580 are engaged in the work of assembly, disassembly, and cartage.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("14")])]), _vm._v(" Again, this census is not merely an administrative detail but a fulfillment of the command of Yahweh.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.83"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("15–20")])]), _vm._v(" These verses tell, once again, about the three branches of the Levites: the Gershonites, the Kohathites, and the Merarites, named after the three sons of Levi.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.83.0183",
      "id": "FN.83.0183r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ The further subdivisions of these groups are given in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18–20")]), _vm._v(" in virtually the same order as found in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 6")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")]), _vm._v(". Vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14–20")]), _vm._v(" comprise two smaller sections, both of which end with concluding formulae: vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14–16")]), _vm._v(", ending with Moses’ carrying out of the command he had been given, and vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–20")]), _vm._v(", ending with the summary "), _c('i', [_vm._v("and these are the clans of the Levites by their fathers’ houses")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("21–39")])]), _vm._v(" The census account itself is made up of a number of stock phrases arranged in virtually identical order:")]), _vm._v(" "), _c('p', [_vm._v("(1) An introduction, which repeats the various groups within the clan, and concludes with the formula “these are the clans of the "), _c('i', [_vm._v("x")]), _vm._v("” (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.83.0184",
      "id": "FN.83.0184r"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', [_vm._v("(2) A formula introducing the number of males counted, from one month of age and up (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22a")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28a")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34a")]), _vm._v("), followed by the number itself (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22b")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28b")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34b")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("(3) A statement of the place of encampment, to the west, south, or north (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35b")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.83.0185",
      "id": "FN.83.0185r"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("(4) The naming of the leader of the particular group (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35a")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.83.0186",
      "id": "FN.83.0186r"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', [_vm._v("(5) The actual items that the group is to guard (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25–26")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("36–37")]), _vm._v("). The last section is very important and will be discussed below.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("21")])]), _c('b', [_vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")])]), _vm._v(" The names of the clans of the different Levitical groups are, for Gershon, the Libnites and the Shimeites; for Kohath, the Amramites, the Izharites, the Hebronites, and the Uzzielites; for Merari, the Mahlites and the Mushites. The clan names are derived from the names "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.84"
    }
  }), _vm._v("of the children of Gershon, Kohath, and Merari, and are listed in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 6")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")]), _vm._v(". Little is known about the men themselves, but enough time must have passed for the name of individual son of Aaron to be understood as a clan name.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("39")])]), _vm._v(" The individual figures (Gershonites, 7,500; Kohathites, 8,600; Merarites, 6,200) add up to 22,300. V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("39")]), _vm._v(" gives the figure as 22,000. Either the total figure is meant only to represent a round number, or, more likely, at least one of the individual group numbers is incorrect. The individual total most likely to be textually corrupt is usually held to be the 8,600 for the Kohathites. In the consonantal Hebrew text the word “three” is "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šlš")]), _vm._v(", while “six” is "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šš")]), _vm._v(". Thus, the “extra” three hundred is accounted for by the loss of one Hebrew consonant. This solution is simplest and is probably correct.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.84.0187",
      "id": "FN.84.0187r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_vm._v("In v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")]), _vm._v(" the phrase "), _c('i', [_vm._v("standing guard over the holy things")]), _vm._v(" is added to the standard formula. The term "), _c('i', [_vm._v("the holy things")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("haqqōḏeš")]), _vm._v(") cannot refer to the sanctuary proper (as in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.87"
    }
  }, [_vm._v("NIV")]), _vm._v(", etc.) because the Levites do not guard the sanctuary itself—that is the job of the priests (cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:38")]), _vm._v("). The Kohathites guard only the ark, altars, holy vessels, etc., and this only in transit (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:7")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")])]), _c('b', [_vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35b")])]), _vm._v(" The various groups of Levites will station themselves on the west (Gershonites), the south (Kohathites), and the north (Merarites) sides of the tabernacle. The group with the most important guard duty (the Kohathites) is placed on the south, near to the priests. All through this census description the Kohathites have been described in more detail because their guard duty (the holy things) is more dangerous.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("24")])]), _c('b', [_vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35a")])]), _vm._v(" The heads of the various groups are named next. "), _c('i', [_vm._v("Eliasaph")]), _vm._v(" here is probably not the same person named as a leader in Gad (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:14")]), _vm._v("). "), _c('i', [_vm._v("Lael")]), _vm._v(" is a name that occurs only here in the Bible. A variant of the name "), _c('i', [_vm._v("Elizaphan")]), _vm._v(" (Elzaphan) is found in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6:22")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 10:4")]), _vm._v(". El(i)zaphan was one of the persons Moses called on to carry away the corpses of Nadab and Abihu. "), _c('i', [_vm._v("Uzziel")]), _vm._v(" is one of the sons of Kohath and is mentioned often in the OT (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6:18")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("22")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 10:4")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 6:2")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18")]), _vm._v("). "), _c('i', [_vm._v("Zuriel")]), _vm._v(" also occurs only here in the Bible. Thus the only names in this list to occur elsewhere in the Bible are El(i)zaphan and Uzziel.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("25–26")])]), _c('b', [_vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("36")])]), _vm._v(" The next part of the description is the assigned duty of the groups with an emphasis on their guard duty. All that is said about the work of dismantling, assembling, and carting the tabernacle "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.85"
    }
  }), _vm._v("seems almost an afterthought here.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.85.0188",
      "id": "FN.85.0188r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ This work will be more clearly detailed in the next chapter. It is possible that the comment is part of the process of editing chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" together.")]), _vm._v(" "), _c('p', [_vm._v("The Gershonites are to guard the coverings and the fabric or skin coverings of the sanctuary, i.e., the "), _c('i', [_vm._v("tabernacle")]), _vm._v(" and the "), _c('i', [_vm._v("tent")]), _vm._v(". These structures are identified many times, but here they are listed separately, as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26")]), _vm._v(". The Gershonites are to be in charge of the coverings. The "), _c('i', [_vm._v("tabernacle")]), _vm._v(" itself ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammiškān")]), _vm._v(") consisted of ten curtains made of fine linen ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:1–6")]), _vm._v("). The "), _c('i', [_vm._v("tent")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ōhel")]), _vm._v(") was made of goats’ hair and consisted of eleven curtains to go over the top of the tabernacle ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:7–14")]), _vm._v("). The Gershonites were also responsible for guarding the "), _c('i', [_vm._v("covering")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("miśkeh")]), _vm._v(") that covered the whole structure ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:14")]), _vm._v("; cf. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 4:6–14")]), _vm._v("). They were also to watch over "), _c('i', [_vm._v("the screen of the door of the tent of meeting")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("māśāḵ peṯaḥ ’ōhel mô‘eḏ")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:36")]), _vm._v("), "), _c('i', [_vm._v("the hangings of the court")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qal‘ê heḥāṣer")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:9")]), _vm._v("), "), _c('i', [_vm._v("the screen of the door of the court")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maśaḵ peṯaḥ heḥāṣer ’ăšer ‘al hammiškān w")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘al hammizbēaḥ sāḇîḇ")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:16")]), _vm._v("), and the "), _c('i', [_vm._v("cords")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mêṯār")]), _vm._v(") that were connected with these items. To this guard duty is added a note about the "), _c('i', [_vm._v("work")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") connected with this task. Since "), _c('i', [_vm._v("specific")]), _vm._v(" work has not yet been assigned to the Gershonites (see ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v("), the term may be taken as general here.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.85.0189",
      "id": "FN.85.0189r"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("The Kohathites have the most holy things as their guard duty assignment. These include "), _c('i', [_vm._v("the ark")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hā’ārōn")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:10–22")]), _vm._v("), "), _c('i', [_vm._v("the table")]), _vm._v(" (of the bread of the Presence, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("haššulḥān")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:23–30")]), _vm._v("), "), _c('i', [_vm._v("the lampstand")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hamm")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nōrâ")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:31–40")]), _vm._v("), "), _c('i', [_vm._v("the altars")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammizb")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥôṯ")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:1–8")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("30:1–10")]), _vm._v("), "), _c('i', [_vm._v("the holy objects")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("k")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lê haqqōḏeš")]), _vm._v(", e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:17–21")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:7–11")]), _vm._v("), and "), _c('i', [_vm._v("the screen")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammasaḵ")]), _vm._v("). This last term is used to refer to three items: "), _c('i', [_vm._v("the screen of the door of the tent of meeting")]), _vm._v(" (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v("), "), _c('i', [_vm._v("the screen of the court that is around the tabernacle and around the altar")]), _vm._v(" (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")]), _vm._v("), and the screen that divided the Most Holy Place from the Holy Place in the tabernacle proper (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:31–33")]), _vm._v("). Since the Gershonites guard the first two of these screens, and since the Kohathites carry the holy things, the screen referred to here must be the third screen. As will be seen in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(", the Kohathites are responsible only for carrying these items. The priests pack them up for moving (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:4–14")]), _vm._v("). Therefore, one may understand "), _c('i', [_vm._v("work")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") here as “cartage.”")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.86"
    }
  }), _vm._v("The Merarites are responsible for guarding the framework of the tabernacle, including the outer structure ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:15–30")]), _vm._v(") and the supports for the court ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:9–19")]), _vm._v("). Their "), _c('i', [_vm._v("work")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") included dismantling, reassembling, and carrying these materials to the carts.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("38–39")])]), _vm._v(" On the east side of the tabernacle, at the preeminent position,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.86.0190",
      "id": "FN.86.0190r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ Moses (presumably with his family) and Aaron and his sons were to encamp. The priests, too, have a guard duty to perform. They stand guard over the holy things. This guard duty is to be differentiated from that of the Kohathites, who stand guard over the holy things when the sanctuary has been erected. The construction "), _c('i', [_vm._v("a guard duty on behalf of the children of Israel")]), _vm._v(" interrupts the flow of the sentence. This guard duty is on behalf of and for the benefit of Israel. The reason why it is beneficial is seen in the next clause, the formula "), _c('i', [_vm._v("and the unauthorized person who encroaches will be killed")]), _vm._v(" (see also "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:51")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:10")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:7")]), _vm._v("). The priests here have only guard duty, no “work” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") as such.")]), _vm._v(" "), _c('p', [_vm._v("The sacred shrine is called the "), _c('i', [_vm._v("tabernacle")]), _vm._v(" and the "), _c('i', [_vm._v("tent of meeting")]), _vm._v(" in apposition here.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.86.0191",
      "id": "FN.86.0191r"
    }
  }, [_vm._v("16")]), _vm._v("﻿ The structure may be referred to in a technical way (as in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v(" above), in which case tabernacle and tent may be differentiated, or, as here, the general structures may be identified.")]), _vm._v(" "), _c('p', [_vm._v("The total number of Levites, from one month of age and up, is 22,000, which includes the 7,500 Gershonites, 8,300 Kohathites, and 6,200 Merarites.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.86.0192",
      "id": "FN.86.0192r"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "sh",
    attrs: {
      "id": "NUM.I.A.1.C.1.EXCURSUS"
    }
  }, [_vm._v("Excursus on the Priests and Levites")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("According to the biblical narratives, both priests and Levites were descended from Levi, the third son of Jacob and Leah ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 29:34")]), _vm._v("). Levi had three sons: Gershon (or Gershom), Kohath, and Merari ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 46:11")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6:16")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 6:2")]), _vm._v("). Aaron and Moses were descendants of Kohath ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 6:16–20")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 6:2–3")]), _vm._v("). Their descent from him is probably corroborated by the fact that, although the Kohathites are not descendants of the firstborn, they are given more responsibility and honor than the other Levites. The priests were the only ones who were allowed to offer sacrifices and preside at the sacred rites of the tabernacle (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3:38")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:1–32")]), _vm._v("). The Levites included all other descendants of Levi, i.e., "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.87"
    }
  }), _vm._v("the non-Aaronite Kohathites, the Gershonites, and the Merarites. The Levites’ duties had to do with guarding the outside of the tabernacle (“guard duty,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar mišmereṯ")]), _vm._v(") and the physical work of erecting, dismantling, and carrying it ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘āḇaḏ ‘ăḇōḏâ")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("From the point of view of the text as it stands, Levi was originally a “secular” tribe that was later set apart for sacred service. Genesis paints Levi as a bloodthirsty man (tribe?) who, along with Simeon, avenged their sister Dinah’s assault by killing all the men of Shechem ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 34")]), _vm._v("), a fact noted with disapproval in the Testament of Jacob ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Gen. 49:7")]), _vm._v("). The Levites were chosen by Moses to execute the death sentence on 3,000 idolators after the incident with the golden calf ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 32:28")]), _vm._v("). That Moses and Aaron were brothers and Levites probably explains, at least in the first instance, why this tribe was chosen for special service.")]), _vm._v(" "), _c('p', [_vm._v("The question that has arisen, however is, Is this the way it really happened? Since the time of Julius Wellhausen the answer of a great portion of critical scholarship has been negative. As is well known, Wellhausen fixed the date of the Priestly Code of the Pentateuch in the postexilic age. This meant that the assignment of duties of priests and Levites here in Numbers did not really belong to the time of Moses, but rather was a projection of the concerns of the time of the second temple back into the Mosaic age.")]), _vm._v(" "), _c('p', [_vm._v("As is widely admitted today among all varieties of scholarship, Wellhausen assumed much of what he wrote rather than demonstrating it to be true. One of his major assumptions was the unilinear evolution of religious institutions from simple to complex. The complexity of regulations in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" meant that in all probability the material was very late, and in hardly any cases could belong to the Mosaic period, or even that of the united monarchy.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.87.0193",
      "id": "FN.87.0193r"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', [_vm._v("According to the common theory that has become connected with the names of Graf and Wellhausen, the earliest narrative sources in the Pentateuch speak little about the Israelite priesthood at all. What may be said is that the complex legislation of Numbers left minimal or no traces in the time, e.g., of the judges. In the early days most anyone could become a priest, although a Levite might be preferred. During the time of the monarchy the priesthood became more settled in families, notably the (supposedly) non-Levitical family of Zadok that officiated at the Jerusalem temple.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.87.0194",
      "id": "FN.87.0194r"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.88"
    }
  }), _vm._v("In the 620s, when Josiah tore out the local sanctuaries in favor of the Jerusalem temple, some of the local priests, of course, lost their jobs. He brought them to Jerusalem to assist the Zadokite priests. It is usually assumed that the programmatic document for Josiah’s reforms was Deuteronomy (or some part of it). It is also assumed that Deuteronomy makes no differentiation between Levites and priests by its formula “the priests, the Levites” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(" “the Levitical priests”; e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 17:9")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Priests and Levites were first sharply distinguished only later, in Ezekiel’s plan of the restored temple (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40–44")]), _vm._v("). The Priestly Code projects all this innovation back into the Mosaic age as existent from the beginning.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.88.0195",
      "id": "FN.88.0195r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ The clearly postexilic books of Ezra-Nehemiah and Chronicles agree more fully with the Priestly Code in Numbers than with any other literature. In this literature the priests are traced back to Aaron rather than merely to Zadok (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Ezra 8:2")]), _vm._v("). A clear difference is also made between priests and Levites (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Ezra 2:36–42")]), _vm._v("), again, as in the Priestly Code.")]), _vm._v(" "), _c('p', [_vm._v("The biblical text, when read as it stands, would seem to hold that the postexilic interest in religious, cultic, and priestly matters was a revival of an interest that existed at the beginning of the history of the people and originated in divine revelation. Why is it not likely that in the age of Ezra and Nehemiah, when the whole question of national identity and goals was transposed from a political into a religious key (since the Jews’ political fortunes were not in their own hands), interest would not revive in the priesthood, worship, and temple service? What better programmatic document for such goals could be found than the Priestly Code? The picture given by the present text (i.e., the antiquity of this priestly material and the priesthood) is just as likely as the very complex (overly complex?) reconstructions offered by modern followers of Wellhausen. This is especially so in the light of the methodological problems that plague such reconstructions.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.88.0196",
      "id": "FN.88.0196r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ For example, the only reason why Ezekiel must precede the Priestly Code is surely a prior decision to that effect. It is just as likely that Ezekiel used the Priestly material in his proposals. Whereas Ezekiel’s program fits well in the postexilic age, the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.89"
    }
  }), _vm._v("program of the Priestly material is locked into the wilderness period and would have more limited immediate usefulness in a sedentary environment. For example, Ezekiel makes provision for the priests near the sanctuary rather than in priestly/Levitical cities around the countryside, as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 35")]), _vm._v(". To their credit, a growing number of scholars affirm the antiquity of the Priestly material.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.89.0197",
      "id": "FN.89.0197r"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("Of course, the case must be argued on its merits and on the details of individual texts rather than on general feelings and principles (as important as the latter may be). This is not the place to engage in a full-blown discussion of the case of Wellhausen’s school, but a few points can be made.")]), _vm._v(" "), _c('p', [_vm._v("First, the contention that D (the Deuteronomist) made no differentiation between priests and Levites is open to question.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.89.0198",
      "id": "FN.89.0198r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ Every Levite was, at least potentially, a priest. Levites are mentioned 19 times in Deuteronomy, in 10 of which the people are adjured to care for the Levites along with other “homeless” classes such as the sojourner, widow, and fatherless.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.89.0199",
      "id": "FN.89.0199r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("27:14")]), _vm._v(" the Levites declare the curses found in the following verses. In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:25")]), _vm._v(" the Levites are responsible for carrying the ark, in agreement with such passages as "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3:31")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:15")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.89.0200",
      "id": "FN.89.0200r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deut. 18:6–7")]), _vm._v(" a group of Levites is responsible for ministering along with other Levites. This last passage is within a pericope crucial to the question, and will be dealt with in a moment.")]), _vm._v(" "), _c('p', [_vm._v("In five cases the Levites are mentioned in the formula “the priests, the Levites,” i.e., “the Levitical priests” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(") or “the priests, who are "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.90"
    }
  }), _vm._v("Levites” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.87"
    }
  }, [_vm._v("NIV")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.90.0201",
      "id": "FN.90.0201r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ This construction has, at the very least, confirmed the widespread assumption that in Deuteronomy “priest” and “Levite” are equivalent terms. It should be remembered that, according to, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 28")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 8")]), _vm._v("; and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 16–18")]), _vm._v(", only the sons of Aaron the Levite could officiate at cultic ceremonies in Israel. In other words, all priests had to be Levites descended from Aaron. It is possible that in the light of this fact, the phrase “the priests, the Levites” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hakkōhănîm hal")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("wîyim")]), _vm._v(") simply points to the fact that each "), _c('i', [_vm._v("legitimate")]), _vm._v(" priest had to be a Levite. That this is a possible meaning can be further shown from another similar phrase used for the priests, “the priests, the sons of Levi” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hakkōhănîm b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nê lēwî")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21:5")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31:9")]), _vm._v("). Otherwise these functionaries are simply called “the priests” ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17:12")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:3")]), _vm._v(" [twice]; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("19:17")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20:2")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:3")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("Deuteronomy 18:1–8")]), _vm._v(" is crucial to the discussion. One cannot even outline all the problems here, but only sketch some proposed solutions. The text begins: “None of the priests, the Levites, all the tribe of Levi, will have a share or inheritance with Israel.” The question is whether “the priests, the Levites” is the same as “all the tribe of Levi” here, as J. A. Emerton holds, or whether, as G. E. Wright suggested, the latter is a larger group that makes the former designation, “the priests, the Levites,” more expansive.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.90.0202",
      "id": "FN.90.0202r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ R. Abba gave important support to Wright’s reading of the verse,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.90.0203",
      "id": "FN.90.0203r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ but, in fact, the syntax of the verse is not clear and no final decision can be rendered on it. The conclusions one comes to here will likely be influenced by one’s own view of the problem in the first place. Suffice it to say that Emerton does not appear to shut the door on the Wright/Abba case, and their reading of the verse remains possible.")]), _vm._v(" "), _c('p', [_vm._v("The rest of the pericope seems to favor Abba’s position. Vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–5")]), _vm._v(" prescribe that dues be received not by “the priest, the Levite,” but simply by “the priest.” Vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6–8")]), _vm._v(" outline the ministry simply for “the Levites.” If there is no difference between the terms "), _c('i', [_vm._v("priest")]), _vm._v(" and "), _c('i', [_vm._v("Levite")]), _vm._v(", why not use one term throughout the passage? This is not a simple matter of using different terms for literary variety. It, rather, seems more likely that vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–2")]), _vm._v(" use a general term encompassing both priests and Levites (for neither has a land inheritance), vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3–5")]), _vm._v(" deal with the priests, and vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("6–8")]), _vm._v(" with the Levites.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.90.0204",
      "id": "FN.90.0204r"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.91"
    }
  }), _vm._v("Attention might now be drawn to the terminology used to describe the Levites’ work in Numbers, Chronicles, and Ezekiel. In Numbers the work is described as guard duty ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šāmar mišmereṯ")]), _vm._v(") and the physical work of assembly, disassembly, and cartage of the tabernacle ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v("). In Chronicles the first duty is still understood and given to the Levites, as is shown by "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 9:27")]), _vm._v(": “They [the Levites] spent the night surrounding the house of God because the guard duty ["), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v("] was upon them.” The most likely reason that the Chronicler does not explain "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(" is that he knew “guard duty” to be the original and proper meaning of the term.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.91.0205",
      "id": "FN.91.0205r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ When it came to the other duty, however, Milgrom has shown that the Chronicler shifted the meaning of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(" from physical work to cultic service.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.91.0206",
      "id": "FN.91.0206r"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("In Numbers the Levites simply do not play the role in the cult that they do in Chronicles. For example, the Levites’ work with the utensils in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1 Chr. 9:28–32")]), _vm._v(" is very different from the hands-off attitude of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 4:4–14")]), _vm._v(". There is also no comparison between the great number of other types of functionaries (e.g., the singers) in Chronicles and in Numbers. In short, the book of Numbers is wholly geared to Levitical service in a mobile tent shrine, while Chronicles shows the more cumbersome mechanisms of a permanent temple. To place the composition of Numbers, even in its final form, within 50 to 100 years of Chronicles seems unlikely.")]), _vm._v(" "), _c('p', [_vm._v("Ezekiel’s program for the reestablishment of the temple service (chs. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40–44")]), _vm._v(", esp. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44:6–31")]), _vm._v(") is an ideal plan that divided the Levites from the priests (the latter were descended only from Zadok). That his plan was not put into practice after the return from exile (as a comparison with Chronicles shows it was not) must be left aside as beside the present note. Ezekiel uses "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(" as “guard duty,” but expands it to mean “guarding by will power.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.91.0207",
      "id": "FN.91.0207r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ He uses the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(" only once ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44:14")]), _vm._v("), in a paraphrase (midrash?) on "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 18:4a")]), _vm._v(" (where "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(" occurs in the text of Numbers), and to this he adds an extra phrase (“that is, everything that is to be done in it,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ûl")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḵol ’ăšer yē‘āśeh bô")]), _vm._v(") to explain what it means to him. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.92"
    }
  }), _vm._v("It is clear that the duties of slaying the whole burnt offering and the sacrifice, assigned to the Levites in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44:11")]), _vm._v(", is a task reserved for the laity in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 1:5")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:2")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("13")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:24")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("In sum, neither Ezekiel nor Chronicles uses either the term "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(" or "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōdâ")]), _vm._v(" in just the way Numbers does. Numbers is, again, tied to the wilderness-wandering period. Only the desire to agree with a particular school of interpretation forces one to the necessity of seeing the material in Numbers as later than Ezekiel. If anything, Ezekiel shows traces of having used Numbers (and Leviticus) rather than the other way around.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.92.0208",
      "id": "FN.92.0208r"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "NUM.I.A.1.C.2"
    }
  }, [_vm._v("(2) Levites for Firstborn ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:40–51")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("40")]), _c('i', [_vm._v("And Yahweh said to Moses, “Number every firstborn male of the children of Israel from one month of age and up, and calculate their total by names")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("41")]), _vm._v("and take the Levites for me—I am Yahweh—instead of each firstborn among the children of Israel, as well as the Levites’ cattle, instead of every firstborn among the cattle of the children of Israel.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("42")]), _vm._v("So Moses numbered every firstborn among the children of Israel as Yahweh had commanded him.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("43")]), _vm._v("And it was﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.92.0209",
      "id": "FN.92.0209r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ that every firstborn male, by the number of names, from one month of age and up, numbered 22,273.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("44")]), _vm._v("And Yahweh spoke to Moses, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("45")]), _vm._v("“Take the Levites instead of every firstborn of the children of Israel and the cattle of the Levites instead of their cattle, and the Levites shall be mine—I am Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("46")]), _vm._v("And, as for the ransoming of the 273﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.92.0210",
      "id": "FN.92.0210r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ from the firstborn of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.93"
    }
  }), _vm._v("children of Israel, who are over and above the number of the Levites,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("47")]), _vm._v("you shall take five shekels for each one individually﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.93.0211",
      "id": "FN.93.0211r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ (you shall take this in the shekel of the sanctuary, the twenty-gerah shekel),")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("48")]), _vm._v("and you shall give the silver that has ransomed these over and above them﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.93.0212",
      "id": "FN.93.0212r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ to Aaron and his sons.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("49")]), _vm._v("So Moses took the silver of the ransom﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.93.0213",
      "id": "FN.93.0213r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ from those who were over and above those ransomed by the Levites,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("50")]), _vm._v("from the firstborn of the children of Israel he took the silver, 1,365 shekels by the shekel of the sanctuary.")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("51")]), _vm._v("And Moses gave the silver of the ransom to Aaron and to his sons according to the command of Yahweh, just as Yahweh had commanded him.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The firstborn male Israelites of one month of age and up are counted and found to total 22,273. This total exceeded the total number of Levites by 273. Thus there were 273 unreplaced and unredeemed Israelite males in this count, since the Levites were meant to replace the firstborn males of Israel (see, e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:11–13")]), _vm._v("). These unredeemed males were redeemed at a cost of five silver shekels apiece, and the total ransom price of 1,365 shekels was given to the priests.")]), _vm._v(" "), _c('p', [_vm._v("This section contains two subsections, each begun by a formula that relates what follows as Yahweh’s word (“Yahweh said . . . ,” v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40")]), _vm._v("; “Yahweh spoke . . . ,” v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44")]), _vm._v("). The first subsection deals with two subjects: the count of the firstborn males, and their replacement by the Levites (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40–43")]), _vm._v("). The second subsection repeats the replacement theme and then discusses the ransom of the 273 extra firstborn males (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("44–51")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("40")])]), _vm._v(" "), _c('i', [_vm._v("Number . . . calculate by names")]), _vm._v(". Again, as in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:2")]), _vm._v(" (where the same idiom occurs), the counting of Israelites is not seen as an unimportant detail, but is placed in the will and command of Yahweh.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.94"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("41")])]), _vm._v(" "), _c('i', [_vm._v("for me")]), _vm._v(" means “for my use.” This verse reiterates that all the Levites belonged to Yahweh as a replacement for the firstborn sons of Israel who became Yahweh’s at the time of the tenth plague in Egypt.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0214",
      "id": "FN.94.0214r"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_vm._v("The text also makes clear that the firstborn animals belong to Yahweh: "), _c('i', [_vm._v("take . . . the Levites’ cattle, instead of every firstborn among the cattle of the children of Israel")]), _vm._v(". The text cannot mean (and does not say) that the Levites’ cattle replaced the sacrifice of firstlings of other cattle. In fact, "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:5")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("7")]), _vm._v(" forbid cows, sheep, or goats to be redeemed. Rather than seeing the whole construction as artful theorizing long after the fact,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0215",
      "id": "FN.94.0215r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ the text should be considered an expansion of the statement of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:11–13")]), _vm._v("—that the Levites and all they have belonged to Yahweh.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0216",
      "id": "FN.94.0216r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ In the light of the priestly exclusivity of v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38")]), _vm._v(", a restatement of the special status of the Levites as over against the priests is quite natural and timely.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("42–43")])]), _vm._v(" Moses did as Yahweh commanded him, and the total was 22,273. The problem of the number of firstborn males in a male population of over 600,000 has already been referred to above.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0217",
      "id": "FN.94.0217r"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("44–45")])]), _vm._v(" The second subsection is also that which Yahweh said, and begins with the main theme of the previous subsection (the divine possession of the Levites), thus linking the two units. The firstborn cattle are mentioned here only to indicate that all the Levites’ possessions truly belonged to God.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("46–48")])]), _vm._v(" "), _c('i', [_vm._v("ransoming, ransomed")]), _vm._v(". The Hebrew words "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("p")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏûyê, happ")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏûyîm")]), _vm._v(" (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("51")]), _vm._v("), and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("happiḏyôm")]), _vm._v(" (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("49")]), _vm._v(") are derivatives of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pāḏâ")]), _vm._v(", the basic meaning of which is to transfer ownership of someone or something to another.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0218",
      "id": "FN.94.0218r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ All contain the idea of ransoming. In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 3")]), _vm._v(" the ransom price is a life for a life: the Levites for the firstborn male Israelites.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.94.0219",
      "id": "FN.94.0219r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ Thus the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("kese")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("happiḏyôm")]), _vm._v(" (lit., “the silver of the ransom”) is the “ransom price” (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("49")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.95"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("47")])]), _vm._v(" Each of these firstborn males is ransomed, not at the cost of a life, but for "), _c('i', [_vm._v("five shekels")]), _vm._v(" of silver. This five-shekel redemption price, according to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27:6")]), _vm._v(", is the price of redemption for a male from one month to five years of age. The regulation of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("18:15–16")]), _vm._v(" establishes the principle that each firstborn is to be redeemed at the age of one month (as is appropriate for the five-shekel price).")]), _vm._v(" "), _c('p', [_vm._v("It is not certain what is intended by the "), _c('i', [_vm._v("shekel of the sanctuary")]), _vm._v(". Although the term "), _c('i', [_vm._v("shekel")]), _vm._v(" was a common unit of weight all across the ancient Near East, its actual value differed from place to place and time to time.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.95.0220",
      "id": "FN.95.0220r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ Scholars usually assume that the sanctuary shekel was different in some way from other shekels.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.95.0221",
      "id": "FN.95.0221r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ All that can be said with certainty is that the shekel here was measured on the standard then current and in force at the sanctuary. This standard is listed as "), _c('i', [_vm._v("twenty gerahs")]), _vm._v(" to the shekel. A gerah is usually thought to have weighed about half a gram, so that a twenty-gerah shekel would weigh about 0.4 oz.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("48")])]), _vm._v(" At the time of this first redemption, the reader is not informed which 273 had to pay the price or how it was collected. The collected silver, like the Levites for which it was to be a substitute, belonged to the priests. Wenham may well be right in concluding that the valuations of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27:2–8")]), _vm._v(" and the current passage come from the average price that a slave would bring on the ancient Near Eastern market.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.95.0222",
      "id": "FN.95.0222r"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("This chapter shows, first, that the Levites were set aside by God for divine and priestly use. The Levites aid the priests by standing guard over various items connected with the tabernacle while the camp is on the march, and by guarding the gate of the holy shrine when the camp is set up. The Levites also have physical work (as yet undesignated) that is connected with the tabernacle service. The Levites belong to God as replacements for the firstborn males of Israel. Once the number of the Levites became known through a census, the number of firstborn males could also be calculated. When it was found that there were 273 more firstborn males than Levites, a five-shekel ransom price was set for each one. Thus God’s holiness is insulated from the people and the people are insulated by the Levites from the fatal holiness of God. The Levites keep watch over both the priests and the people to make sure that no unauthorized person encroaches upon the sanctuary and the holy things in it.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.96"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("49–51")])]), _vm._v(" These verses form the conclusion to the present unit. "), _c('i', [_vm._v("Silver of the ransom")]), _vm._v("—see the note on the translation above. "), _c('i', [_vm._v("1,365 shekels")]), _vm._v("—this figure is obtained by multiplying the number of unredeemed and unreplaced Levites (273) by the five-shekel ransom price for each. V. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("51")]), _vm._v(" is a conclusion which, once again, states that all was done exactly as Yahweh had commanded Moses (see also "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1:54")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:33–34")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:42")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "NUM.I.A.1.C.3"
    }
  }, [_vm._v("(3) Census of Working Levites ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:1–49")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _c('i', [_vm._v("And Yahweh spoke to Moses and to Aaron, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("“Calculate the total of the sons of Kohath from the midst of the children of Levi, by their clans, by their fathers’ houses,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("from the age of thirty years to the age of fifty years, all who are qualified to go to the service, to do work in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("This is the work of the sons of Kohath in the tent of meeting: the holiest things.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("When the encampment is to move, Aaron and his sons will go in and take down the veil of the screen, and cover the ark of the testimony in it,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("and they shall put over it a covering of porpoise skin,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.96.0223",
      "id": "FN.96.0223r"
    }
  }, [_vm._v("1")]), _vm._v("﻿ and spread out over it a wrapping entirely of blue-violet, and put its poles in place.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("And over the table of the Presence they will spread out a blueviolet covering, and put upon it the dishes, the spoons,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.96.0224",
      "id": "FN.96.0224r"
    }
  }, [_vm._v("2")]), _vm._v("﻿ the sacrificial bowls,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.96.0225",
      "id": "FN.96.0225r"
    }
  }, [_vm._v("3")]), _vm._v("﻿ and the jars﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.96.0226",
      "id": "FN.96.0226r"
    }
  }, [_vm._v("4")]), _vm._v("﻿ for the drink offering. The continual bread will also be upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.97"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("And they will spread out over them a wrapping of scarlet, and cover it in a covering of porpoise skin, and put its poles in place.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("And they will take a wrapping of blue-violet and cover the lampstand of the light, and its lamps, and its tongs,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0227",
      "id": "FN.97.0227r"
    }
  }, [_vm._v("5")]), _vm._v("﻿ and its trays,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0228",
      "id": "FN.97.0228r"
    }
  }, [_vm._v("6")]), _vm._v("﻿ and all its oil vessels with which they service it.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("And they will put it and all its accessories into a covering of porpoise skin, and put it on the carrying frame.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And upon the altar of gold they will spread out a wrapping of blue-violet, and cover it in a covering of porpoise skin, and put its poles in place.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("And they will take all the accessories of service with which they serve in the sanctuary, and put them into a wrapping of blue-violet, and cover them in a covering of porpoise skin, and put them on the carrying frame.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("And they will take away the ashes from the altar, and spread out over it a wrapping of purple.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("And they will put on it all its accessories with which they service it, namely, the trays, the implements,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0229",
      "id": "FN.97.0229r"
    }
  }, [_vm._v("7")]), _vm._v("﻿ the shovels,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0230",
      "id": "FN.97.0230r"
    }
  }, [_vm._v("8")]), _vm._v("﻿ the basins,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0231",
      "id": "FN.97.0231r"
    }
  }, [_vm._v("9")]), _vm._v("﻿ that is, all the accessories of the altar, and they will spread out over them a covering of porpoise skin, and put its poles in place.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("When Aaron and his sons have finished covering the sanctuary and the accessories of the sanctuary, when the camp is ready to move and after this is done,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.97.0232",
      "id": "FN.97.0232r"
    }
  }, [_vm._v("10")]), _vm._v("﻿ the sons of Kohath may come to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.98"
    }
  }), _vm._v("carry these things, but they must not touch that which is holy or they will die. These things are the burden of the sons of Kohath in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("That which is the oversight of Eleazar the son of Aaron the priest is: the oil for the light, the sweet incense,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.98.0233",
      "id": "FN.98.0233r"
    }
  }, [_vm._v("11")]), _vm._v("﻿ the regular meal offering, and the oil for anointing; also the oversight of all the tabernacle and everything that is in it, that is, the holy place and its accessories.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("And Yahweh spoke to Moses and to Aaron, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("“You shall not cut off the tribe of the clans of the Kohathites from the midst of the Levites,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("but do this for them that they might live and not die when they make contact with﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.98.0234",
      "id": "FN.98.0234r"
    }
  }, [_vm._v("12")]), _vm._v("﻿ the holy things. Aaron and his sons will go in and set them, each one, to his work and to his carrying.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("But they must not enter to see the holy things even for an instant or they will die.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("And Yahweh spoke to Moses, saying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("“Calculate the total of the sons of Gershon, as well, by their fathers’ houses, by their clans.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("You shall number them from the age of thirty years up to the age of fifty years, all those who are qualified to go to do service, to do work in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("This is the work of the Gershonites, as relates to packing and carrying:")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("They will carry the curtains of the tabernacle, and the tent of meeting, its covering, and the covering of porpoise skin that is over the top of it, and the screen of the door to the tent of meeting,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("also the hangings of the court, the screen for the door of the gate of the court that is around the tabernacle and around the altar, their cords, and all the accessories for transporting them. And all that is done for them, they shall do.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("All the work of the sons of the Gershonites will be at the command "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.99"
    }
  }), _vm._v("of Aaron and his sons, as regards all their carrying and all their packing. And you shall appoint them as a guard for all that they are to carry.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("This is the work of the clans of the sons of the Gershonites in the tent of meeting. And their guard duty is to be under the authority of Ithamar, the son of Aaron the priest.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("As for the sons of Merari, by their clans, by their fathers’ houses, you shall number them,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("from thirty years of age up to fifty years of age you shall number them, all who are qualified to go to the service to do the work of the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("This is their guard burden, as regards their packing work in the tent of meeting: the boards of the tabernacle, its crosspieces, its pillars, and its sockets,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("32")]), _vm._v("also the pillars surrounding the court, their sockets, their tent pegs, their cords, and all their accessories for all their work. And you shall specify all the items by name that are their charge to carry.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("33")]), _vm._v("This is the work of the clans of the sons of Merari, as regards all their work in the tent of meeting. They are under the authority of Ithamar, the son of Aaron the priest.”")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("34")]), _vm._v("So Moses and Aaron and the leaders of the congregation numbered the sons of Kohath by their clans and by their fathers’ houses,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("35")]), _vm._v("from the age of thirty years up to the age of fifty years, everyone who was eligible to go to the service, for work in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("36")]), _vm._v("And those numbered, by their clans, were 2,750.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("37")]), _vm._v("These are those numbered of the clans of the Kohathites, all who would work in the tent of meeting, whom Moses and Aaron numbered according to the commandment of Yahweh by the agency of Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("38")]), _vm._v("And those numbered of the sons of Gershon, by their clans and by their fathers’ houses,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("39")]), _vm._v("from the age of thirty years up to the age of fifty years, everyone who was eligible to go to the service, for work in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("40")]), _vm._v("And those numbered, by their clans, were 2,630.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("41")]), _vm._v("These are those numbered of the clans of the sons of Gershon, all who would do work in the tent of meeting, whom Moses and Aaron numbered according to the commandment of Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("42")]), _vm._v("And those numbered of the clans of the sons of Merari, by their clans, by their fathers’ houses,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.100"
    }
  }), _c('span', {
    staticClass: "ver"
  }, [_vm._v("43")]), _vm._v("from the age of thirty years up to the age of fifty years, everyone who could go to the service, for work in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("44")]), _vm._v("And those numbered, by their clans, were 3,200.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("45")]), _vm._v("These are those numbered of the clans of the sons of Merari, whom Moses and Aaron numbered according to the commandment of Yahweh by the agency of Moses.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("46")]), _vm._v("All those numbered of the Levites, whom Moses and Aaron and the leaders of Israel numbered, by their clans, and by their fathers’ houses,")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("47")]), _vm._v("from the age of thirty years up to the age of fifty years, everyone who was eligible to go to do the work of packing and the work of bearing burdens in the tent of meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("48")]), _vm._v("And those numbered were 8,580.")]), _vm._v(" "), _c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("49")]), _vm._v("According to the commandment of Yahweh by the agency of Moses he numbered them, each one to his labor or his burden. And they were appointed just as Yahweh had commanded Moses.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Several points about this census record have already been made in connection with the last chapter, but a further general comment is in order. Although it has not been the normal custom in English Bible translation to do so, the interpreter should be careful to define just what it is that the Levites are charged to do here. In ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" the most common duty was “guard duty” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v("). Here three other words come into play: work in the sense of “skilled labor” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("m")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lāḵâ")]), _vm._v("), work in the sense of “physical work” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(" or the verbal form "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘āḇaḏ")]), _vm._v("), and a general term for service or “ministry” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šērēṯ")]), _vm._v(") in which the Levites assist the priests.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.100.0235",
      "id": "FN.100.0235r"
    }
  }, [_vm._v("13")]), _vm._v("﻿ The following chart shows the distribution of these words:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Guard Duty")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Ministry")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Physical Work")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("Skilled Work")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:7")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:6")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:7")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("3:—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:27")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:12")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("4:3")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("47")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("49")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.101"
    }
  }), _vm._v("Of course, specific meanings of these words will depend upon individual contexts, but the general meanings hold. This chart shows that one major purpose of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" is to detail the physical work for each of the Levitical clans involved in the dismantling, carrying, and reassembling of the tabernacle. The purpose of ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" was to discuss the guard duty the Levites were to exercise around the tabernacle. This explains why ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" limits the age range from 30 to 50 years (adults at the peak of physical power), whereas ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(" allows guard duty to be carried out by most any age group, including, at least theoretically, those only one month old.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.101.0236",
      "id": "FN.101.0236r"
    }
  }, [_vm._v("14")]), _vm._v(" In the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.102"
    }
  }), _vm._v("case of the very young Levites, this guard duty would only be potential. It is ipossible that older children were thought of as in-training for their actual guard-duty, which would come later.")]), _vm._v(" "), _c('p', [_vm._v("The order of the Levitical clans differs here from ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3")]), _vm._v(". The reason for the difference is not hard to find. Kohath, who had charge of the holy things, is first, followed by the one who has the next most important task, etc. The census is not introduced as a whole, but only by the clans. The introduction of each of the clans is basically the same (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–3")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21–23")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29–30")]), _vm._v("). This is followed by an outline of the work each clan was to do (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4–15")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("24–27")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31–32")]), _vm._v("). Next comes a statement as to which of Aaron’s sons had authority over the particular work (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("28")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("33")]), _vm._v("). The Kohathite section has a special note on the delicate nature of their work with the holy things (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–20")]), _vm._v("), which is naturally missing from the other sections. A group of totals follows the individual lists of clan responsibilities (vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34–49")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–4")])]), _vm._v(" After setting forth the introductory qualifications in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("1–3")]), _vm._v(", the Kohathites are given the task of "), _c('i', [_vm._v("the holiest things")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qōḏeš haqq")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḏāšîm")]), _vm._v(", v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v("). In fact, the physical work ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") of the Kohathites consists solely in carrying the holiest things, because the priests must prepare them for transit. That the Kohathites only carry the holiest things is shown by reference to the priests in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("15")]), _vm._v(" and the death penalty for even seeing the holy things in v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("20")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("5–15")])]), _vm._v(" These verses deal with the way in which Aaron and his sons (not the Kohathites) will pack up the holiest things. These things are to be prepared for transport in a certain order, beginning with the holiest place and moving outward to the court. The assumption is that the reader will be familiar with the contents of the tabernacle ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25–31")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35–40")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The first item to be taken down is the "), _c('i', [_vm._v("veil of the screen")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pārōḵeṯ hammāsāḵ")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.102.0237",
      "id": "FN.102.0237r"
    }
  }, [_vm._v("15")]), _vm._v("﻿ This is also called “the veil” (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:31")]), _vm._v("), “the veil of the testimony” (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 24:3")]), _vm._v("), “the veil before the testimony” ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 27:21")]), _vm._v(", because of its proximity to the ark of the testimony/covenant), or “the veil of the sanctuary” ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 4:6")]), _vm._v("). It is different from the “screen” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammāsāḵ")]), _vm._v(") that was the door of the tabernacle (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:36")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("In this three-colored cloth the most holy thing, "), _c('i', [_vm._v("the ark of the testimony")]), _vm._v(", was wrapped.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.102.0238",
      "id": "FN.102.0238r"
    }
  }, [_vm._v("16")]), _vm._v("﻿ According to "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:10–15")]), _vm._v(" this box was to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.103"
    }
  }), _vm._v("be made of acacia wood and be 2.5 cubits long by 1.5 cubits wide and 1.5 cubits high (about 44 by 26 by 26 in.). It was to be covered in gold inside and out, and to be furnished with a gold molding around it and four gold rings in its feet so that two gold-covered acacia wood carrying "), _c('i', [_vm._v("poles")]), _vm._v(" could be inserted. On the ark was the golden mercy seat from which Yahweh spoke to Moses and Israel (e.g., "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:22")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 7:89")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The ark and the veil were wrapped in a sheath of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ôr taḥaš")]), _vm._v(", here translated "), _c('i', [_vm._v("porpoise skin")]), _vm._v(" (see "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.81"
    }
  }, [_vm._v("NEB")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.87"
    }
  }, [_vm._v("NIV")]), _vm._v("; see also note on translation). The bottle-nosed dolphin is found in the eastern Mediterranean, while the dugong (another kind of dolphin) is plentiful in the Red Sea and Gulf of Aqaba. Modern bedouin women use the skin of the dugong to make sandals. A related word for women’s sandals occurs in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Ezek. 16:10")]), _vm._v(". This skin would conceivably have been available in the locality, and it would be waterproof and tough.")]), _vm._v(" "), _c('p', [_vm._v("The word here translated "), _c('i', [_vm._v("blue-violet")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("t")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḵēleṯ")]), _vm._v(") is translated “blue” by most modern English versions.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.103.0239",
      "id": "FN.103.0239r"
    }
  }, [_vm._v("17")]), _vm._v("﻿ According to A. Brenner, this term and "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ārgāmān")]), _vm._v(" (“red-purple”) are variant shades of purple.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.103.0240",
      "id": "FN.103.0240r"
    }
  }, [_vm._v("18")]), _vm._v("﻿ The ark is wrapped in the veil and the sheath of porpoise skin and blue-violet cloth. This procedure is reversed for the other objects (i.e., the porpoise skin is on the outside; see vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("10")]), _vm._v(", etc.). This clearly sets the ark apart from all the other items to be carried.")]), _vm._v(" "), _c('p', [_vm._v("Outside the veil of the most holy place, on the north side of the tabernacle, stood the "), _c('i', [_vm._v("table of the Presence")]), _vm._v(".﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.103.0241",
      "id": "FN.103.0241r"
    }
  }, [_vm._v("19")]), _vm._v("﻿ The top of this table was about 3 ft. square, and the table itself was about 2 ft. high. It was covered with gold and had four gold rings attached to its legs. Through these rings were inserted the gold-covered acacia wood "), _c('i', [_vm._v("poles")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("baddîm")]), _vm._v(") upon which "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.104"
    }
  }), _vm._v("the table was carried (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:13–15")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("35:12")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("37:4–5")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("39:35")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("40:20")]), _vm._v("). The various utensils on the table are noted in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:29")]), _vm._v(" and "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("37:16")]), _vm._v(". The order here is according to the latter verse. These utensils are "), _c('i', [_vm._v("the dishes")]), _vm._v(" or plates ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("q")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ārōṯ")]), _vm._v("), which were presumably for the continual bread (see below); the "), _c('i', [_vm._v("spoons")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hakkappōṯ")]), _vm._v("), the sacrificial bowls ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hamm")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("naqqîyōṯ")]), _vm._v("), and the "), _c('i', [_vm._v("jars for the drink offering")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("q")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("śôṯ hannāseḵ")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The term "), _c('i', [_vm._v("continual bread")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("leḥem haṭṭāmîḏ")]), _vm._v(") is unique, but the meaning is clear enough from "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:30")]), _vm._v(", where the original legislation is given. There the bread is called “the bread of the Presence that is always before me” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("leḥem pānîm l")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "iu"
  }, [_vm._v("p")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ānay tāmîḏ")]), _vm._v("). Thus, this bread is always to be on the table in Yahweh’s presence. The directions for its preparation are given in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 24:5–9")]), _vm._v(". Twelve loaves, perhaps representing the twelve tribes of Israel, were set in two rows. The bread was replaced each Sabbath. The old loaves were eaten by the priests.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.104.0242",
      "id": "FN.104.0242r"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_vm._v("The table, which had previously been wrapped in blue, with all its contents on it, is now wrapped in a scarlet cloth ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("beḡeḏ tôla‘aṯ šānî")]), _vm._v(").﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.104.0243",
      "id": "FN.104.0243r"
    }
  }, [_vm._v("21")]), _vm._v("﻿ Thus, as the only item wrapped in scarlet, the table of the Presence is also clearly marked.")]), _vm._v(" "), _c('p', [_vm._v("Next a blue cloth is put over the seven-branched menorah and all its accessories. This golden lampstand is called "), _c('i', [_vm._v("the lampstand of the light")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("m")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nōraṯ hammā’ôr")]), _vm._v(") here and in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 35:14")]), _vm._v(". "), _c('i', [_vm._v("its lamps")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nērōṯeyhā")]), _vm._v(") refers to each individual light on the lampstand. The pattern for the menorah is given in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:31–40")]), _vm._v(". It is located opposite the table of the bread on the south side of the structure outside the most holy place. The accessories named are "), _c('i', [_vm._v("tongs")]), _vm._v(" (or “snuffers,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("malqāḥayim")]), _vm._v("), "), _c('i', [_vm._v("trays")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maḥtôṯ")]), _vm._v("), and "), _c('i', [_vm._v("oil vessels")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("k")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("lê šemen")]), _vm._v("). The lamp and accessories will be wrapped in an outer covering of porpoise hide and put on the "), _c('i', [_vm._v("carrying frame")]), _vm._v(" (or “pole,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammôṭ")]), _vm._v("). This last-named article is to be distinguished from the gold-covered acacia wood poles that were inserted into the golden carrying rings in the ark and the table. The menorah and accessories had no such provisions for carrying so that they had to be transported on this carrying pole. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 13:23")]), _vm._v(" uses this same word to describe the pole carried by two men upon which was suspended a huge cluster of grapes from the Valley of Eshcol in Canaan.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.104.0244",
      "id": "FN.104.0244r"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.105"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–12")])]), _vm._v(" Among the holy things are two more items of furniture, and both are altars. These verses speak of the "), _c('i', [_vm._v("altar of gold")]), _vm._v(" that stands in front of the veil outside the most holy place, also called the altar of incense.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.105.0245",
      "id": "FN.105.0245r"
    }
  }, [_vm._v("23")]), _vm._v("﻿ The golden altar was wrapped in porpoise hide and its poles inserted. Next, all the accessories for it were placed in porpoise hide, and, since they had no provision for being carried on poles, they were placed on a "), _c('i', [_vm._v("carrying frame")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("môṭ")]), _vm._v("), as was the menorah.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("13–14")])]), _vm._v(" These verses discuss the other altar that stood in the court of the tabernacle along with its accessories.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.105.0246",
      "id": "FN.105.0246r"
    }
  }, [_vm._v("24")]), _vm._v("﻿ After taking away the ashes of the whole burnt offerings from this altar, the priests were to spread over it a wrapping of purple cloth.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.105.0247",
      "id": "FN.105.0247r"
    }
  }, [_vm._v("25")]), _vm._v("﻿ The accessories of the altar of whole burnt offerings were the "), _c('i', [_vm._v("trays")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maḥtōṯ")]), _vm._v("), the "), _c('i', [_vm._v("implements")]), _vm._v(" (or “forks,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammizlāḡōṯ")]), _vm._v("), the "), _c('i', [_vm._v("shovels")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hayyā‘îm")]), _vm._v("), and the "), _c('i', [_vm._v("basins")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hammizrāqōṯ")]), _vm._v("). These accessories were placed on the altar of burnt offerings, the entire assemblage covered with porpoise hide, and the carrying poles slid into the bronze rings.")]), _vm._v(" "), _c('p', [_vm._v("Only after Aaron and his sons finished dismantling and covering all the holy things are the sons of Kohath permitted to enter to carry these things. They are allowed to touch the carrying poles but not the holy things themselves on pain of death. Again, the holiness of God’s sanctuary (which is the holiness of God himself) is not to be treated lightly.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("16")])]), _vm._v(" Eleazar, Aaron’s older surviving son, is given oversight of four holy things not previously mentioned as well as administrative oversight of the tabernacle and its furnishings as set out in the previous verses. It is possible that Eleazar himself was responsible for carrying the four holy things since all of them were holy and thus had to be handled only by a priest.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the oil for the light")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šemen hammā’ôr")]), _vm._v("). This oil was mentioned in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:6")]), _vm._v(" and put into the hands of the priests in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:20–21")]), _vm._v(". The latter text specified that Aaron and his sons would have charge of it.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.106"
    }
  }), _c('i', [_vm._v("the sweet incense")]), _vm._v(" (lit., “incense of spices,” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("q")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ṭōreṯ hassammîm")]), _vm._v(") was also mentioned in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 25:6")]), _vm._v(". The recipe is given in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:34–38")]), _vm._v(", which also makes plain that this incense is holy to Yahweh, and therefore only the priests are to handle it.")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the regular")]), _vm._v(" (or continual) "), _c('i', [_vm._v("meal offering")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("minḥaṯ hattāmîḏ")]), _vm._v(") is not mentioned elsewhere in the Pentateuch, although the meal or cereal offering ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("minḥâ")]), _vm._v(") of "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Lev. 6:7–10")]), _vm._v(" (Eng. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("14–17")]), _vm._v(") is probably the same offering. That offering is most holy and is to be offered and consumed only by priests.")]), _vm._v(" "), _c('p', [_vm._v("Finally, "), _c('i', [_vm._v("the oil for anointing")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("šemen hammišḥâ")]), _vm._v(") is discussed in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 30:22–33")]), _vm._v(". It is holy to Yahweh and must be handled by priests. Eleazar’s administrative oversight includes both the packing work of the priests and the carrying work of the Kohathites.")]), _vm._v(" "), _c('p', [_vm._v("A second-millennium-B"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v("C"), _c('span', {
    staticClass: "sm"
  }, [_vm._v(".")]), _vm._v(" Hittite document is similar in many ways to the texts regarding the work of the priests and Levites in the Pentateuch. In the Hittite document, as here, two classes of people watch over and tend the temple—a priestly class and a nonpriestly class of keepers. The latter group is under the watchcare of the priests. This kind of parallel in a nonbiblical text of pre-Mosaic times shows the possibility of such a thing in Israel.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.106.0248",
      "id": "FN.106.0248r"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("17–20")])]), _vm._v(" This section grows out of all that has been said in ch. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("4")]), _vm._v(" to this point. If all that has been legislated is true, then the danger to the Kohathites from accidental exposure to the holy things is great. These verses underline that danger and warn Moses, and especially Aaron, to take care in the packing and preparation of the holy things for transport. These items must be properly prepared before any Levite can be allowed even to catch a glimpse of them: "), _c('i', [_vm._v("even for an instant")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("k")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḇallaʿ")]), _vm._v("), describing the slightest glimpse of the holy things, is literally “as a swallowing,” i.e., even the time it takes to swallow.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.106.0249",
      "id": "FN.106.0249r"
    }
  }, [_vm._v("27")]), _vm._v("﻿ For the Levite any exposure, no matter how slight, to the holy things brings death. The priests are to make sure that their work is well done so that lethal contact for the Levites is eliminated. This warning is given only to the Kohathites, since the other clans do not risk contact with the holy things in the same way.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.107"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("21–28")])]), _vm._v(" The duties of the Gershonites concern the cloth, fabric, and skin items that cover and enclose the tabernacle structure. Three words are used in connection with their tasks. The first is "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(", which, in this case, describes the physical work of dismantling the curtains, etc., loading them on wagons, and reassembling them in due course. One month earlier the Gershonites had been given two wagons and four oxen to carry their burdens (see "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 7:1–11")]), _vm._v("). The second word, here translated as "), _c('i', [_vm._v("carrying")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maśśā’")]), _vm._v("), is literally “a burden.”﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.107.0250",
      "id": "FN.107.0250r"
    }
  }, [_vm._v("28")]), _vm._v("﻿ The third word is "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(", which, once again, means "), _c('i', [_vm._v("guard duty")]), _vm._v(", and indicates that the Gershonites were responsible for watching over these curtains, etc., as these things traveled on the wagons (as has already been set out in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:25–26")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The list of items to be packed and loaded by the Gershonites is found in more or less the same order in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:25–26")]), _vm._v(". This is also the same order as found in the first commands regarding these things in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26–27")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("the curtains of the tabernacle and the tent of meeting")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’eṯ–y")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rî‘ōṯ hammišḵān w")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’eṯ–’ōhel mô‘ēḏ")]), _vm._v("). The original command for these is found in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:1–14")]), _vm._v(". The two coverings for the tent are set out in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("26:14")]), _vm._v(". The first covering was to be of “tanned ram’s skin” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicot04nu0007#ABBR.86"
    }
  }, [_vm._v("RSV")]), _vm._v(") ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ōrōṯ ’êlim m")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ādāmîm")]), _vm._v("), and the second was to be of “porpoise skin” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ōrōṯ t")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ḥašîm")]), _vm._v("). Next came the "), _c('i', [_vm._v("screen")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("māsaḵ")]), _vm._v(") of the holy place ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:36–37")]), _vm._v("). The "), _c('i', [_vm._v("hangings of the court")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qal‘ê heḥāṣer")]), _vm._v(") were to be 100 cubits long (approximately 146 ft.) on the north and south sides of the tabernacle, and 50 cubits long (approximately 73 ft.) on the west ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:9")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("11–12")]), _vm._v("). On the east side the hangings were in two parts, each 15 cubits long (approximately 22 ft.; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:14–15")]), _vm._v("), with "), _c('i', [_vm._v("the screen for the door of the gate of the court")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("māsaḵ peṯaḥ ša‘ar heḥāṣēr")]), _vm._v(") (i.e., the whole structure) made of blue, purple, and scarlet embroidered linen covering the gap of 20 cubits (approximately 29 ft.) between the hangings ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:16")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("After the holy things have been removed from the tabernacle, the next logical step was the the removal of the coverings, thus exposing the framework. This led on to the work of the Merarites, which follows in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29–33")]), _vm._v(". The work of both the Gershonites and the Merarites was to be done under the supervision and authority of Ithamar, Aaron’s younger surviving son.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("29–33")])]), _vm._v(" After the standard introduction of the Merarites in vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("29–30")]), _vm._v(", their work is set forth, but in an unusual way. The text uses all three "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.108"
    }
  }), _vm._v("terms for work (discussed above: "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(", "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("maśśā’")]), _vm._v(", "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ăḇōḏâ")]), _vm._v(") in the same sentence (v. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("31")]), _vm._v("). The guard duty of the Merarites is the same as their "), _c('i', [_vm._v("burden")]), _vm._v(" and their "), _c('i', [_vm._v("packing work")]), _vm._v(". In general this task involves the framework of the tabernacle and the court. These materials have already been assigned to the Merarites in "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("3:36–37")]), _vm._v(" as their "), _c('i', [_vm._v("guard duty")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mišmereṯ")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("Briefly, their work consisted in packing, guarding, and unpacking the following: "), _c('i', [_vm._v("the boards of the tabernacle")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qaršê hammiškān")]), _vm._v("). These were 48 in number (20 on the north-south sides and 8 on the west side), each measuring about 14 ft. long and 2 ft. wide, and made of gold-covered acacia wood ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:15–25")]), _vm._v("). Each board had gold rings in it ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:19")]), _vm._v(") through which were inserted gold-covered acacia wood "), _c('i', [_vm._v("crosspieces")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("b")]), _c('sup', {
    staticClass: "i"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("rîaḥ")]), _vm._v("). There were five of these on the north, south, and west sides of the tabernacle. The center crosspiece ran from end to end while the other four were broken in the middle ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:26–29")]), _vm._v("). At the bottom of each board were two tenons or projections (lit., “hands”) that fitted into silver "), _c('i', [_vm._v("sockets")]), _vm._v(" or “bases” ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’ăḏānîm")]), _vm._v("), each made of one talent of silver ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:19")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("21")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("25")]), _vm._v("; "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38:27")]), _vm._v("). Four "), _c('i', [_vm._v("pillars")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ammîḏîm")]), _vm._v(") of gold-covered acacia wood, each in a silver socket, divided the holy place from the most holy place ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 26:32–33")]), _vm._v("). The outer court also had pillars ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("‘ammûḏê heḥāṣer")]), _vm._v("), 60 in number (20 on the long sides, 10 on the short), each one resting in a bronze "), _c('i', [_vm._v("socket")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("’eḏen")]), _vm._v(", "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:9–19")]), _vm._v("). Bronze "), _c('i', [_vm._v("pegs")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("yaṯēḏôṯ")]), _vm._v(") held the pillars in place ("), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Exod. 27:19")]), _vm._v("), and "), _c('i', [_vm._v("cords")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mêṯrîm")]), _vm._v(") were used in erecting and securing the tabernacle and its court. Also mentioned are the "), _c('i', [_vm._v("accessories")]), _vm._v(" ("), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("kēlîm")]), _vm._v(") (possibly the tools) necessary for performing their labors.")]), _vm._v(" "), _c('p', [_vm._v("Ithamar the priest is to oversee each item the Merarites are to load and unload. In "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("Num. 7:1–11")]), _vm._v(", which relates events that had taken place one month before the current text,﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.108.0251",
      "id": "FN.108.0251r"
    }
  }, [_vm._v("29")]), _vm._v("﻿ four wagons and eight oxen were given to the Merarites to transport these materials. Their work consisted in dismantling the framework, etc., packing it on the carts, guarding it on the journey, and reassembling it upon arrival at the destination.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('span', {
    staticClass: "xbr"
  }, [_vm._v("34–49")])]), _vm._v(" These verses finally give the census figures for the Levites from age 30 to 50. The clans are dealt with in the same order in which they have already been named (Kohath, vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("34–37")]), _vm._v("; Gershon, vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("38–41")]), _vm._v("; Merari, vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("42–45")]), _vm._v("; grand totals, vv. "), _c('span', {
    staticClass: "xbr"
  }, [_vm._v("46–49")]), _vm._v("). The numbers are: Kohath, 2,750; Gershon, 2,630; Merari, 3,200. This gives a grand total of 8,530 Levites between 30 and 50 years of age.﻿"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicot04nu0026#FN.108.0252",
      "id": "FN.108.0252r"
    }
  }, [_vm._v("30")])])])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467422932',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(157)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(159);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 159 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.f02b1e080874abd77fcd.js